var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroIllustrationMin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 438,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "figure",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.762 215.535c12.064 34.65-35.438 83.82-71.63 119.79-36.192 35.64-61.074 58.41-125.918 78.87-64.844 20.46-170.404 38.61-209.612.99-39.208-37.29-12.064-130.02 40.716-185.13 52.78-55.11 130.819-72.6 206.219-70.95 75.4 1.32 147.784 21.78 160.225 56.43z",
    fill: "#F2F4F8",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209 410.075c111.748 0 202.337-52.3 202.337-116.815 0-64.514-90.589-116.814-202.337-116.814-111.748 0-202.337 52.3-202.337 116.814 0 64.515 90.59 116.815 202.337 116.815z",
    fill: "#E1EDF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m107.066 346.38 100.12 57.834a9.238 9.238 0 0 0 8.36 0l152.988-88.315c2.316-1.337 2.316-3.503 0-4.84l-100.12-57.835a9.303 9.303 0 0 0-8.36 0l-152.988 88.324c-2.307 1.329-2.307 3.494 0 4.832zM130.884 291.396l-51.138 29.511a4.945 4.945 0 0 1-4.44 0l-51.062-29.502c-1.229-.711-1.229-1.856 0-2.567l51.138-29.502a4.88 4.88 0 0 1 4.44 0l51.07 29.502c1.196.702 1.196 1.856-.008 2.558zM216.95 241.746l-51.832 29.887a4.95 4.95 0 0 1-4.497 0l-51.732-29.879c-1.237-.718-1.237-1.881 0-2.599l51.832-29.887a4.953 4.953 0 0 1 4.498 0l51.731 29.887c1.246.718 1.246 1.881 0 2.591z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m274.793 261.668-5.375-3.11s-3.194-13.276-1.923-25.23c1.797-16.796 12.858-23.124 17.063-21.67 4.205 1.455 5.417 6.337-1.538 16.344-4.105 5.911-9.146 18.208-8.227 33.666z",
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m274.793 261.668-5.375-3.11s-3.194-13.276-1.923-25.23c1.797-16.796 12.858-23.124 17.063-21.67 4.205 1.455 5.417 6.337-1.538 16.344-4.105 5.911-9.146 18.208-8.227 33.666z",
    fill: "#fff",
    opacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.536 255.147h.05a.369.369 0 0 0 .293-.435c-2.943-15.491 2.508-32.904 9.196-40.128a.375.375 0 0 0-.264-.637.364.364 0 0 0-.263.111c-6.822 7.373-12.348 25.08-9.355 40.797a.368.368 0 0 0 .343.292z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289.097 270.103c.836.41 2.943-1.421 3.537-1.864a7.442 7.442 0 0 0 2.332-2.968 6.92 6.92 0 0 0 .401-4.18 17.107 17.107 0 0 0-.635-2.207c-.242-.71-.493-1.413-.736-2.123a5.61 5.61 0 0 1-.426-2.166c.117-1.488 1.379-2.591 2.508-3.544 1.129-.953 2.575-2.425 2.508-4.18a6.316 6.316 0 0 0-1.756-3.654c-.911-1.028-1.964-1.931-2.792-3.034a4.368 4.368 0 0 1-1.037-2.717 4.53 4.53 0 0 1 .519-1.756 24.858 24.858 0 0 0 1.714-3.561 3.49 3.49 0 0 0-.786-3.653 4.067 4.067 0 0 0-3.102-.611 7.118 7.118 0 0 0-2.8 1.146c-2.742 1.713-4.18 5.141-7.123 6.504-1.172.432-2.37.789-3.587 1.07a4.444 4.444 0 0 0-2.884 2.198c-.995 2.258 1.187 4.858.527 7.232-.577 2.098-2.508 2.993-3.578 4.907a4.457 4.457 0 0 0-.393 2.734c.178 1.573.642 3.1 1.371 4.506a40.239 40.239 0 0 0 2.717 4.18l13.501 7.741z",
    fill: "url(#b)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M289.097 270.103c.836.41 2.943-1.421 3.537-1.864a7.442 7.442 0 0 0 2.332-2.968 6.92 6.92 0 0 0 .401-4.18 17.107 17.107 0 0 0-.635-2.207c-.242-.71-.493-1.413-.736-2.123a5.61 5.61 0 0 1-.426-2.166c.117-1.488 1.379-2.591 2.508-3.544 1.129-.953 2.575-2.425 2.508-4.18a6.316 6.316 0 0 0-1.756-3.654c-.911-1.028-1.964-1.931-2.792-3.034a4.368 4.368 0 0 1-1.037-2.717 4.53 4.53 0 0 1 .519-1.756 24.858 24.858 0 0 0 1.714-3.561 3.49 3.49 0 0 0-.786-3.653 4.067 4.067 0 0 0-3.102-.611 7.118 7.118 0 0 0-2.8 1.146c-2.742 1.713-4.18 5.141-7.123 6.504-1.172.432-2.37.789-3.587 1.07a4.444 4.444 0 0 0-2.884 2.198c-.995 2.258 1.187 4.858.527 7.232-.577 2.098-2.508 2.993-3.578 4.907a4.457 4.457 0 0 0-.393 2.734c.178 1.573.642 3.1 1.371 4.506a40.239 40.239 0 0 0 2.717 4.18l13.501 7.741z",
    fill: "#fff",
    opacity: 0.55
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M281.331 266.049a.362.362 0 0 0 .326-.385c-1.287-13.936 4.515-29.686 9.071-34.41a.358.358 0 0 0 .101-.249.37.37 0 0 0-.028-.135.352.352 0 0 0-.575-.109c-4.656 4.815-10.575 20.833-9.271 34.97a.351.351 0 0 0 .376.318z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.71 248.86h.109a47.65 47.65 0 0 1 10.032-2.148.36.36 0 0 0 .239-.126.355.355 0 0 0 .065-.121c.014-.045.018-.091.014-.138a.344.344 0 0 0-.385-.317 48.46 48.46 0 0 0-10.216 2.173.346.346 0 0 0-.198.183.352.352 0 0 0-.011.269.33.33 0 0 0 .351.225z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m167.727 85.004 41.608 24.019c.405.263.743.618.985 1.037.243.418.384.888.411 1.37v126.379a3.07 3.07 0 0 1-.411 1.37c-.242.419-.58.774-.985 1.037l-45.002 25.983a3.091 3.091 0 0 1-2.784 0l-41.608-24.018a3.092 3.092 0 0 1-1.396-2.416v-126.37a3.085 3.085 0 0 1 1.396-2.408l45.002-25.983a3.035 3.035 0 0 1 2.784 0z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.553 113.395v126.37a3.088 3.088 0 0 0 1.388 2.416l41.608 24.018c.426.23.904.345 1.387.335v-129.58a2.888 2.888 0 0 1-1.387-.335l-41.608-24.018-.385-.318-.493-.409a2.854 2.854 0 0 0-.51 1.521z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m119.941 110.987 45.002-25.983a3.035 3.035 0 0 1 2.784 0l41.608 24.019a.83.83 0 0 1 .434.301.834.834 0 0 1-.434 1.304l-45.002 25.983a3.04 3.04 0 0 1-2.784 0l-41.608-24.019a.836.836 0 0 1 0-1.605z",
    fill: "#E1EDF8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.364 84.67c.484-.01.962.105 1.388.334l41.607 24.019a.83.83 0 0 1 .602.802.834.834 0 0 1-.602.803l-45.001 25.983a3.074 3.074 0 0 1-2.784 0l-41.608-24.019a.836.836 0 0 1 0-1.605l45.002-25.983c.428-.23.91-.345 1.396-.334zm0-.777a3.58 3.58 0 0 0-1.781.434l-45.035 26.025a1.628 1.628 0 0 0-.698.598 1.629 1.629 0 0 0 0 1.763c.17.263.413.47.698.598l41.608 24.019a3.872 3.872 0 0 0 3.561 0l45.01-25.983a1.618 1.618 0 0 0 .958-1.48 1.618 1.618 0 0 0-.958-1.48l-41.607-24.06a3.607 3.607 0 0 0-1.781-.434h.025zM156.416 139.144c-1.447-.836-2.617-.075-2.617 1.672v63.837a5.995 5.995 0 0 0 2.608 4.723c1.447.836 2.617.075 2.617-1.672v-63.837a5.995 5.995 0 0 0-2.608-4.723z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.407 207.855a3.002 3.002 0 0 1-1.304-2.366v-63.996c0-.895.585-1.271 1.313-.836a2.985 2.985 0 0 1 1.304 2.358v64.004c0 .869-.552 1.254-1.313.836z",
    fill: "#E0E0E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M156.407 207.855a3.002 3.002 0 0 1-1.304-2.366v-63.996c0-.895.585-1.271 1.313-.836a2.985 2.985 0 0 1 1.304 2.358v64.004c0 .869-.552 1.254-1.313.836z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.407 207.855a3.002 3.002 0 0 1-1.304-2.366v-31.267l2.617 1.505v31.275c0 .886-.552 1.271-1.313.853z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.574 134.596c-1.438-.836-2.608-.075-2.608 1.672v63.812a5.994 5.994 0 0 0 2.608 4.723c1.446.836 2.617.076 2.617-1.672v-63.787a5.971 5.971 0 0 0-2.617-4.748z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.574 203.332a2.995 2.995 0 0 1-1.304-2.366V136.97c0-.894.585-1.27 1.304-.836a2.957 2.957 0 0 1 1.312 2.358v63.987c0 .886-.585 1.271-1.312.853z",
    fill: "#E0E0E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.741 130.098c-1.438-.836-2.609-.075-2.609 1.672v63.854a5.987 5.987 0 0 0 2.609 4.723c1.446.836 2.616.076 2.616-1.672v-63.853a5.98 5.98 0 0 0-2.616-4.724z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.741 198.809a2.99 2.99 0 0 1-1.304-2.366v-63.996c0-.894.585-1.27 1.304-.836a2.958 2.958 0 0 1 1.312 2.358v64.004c-.008.87-.585 1.254-1.312.836z",
    fill: "#E0E0E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M140.741 198.809a2.99 2.99 0 0 1-1.304-2.366v-63.996c0-.894.585-1.27 1.304-.836a2.958 2.958 0 0 1 1.312 2.358v64.004c-.008.87-.585 1.254-1.312.836z",
    fill: "#000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M140.741 198.809a2.99 2.99 0 0 1-1.304-2.366V149.97l2.616 1.513v46.473c-.008.887-.585 1.271-1.312.853z",
    fill: "#E0E0E0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.924 125.576c-1.438-.836-2.608-.076-2.608 1.672v63.811a5.988 5.988 0 0 0 2.608 4.724c1.447.836 2.617.075 2.617-1.672v-63.812a5.976 5.976 0 0 0-2.617-4.723z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.924 194.286a2.99 2.99 0 0 1-1.304-2.365v-64.013c0-.895.585-1.271 1.304-.836a2.95 2.95 0 0 1 1.304 2.358v64.004c-.017.886-.602 1.27-1.304.852z",
    fill: "#E0E0E0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M132.924 194.286a2.99 2.99 0 0 1-1.304-2.365v-64.013c0-.895.585-1.271 1.304-.836a2.95 2.95 0 0 1 1.304 2.358v64.004c-.017.886-.602 1.27-1.304.852z",
    fill: "#000"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.924 194.286a2.99 2.99 0 0 1-1.304-2.365v-11.704l2.608 1.513v11.704c-.017.886-.602 1.27-1.304.852z",
    fill: "#E0E0E0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M125.074 121.053c-1.438-.836-2.608-.075-2.608 1.672v63.812a5.986 5.986 0 0 0 2.608 4.723c1.446.836 2.617.075 2.617-1.672v-63.812a5.976 5.976 0 0 0-2.617-4.723z",
    fill: "#F0F0F0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M125.074 189.772a2.997 2.997 0 0 1-1.304-2.366v-64.004c0-.895.585-1.271 1.304-.836.388.263.708.613.934 1.023.227.409.354.867.37 1.334v64.013c0 .836-.585 1.246-1.304.836z",
    fill: "#E0E0E0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M125.074 189.772a2.997 2.997 0 0 1-1.304-2.366v-64.004c0-.895.585-1.271 1.304-.836.388.263.708.613.934 1.023.227.409.354.867.37 1.334v64.013c0 .836-.585 1.246-1.304.836z",
    fill: "#000"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M125.074 189.772a2.997 2.997 0 0 1-1.304-2.366V153.13l2.608 1.505v34.276c0 .861-.585 1.271-1.304.861z",
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.201 242.323a1.346 1.346 0 0 1 .618 1.062c0 .393-.276.551-.618.359a1.384 1.384 0 0 1-.611-1.07c0-.393.318-.552.611-.351zM133.334 245.291a1.343 1.343 0 0 1 .618 1.061c0 .393-.276.552-.618.352a1.362 1.362 0 0 1-.611-1.062c0-.393.276-.552.611-.351zM138.383 248.2a1.362 1.362 0 0 1 .61 1.062c0 .393-.276.543-.61.351a1.325 1.325 0 0 1-.61-1.062c0-.384.267-.543.61-.351zM143.466 251.143a1.328 1.328 0 0 1 .61 1.053c0 .393-.267.544-.61.351a1.343 1.343 0 0 1-.602-1.053c0-.393.268-.544.602-.351z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M179.213 160.512a1.192 1.192 0 0 1-.635-.167 1.522 1.522 0 0 1-.686-1.413v-3.286a4.005 4.005 0 0 1 1.831-3.176l24.169-13.953a1.538 1.538 0 0 1 1.572-.109 1.522 1.522 0 0 1 .685 1.413v3.285a3.992 3.992 0 0 1-1.831 3.177l-24.168 13.953a1.928 1.928 0 0 1-.937.276zm25.08-21.268-24.143 13.911a3.17 3.17 0 0 0-1.413 2.45v3.285c0 .343.092.594.259.686a.76.76 0 0 0 .727-.109l24.169-13.953a3.168 3.168 0 0 0 1.413-2.449v-3.286c0-.343-.092-.593-.259-.685a.761.761 0 0 0-.728.108l-.025.042z",
    fill: "#E0E0E0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M203.984 141.627v1.588a.716.716 0 0 1-.326.56l-.368.218c-.176.1-.326 0-.326-.193v-1.588a.742.742 0 0 1 .326-.569l.368-.209c.209-.1.326-.016.326.193zM202.37 142.571v1.589a.722.722 0 0 1-.317.568l-.368.209c-.184.101-.326 0-.326-.192v-1.588a.692.692 0 0 1 .326-.56l.368-.218c.175-.1.317-.017.317.192zM200.732 143.516v1.589a.724.724 0 0 1-.326.568l-.36.209c-.184.1-.326 0-.326-.184v-1.597a.692.692 0 0 1 .326-.56l.36-.217c.184-.1.326-.017.326.192zM199.093 144.461v1.597a.716.716 0 0 1-.326.56l-.368.209c-.175.108-.326 0-.326-.184v-1.597a.72.72 0 0 1 .326-.56l.368-.209c.201-.109.326-.025.326.184z",
    fill: "#E1EDF8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M197.455 145.405v1.597a.726.726 0 0 1-.326.56l-.368.209c-.175.109-.326 0-.326-.184v-1.596a.729.729 0 0 1 .326-.56l.368-.209c.167-.109.326-.026.326.183zM195.808 146.35v1.622a.692.692 0 0 1-.326.56l-.36.209c-.183.109-.326 0-.326-.184v-1.597a.716.716 0 0 1 .326-.56l.36-.209c.184-.125.326-.041.326.159z",
    fill: "#E0E0E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M194.169 147.295v1.597a.698.698 0 0 1-.326.56l-.368.217c-.175.1-.317 0-.317-.192v-1.589a.73.73 0 0 1 .317-.568l.368-.209c.184-.1.326.025.326.184zM192.531 148.248v1.588a.755.755 0 0 1-.326.569l-.368.209c-.176.1-.326 0-.326-.193v-1.613a.732.732 0 0 1 .326-.568l.368-.209c.175-.059.326.008.326.217zM190.884 149.193v1.588a.722.722 0 0 1-.326.568l-.359.209c-.184.101-.326 0-.326-.183v-1.597a.686.686 0 0 1 .326-.56l.359-.218c.184-.1.326-.016.326.193z",
    fill: "#E1EDF8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M189.245 150.137v1.597a.701.701 0 0 1-.326.56l-.367.209c-.176.109-.318 0-.318-.184v-1.597a.704.704 0 0 1 .318-.56l.367-.209c.184-.108.326-.025.326.184z",
    fill: "#E0E0E0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M187.607 151.082v1.597a.736.736 0 0 1-.096.319.736.736 0 0 1-.23.241l-.368.209c-.176.108-.326 0-.326-.184v-1.597a.726.726 0 0 1 .326-.56l.368-.209c.175-.109.326-.025.326.184zM185.96 152.027v1.596a.71.71 0 0 1-.318.56l-.368.209c-.184.109-.326.001-.326-.183v-1.597a.716.716 0 0 1 .326-.56l.368-.209c.176-.101.318-.017.318.184z",
    fill: "#E1EDF8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184.321 152.988v1.597a.695.695 0 0 1-.326.56l-.359.217c-.184.101-.326 0-.326-.192v-1.588a.711.711 0 0 1 .326-.569l.359-.209c.184-.117.326-.033.326.184z",
    fill: "#E0E0E0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M182.683 153.924v1.572a.747.747 0 0 1-.327.568l-.367.209c-.176.101-.326 0-.326-.192v-1.588a.742.742 0 0 1 .326-.569l.367-.209c.176-.083.327 0 .327.209z",
    fill: "#E1EDF8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M181.044 154.869v1.588a.742.742 0 0 1-.326.569l-.368.209c-.175.1-.326 0-.326-.184v-1.555a.72.72 0 0 1 .326-.56l.368-.217c.176-.143.326-.059.326.15zM175.869 158.063l-.677-.393a.883.883 0 0 0-.903.092 2.817 2.817 0 0 0-1.279 2.223.905.905 0 0 0 .368.836l.627.36.117-.192c.129-.028.253-.076.368-.143a2.863 2.863 0 0 0 1.287-2.223 1.341 1.341 0 0 0 0-.335l.092-.225z",
    fill: "#E0E0E0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M174.933 158.138a2.826 2.826 0 0 0-1.279 2.224c0 .836.569 1.153 1.279.744a2.859 2.859 0 0 0 1.288-2.233c0-.819-.577-1.153-1.288-.735z",
    fill: "#E1EDF8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M174.933 158.138a2.826 2.826 0 0 0-1.279 2.224c0 .836.569 1.153 1.279.744a2.859 2.859 0 0 0 1.288-2.233c0-.819-.577-1.153-1.288-.735z",
    fill: "#E1EDF8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m170.293 161.281-.677-.393a.91.91 0 0 0-.903.092 2.838 2.838 0 0 0-1.287 2.224.9.9 0 0 0 .376.836l.635.359.109-.192c.13-.026.254-.074.368-.142a2.828 2.828 0 0 0 1.287-2.224c0-.113-.014-.225-.041-.334l.133-.226z",
    fill: "#E0E0E0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M169.357 161.348a2.839 2.839 0 0 0-1.288 2.224c0 .836.577 1.153 1.288.744a2.853 2.853 0 0 0 1.287-2.232c0-.811-.577-1.137-1.287-.736z",
    fill: "#E1EDF8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M169.357 161.348a2.839 2.839 0 0 0-1.288 2.224c0 .836.577 1.153 1.288.744a2.853 2.853 0 0 0 1.287-2.232c0-.811-.577-1.137-1.287-.736z",
    fill: "#E1EDF8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 185.993a1.067 1.067 0 0 1-.56-.142 1.39 1.39 0 0 1-.476-.544 1.39 1.39 0 0 1-.135-.71v-11.863a3.472 3.472 0 0 1 1.606-2.767l34.56-19.955a1.254 1.254 0 0 1 2.006 1.162v11.846a3.506 3.506 0 0 1-.463 1.577 3.5 3.5 0 0 1-1.134 1.19l-34.56 19.947c-.253.161-.545.25-.844.259zm35.396-35.271-34.56 19.956a2.65 2.65 0 0 0-1.187 2.056v11.863a.635.635 0 0 0 .2.544.608.608 0 0 0 .577-.101l34.56-19.947a2.667 2.667 0 0 0 1.179-2.056v-11.863a.614.614 0 0 0-.209-.552.645.645 0 0 0-.568.1h.008z",
    fill: "#E1EDF8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 155.596a2.982 2.982 0 0 1-1.388 2.308l-29.343 16.937c-.761.443-1.388.134-1.388-.702a2.99 2.99 0 0 1 1.388-2.308l29.343-16.937c.736-.443 1.388-.134 1.388.702z",
    fill: "#E1EDF8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 161.624a2.97 2.97 0 0 1-1.388 2.316l-29.343 16.937c-.761.443-1.388.125-1.388-.702a2.995 2.995 0 0 1 1.388-2.316l29.343-16.937c.736-.41 1.388-.126 1.388.702z",
    fill: "#E0E0E0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m201.727 160.922-12.456 7.189v3.01l12.456-7.181a2.98 2.98 0 0 0 1.388-2.316c.033-.828-.619-1.112-1.388-.702z",
    fill: "#E1EDF8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M179.213 190.967a1.258 1.258 0 0 1-.635-.158 1.557 1.557 0 0 1-.538-.617 1.562 1.562 0 0 1-.148-.805v-3.285a4 4 0 0 1 1.831-3.177l24.169-13.953a1.537 1.537 0 0 1 1.572-.108 1.522 1.522 0 0 1 .685 1.412v3.286a3.999 3.999 0 0 1-1.831 3.177l-24.168 13.953a1.916 1.916 0 0 1-.937.275zm25.08-21.267-24.168 13.952a3.16 3.16 0 0 0-1.413 2.45v3.285c0 .343.092.594.259.686a.759.759 0 0 0 .727-.109l24.169-13.953a3.168 3.168 0 0 0 1.413-2.449v-3.286c0-.342-.092-.593-.259-.685a.76.76 0 0 0-.728.109z",
    fill: "#E0E0E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M203.984 172.124v1.588a.716.716 0 0 1-.326.561l-.368.217c-.176.1-.326 0-.326-.192v-1.589a.736.736 0 0 1 .326-.568l.368-.209c.209-.101.326-.017.326.192zM202.37 173.052v1.588a.73.73 0 0 1-.317.569l-.368.209c-.184.1-.326 0-.326-.192v-1.589a.695.695 0 0 1 .326-.56l.368-.217c.175-.084.317 0 .317.192zM200.732 174.013v1.597a.716.716 0 0 1-.326.56l-.36.209c-.184.101-.326 0-.326-.184v-1.596a.7.7 0 0 1 .326-.561l.36-.217c.184-.1.326-.017.326.192zM199.093 174.958v1.597a.716.716 0 0 1-.326.56l-.368.209c-.175.109-.326 0-.326-.184v-1.58a.72.72 0 0 1 .326-.56l.368-.209c.201-.125.326-.067.326.167z",
    fill: "#E1EDF8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M197.455 175.903v1.597a.727.727 0 0 1-.326.56l-.368.209c-.175.108-.326 0-.326-.184v-1.597a.729.729 0 0 1 .326-.56l.368-.209c.167-.109.326-.025.326.184zM195.808 176.847v1.597a.7.7 0 0 1-.326.56l-.36.218c-.183.1-.326 0-.326-.193v-1.596a.716.716 0 0 1 .326-.56l.36-.209c.184-.101.326-.017.326.183z",
    fill: "#E0E0E0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M194.169 177.8v1.589a.69.69 0 0 1-.326.56l-.368.217c-.175.101-.317 0-.317-.192v-1.588a.73.73 0 0 1 .317-.569l.368-.209c.184-.1.326-.017.326.192zM192.531 178.745v1.589a.763.763 0 0 1-.097.322.759.759 0 0 1-.229.246l-.368.209c-.176.1-.326 0-.326-.192v-1.589a.71.71 0 0 1 .326-.56l.368-.217c.175-.1.326-.017.326.192zM190.884 179.69v1.597a.727.727 0 0 1-.326.56l-.359.209c-.184.1-.326 0-.326-.184v-1.597a.695.695 0 0 1 .326-.56l.359-.217c.184-.101.326-.017.326.192z",
    fill: "#E1EDF8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M189.245 180.635v1.613a.701.701 0 0 1-.326.56l-.367.209c-.176.109-.318 0-.318-.184v-1.597a.704.704 0 0 1 .318-.56l.367-.209c.184-.125.326-.041.326.168z",
    fill: "#E0E0E0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M187.607 181.579v1.597a.726.726 0 0 1-.326.56l-.368.209c-.176.109-.326 0-.326-.184v-1.597a.727.727 0 0 1 .326-.56l.351-.192c.192-.125.343 0 .343.167zM185.96 182.524v1.597a.717.717 0 0 1-.318.56l-.368.209c-.184.108-.326 0-.326-.184v-1.622a.72.72 0 0 1 .326-.56l.368-.209c.176-.067.318.008.318.209z",
    fill: "#E1EDF8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M184.321 183.477v1.588a.692.692 0 0 1-.326.56l-.359.218c-.184.1-.326 0-.326-.192v-1.589a.716.716 0 0 1 .326-.568l.359-.209c.184-.101.326-.017.326.192z",
    fill: "#E0E0E0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M182.683 184.422v1.588a.747.747 0 0 1-.327.568l-.367.209c-.176.101-.326 0-.326-.192v-1.588a.742.742 0 0 1 .326-.569l.367-.209c.176-.1.327-.016.327.193z",
    fill: "#E1EDF8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M181.044 185.366v1.589a.736.736 0 0 1-.326.568l-.368.209c-.175.101-.326 0-.326-.184v-1.596a.716.716 0 0 1 .326-.561l.368-.217c.176-.1.326-.017.326.192zM175.869 188.56l-.677-.393a.89.89 0 0 0-.903.092 2.826 2.826 0 0 0-1.279 2.224.906.906 0 0 0 .368.836l.627.359.117-.192c.129-.028.253-.076.368-.142.373-.245.684-.573.908-.959a2.87 2.87 0 0 0 .379-1.265 1.333 1.333 0 0 0 0-.334l.092-.226z",
    fill: "#E0E0E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M174.933 188.635a2.835 2.835 0 0 0-1.279 2.224c0 .836.569 1.153 1.279.744a2.85 2.85 0 0 0 1.288-2.232c0-.82-.577-1.146-1.288-.736z",
    fill: "#E1EDF8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M174.933 188.635a2.835 2.835 0 0 0-1.279 2.224c0 .836.569 1.153 1.279.744a2.85 2.85 0 0 0 1.288-2.232c0-.82-.577-1.146-1.288-.736z",
    fill: "#E1EDF8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m170.293 191.778-.677-.393a.911.911 0 0 0-.903.092 2.825 2.825 0 0 0-1.287 2.224.904.904 0 0 0 .376.836l.635.36.109-.193c.13-.026.254-.074.368-.142a2.834 2.834 0 0 0 1.287-2.223 1.242 1.242 0 0 0-.041-.327l.133-.234z",
    fill: "#E0E0E0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M169.357 191.854a2.825 2.825 0 0 0-1.288 2.223c0 .836.577 1.154 1.288.744a2.828 2.828 0 0 0 1.287-2.223c0-.828-.577-1.154-1.287-.744z",
    fill: "#E1EDF8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M169.357 191.854a2.825 2.825 0 0 0-1.288 2.223c0 .836.577 1.154 1.288.744a2.828 2.828 0 0 0 1.287-2.223c0-.828-.577-1.154-1.287-.744z",
    fill: "#E1EDF8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 216.524a1.079 1.079 0 0 1-.56-.15 1.385 1.385 0 0 1-.611-1.254v-11.888a3.494 3.494 0 0 1 1.597-2.768l34.569-19.955a1.252 1.252 0 0 1 1.889.443c.11.223.15.473.117.719v11.863a3.466 3.466 0 0 1-1.597 2.759l-34.56 19.955a1.663 1.663 0 0 1-.844.276zm35.396-35.279-34.56 19.955a2.654 2.654 0 0 0-1.187 2.057v11.863a.622.622 0 0 0 .2.543.608.608 0 0 0 .577-.1l34.56-19.939a2.671 2.671 0 0 0 1.179-2.057v-11.896a.614.614 0 0 0-.209-.552.645.645 0 0 0-.568.101l.008.025z",
    fill: "#E1EDF8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 186.094a2.982 2.982 0 0 1-1.388 2.307l-29.343 16.937c-.761.452-1.388.134-1.388-.702a2.995 2.995 0 0 1 1.354-2.324l29.344-16.937c.769-.427 1.421-.117 1.421.719z",
    fill: "#E1EDF8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 192.121a2.97 2.97 0 0 1-1.388 2.316l-29.343 16.937c-.761.443-1.388.126-1.388-.702a2.995 2.995 0 0 1 1.388-2.316l29.31-16.912c.769-.468 1.421-.15 1.421.677z",
    fill: "#E0E0E0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m201.727 191.444-12.456 7.19v3.018l12.456-7.19a2.977 2.977 0 0 0 1.388-2.316c.033-.852-.619-1.17-1.388-.702z",
    fill: "#E1EDF8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M179.213 221.465a1.259 1.259 0 0 1-.635-.159 1.557 1.557 0 0 1-.538-.617 1.56 1.56 0 0 1-.148-.804v-3.286a4 4 0 0 1 1.831-3.177l24.169-13.952a1.538 1.538 0 0 1 1.572-.109 1.522 1.522 0 0 1 .685 1.413v3.285a3.999 3.999 0 0 1-1.831 3.177l-24.168 13.953a1.928 1.928 0 0 1-.937.276zm25.08-21.268-24.168 13.953a3.158 3.158 0 0 0-1.413 2.449v3.269c0 .343.092.594.259.686a.77.77 0 0 0 .727-.109l24.194-13.953a3.168 3.168 0 0 0 1.413-2.449v-3.286c0-.343-.092-.593-.259-.685a.761.761 0 0 0-.728.108l-.025.017z",
    fill: "#E0E0E0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M203.984 202.621v1.589a.749.749 0 0 1-.326.568l-.368.209c-.176.101-.326 0-.326-.192v-1.588a.736.736 0 0 1 .326-.569l.368-.209c.209-.117.326-.017.326.192zM202.37 203.566v1.588a.73.73 0 0 1-.317.569l-.368.209c-.184.1-.326 0-.326-.192v-1.589a.695.695 0 0 1 .326-.56l.368-.217c.175-.101.317-.017.317.192zM200.732 204.511v1.596a.716.716 0 0 1-.326.561l-.36.209c-.184.1-.326 0-.326-.184v-1.597a.7.7 0 0 1 .326-.56l.36-.218c.184-.1.326-.016.326.193zM199.093 205.455v1.597a.724.724 0 0 1-.326.56l-.368.209c-.175.109-.326 0-.326-.184v-1.596a.716.716 0 0 1 .326-.561l.368-.209c.201-.108.326-.025.326.184z",
    fill: "#E1EDF8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M197.455 206.4v1.597a.726.726 0 0 1-.326.56l-.368.209c-.175.109-.326 0-.326-.184v-1.597a.729.729 0 0 1 .326-.56l.368-.209c.167-.109.326-.025.326.184zM195.808 207.328v1.597a.692.692 0 0 1-.326.56l-.36.217c-.183.101-.326 0-.326-.192v-1.588a.725.725 0 0 1 .326-.569l.36-.209c.184-.084.326 0 .326.184z",
    fill: "#E0E0E0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M194.169 208.298v1.588a.698.698 0 0 1-.326.56l-.368.218c-.175.1-.317 0-.317-.193v-1.588a.733.733 0 0 1 .317-.569l.368-.209c.184-.1.326-.016.326.193zM192.531 209.242v1.589a.749.749 0 0 1-.326.568l-.368.209c-.176.101-.326 0-.326-.192v-1.58a.706.706 0 0 1 .326-.56l.368-.217c.175-.109.326-.059.326.183zM190.884 210.187v1.597a.726.726 0 0 1-.326.56l-.359.209c-.184.1-.326 0-.326-.184v-1.597a.695.695 0 0 1 .326-.56l.359-.217c.184-.1.326-.017.326.192z",
    fill: "#E1EDF8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M189.245 211.132v1.597a.705.705 0 0 1-.326.56l-.367.209c-.176.108-.318 0-.318-.184v-1.597a.707.707 0 0 1 .318-.56l.367-.209c.184-.109.326-.025.326.184z",
    fill: "#E0E0E0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M187.607 212.076v1.597a.726.726 0 0 1-.326.56l-.368.209c-.176.109-.326 0-.326-.184v-1.596a.733.733 0 0 1 .326-.56l.368-.209c.175-.109.326-.026.326.183zM185.96 213.021v1.597a.71.71 0 0 1-.318.56l-.368.217c-.184.101-.326 0-.326-.192v-1.597a.724.724 0 0 1 .326-.56l.368-.209c.176-.1.318-.016.318.184z",
    fill: "#E1EDF8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M184.321 214.016v1.588a.71.71 0 0 1-.093.321.704.704 0 0 1-.233.24l-.359.217c-.184.1-.326 0-.326-.192v-1.589a.707.707 0 0 1 .326-.568l.359-.209c.184-.142.326-.059.326.192z",
    fill: "#E0E0E0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M182.683 214.919v1.605a.747.747 0 0 1-.327.568l-.367.209c-.176.101-.326 0-.326-.192v-1.588a.717.717 0 0 1 .326-.56l.367-.218c.176-.117.327-.033.327.176z",
    fill: "#E1EDF8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M181.044 215.864v1.588a.732.732 0 0 1-.326.568l-.368.209c-.175.101-.326 0-.326-.183v-1.597a.716.716 0 0 1 .326-.56l.368-.218c.176-.1.326.017.326.193zM175.869 219.032l-.677-.393a.892.892 0 0 0-.903.092 2.835 2.835 0 0 0-1.279 2.224.93.93 0 0 0 .368.836l.627.359.117-.192c.129-.028.254-.076.368-.142a2.861 2.861 0 0 0 1.287-2.224 1.333 1.333 0 0 0 0-.334l.092-.226z",
    fill: "#E0E0E0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M174.933 219.132a2.829 2.829 0 0 0-1.279 2.224c0 .836.569 1.154 1.279.744a2.859 2.859 0 0 0 1.288-2.232c0-.836-.577-1.145-1.288-.736z",
    fill: "#E1EDF8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M174.933 219.132a2.829 2.829 0 0 0-1.279 2.224c0 .836.569 1.154 1.279.744a2.859 2.859 0 0 0 1.288-2.232c0-.836-.577-1.145-1.288-.736z",
    fill: "#E1EDF8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m170.293 222.276-.677-.393a.901.901 0 0 0-.903.092 2.832 2.832 0 0 0-1.287 2.223.902.902 0 0 0 .376.836l.635.36.109-.192c.13-.027.254-.075.368-.142a2.837 2.837 0 0 0 1.287-2.224c.001-.11-.013-.22-.041-.326l.133-.234z",
    fill: "#E0E0E0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M169.357 222.376a2.839 2.839 0 0 0-1.288 2.224c0 .836.577 1.153 1.288.744a2.838 2.838 0 0 0 1.287-2.224c0-.853-.577-1.179-1.287-.744z",
    fill: "#E1EDF8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M169.357 222.376a2.839 2.839 0 0 0-1.288 2.224c0 .836.577 1.153 1.288.744a2.838 2.838 0 0 0 1.287-2.224c0-.853-.577-1.179-1.287-.744z",
    fill: "#E1EDF8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 246.988a1.086 1.086 0 0 1-.56-.142 1.39 1.39 0 0 1-.476-.544 1.394 1.394 0 0 1-.135-.71v-11.863a3.466 3.466 0 0 1 1.606-2.767l34.56-19.956a1.253 1.253 0 0 1 2.006 1.162v11.88a3.503 3.503 0 0 1-.463 1.577 3.5 3.5 0 0 1-1.134 1.19l-34.56 19.947a1.668 1.668 0 0 1-.844.226zm35.396-35.271-34.56 19.955a2.663 2.663 0 0 0-1.187 2.057v11.863a.622.622 0 0 0 .2.543.608.608 0 0 0 .577-.1l34.56-19.947c.342-.229.626-.534.83-.891.205-.356.324-.755.349-1.166v-11.863a.609.609 0 0 0-.209-.551.632.632 0 0 0-.568.1h.008z",
    fill: "#E1EDF8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 216.591a2.978 2.978 0 0 1-1.388 2.307l-29.377 16.938c-.761.451-1.388.133-1.388-.703a3.008 3.008 0 0 1 1.388-2.307l29.344-16.937c.769-.443 1.421-.134 1.421.702z",
    fill: "#E1EDF8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 222.618a2.974 2.974 0 0 1-1.388 2.316l-29.343 16.938c-.761.443-1.388.125-1.388-.703a2.995 2.995 0 0 1 1.388-2.315l29.343-16.938c.736-.443 1.388-.125 1.388.702z",
    fill: "#E0E0E0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m201.727 221.916-12.456 7.19v3.018l12.456-7.19a2.977 2.977 0 0 0 1.388-2.316c.033-.827-.619-1.145-1.388-.702z",
    fill: "#E1EDF8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M179.213 251.962a1.259 1.259 0 0 1-.635-.159 1.548 1.548 0 0 1-.686-1.421v-3.285a3.993 3.993 0 0 1 1.831-3.177l24.169-13.953a1.538 1.538 0 0 1 1.572-.109 1.522 1.522 0 0 1 .685 1.413v3.286a3.991 3.991 0 0 1-1.831 3.176l-24.168 13.953a1.928 1.928 0 0 1-.937.276zm25.08-21.268-24.168 13.953a3.187 3.187 0 0 0-1.413 2.45v3.285c0 .343.092.594.259.686a.77.77 0 0 0 .727-.109l24.169-13.953a3.168 3.168 0 0 0 1.413-2.449v-3.286c0-.343-.092-.594-.259-.685a.761.761 0 0 0-.728.108z",
    fill: "#E0E0E0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M203.984 233.119v1.588a.752.752 0 0 1-.326.569l-.368.209c-.176.1-.326 0-.326-.193v-1.588a.742.742 0 0 1 .326-.569l.368-.209c.209-.1.326-.016.326.193zM202.37 234.08v1.588a.73.73 0 0 1-.317.569l-.368.209c-.184.1-.326 0-.326-.184v-1.597a.695.695 0 0 1 .326-.56l.368-.217c.175-.117.317-.034.317.192zM200.732 235.008v1.58a.72.72 0 0 1-.326.56l-.36.209c-.184.1-.326 0-.326-.184v-1.597a.699.699 0 0 1 .326-.56l.36-.209c.184-.092.326-.008.326.201zM199.093 235.953v1.596a.728.728 0 0 1-.326.561l-.368.209c-.175.108-.326 0-.326-.184v-1.597a.716.716 0 0 1 .326-.56l.368-.209c.201-.109.326-.017.326.184z",
    fill: "#E1EDF8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M197.455 236.897v1.597a.726.726 0 0 1-.326.56l-.368.209c-.175.109-.326 0-.326-.184v-1.596a.729.729 0 0 1 .326-.561l.368-.209c.167-.125.326-.025.326.184zM195.808 237.842v1.597a.692.692 0 0 1-.326.56l-.36.217c-.183.101-.326 0-.326-.192v-1.588a.725.725 0 0 1 .326-.569l.36-.209c.184-.1.326-.017.326.184z",
    fill: "#E0E0E0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M194.169 238.795v1.588a.724.724 0 0 1-.326.569l-.368.209c-.175.1-.317 0-.317-.192v-1.589a.726.726 0 0 1 .317-.568l.368-.209c.184-.101.326-.017.326.192zM192.531 239.74v1.588a.752.752 0 0 1-.326.569l-.368.209c-.176.1-.326 0-.326-.193v-1.588a.706.706 0 0 1 .326-.56l.368-.218c.175-.1.326-.016.326.193zM190.884 240.684v1.597a.726.726 0 0 1-.326.56l-.359.209c-.184.101-.326 0-.326-.184v-1.596a.686.686 0 0 1 .326-.561l.359-.209c.184-.108.326-.025.326.184z",
    fill: "#E1EDF8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M189.245 241.604v1.597a.705.705 0 0 1-.326.56l-.367.209c-.176.109-.318 0-.318-.184v-1.597a.707.707 0 0 1 .318-.56l.367-.209c.184-.084.326 0 .326.184z",
    fill: "#E0E0E0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M187.607 242.574v1.597a.727.727 0 0 1-.326.56l-.368.209c-.176.108-.326 0-.326-.184v-1.597a.729.729 0 0 1 .326-.56l.368-.209c.175-.109.326-.025.326.184zM185.96 243.518v1.597a.71.71 0 0 1-.318.56l-.368.218c-.184.1-.326 0-.326-.193v-1.588a.72.72 0 0 1 .326-.56l.368-.209c.176-.067.318-.025.318.175z",
    fill: "#E1EDF8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M184.321 244.471v1.589a.695.695 0 0 1-.326.56l-.359.217c-.184.101-.326 0-.326-.192v-1.588a.711.711 0 0 1 .326-.569l.359-.209c.184-.1.326-.017.326.192z",
    fill: "#E0E0E0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M182.683 245.416v1.589a.75.75 0 0 1-.327.568l-.367.209c-.176.1-.326 0-.326-.192v-1.589a.72.72 0 0 1 .326-.56l.367-.217c.176-.1.327-.017.327.192z",
    fill: "#E1EDF8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M181.044 246.361v1.597a.74.74 0 0 1-.326.56l-.368.209c-.175.1-.326 0-.326-.184v-1.597a.72.72 0 0 1 .326-.56l.368-.217c.176-.101.326-.017.326.192zM175.869 249.554l-.677-.393a.892.892 0 0 0-.903.092 2.829 2.829 0 0 0-1.279 2.224c-.016.159.01.32.074.467a.938.938 0 0 0 .294.369l.627.36.117-.193c.129-.028.254-.076.368-.142a2.863 2.863 0 0 0 1.287-2.224 1.333 1.333 0 0 0 0-.334l.092-.226z",
    fill: "#E0E0E0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M174.933 249.63a2.817 2.817 0 0 0-1.279 2.223c0 .836.569 1.154 1.279.744a2.859 2.859 0 0 0 1.288-2.232c0-.819-.577-1.145-1.288-.735z",
    fill: "#E1EDF8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M174.933 249.63a2.817 2.817 0 0 0-1.279 2.223c0 .836.569 1.154 1.279.744a2.859 2.859 0 0 0 1.288-2.232c0-.819-.577-1.145-1.288-.735z",
    fill: "#E1EDF8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m170.293 252.773-.677-.393a.901.901 0 0 0-.903.092 2.838 2.838 0 0 0-1.287 2.224.9.9 0 0 0 .376.836l.635.359.109-.192c.13-.027.254-.075.368-.142a2.828 2.828 0 0 0 1.287-2.224c.001-.11-.013-.22-.041-.326l.133-.234z",
    fill: "#E0E0E0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M169.357 252.848a2.839 2.839 0 0 0-1.288 2.224c0 .836.577 1.154 1.288.744a2.838 2.838 0 0 0 1.287-2.224c0-.819-.577-1.12-1.287-.744z",
    fill: "#E1EDF8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M169.357 252.848a2.839 2.839 0 0 0-1.288 2.224c0 .836.577 1.154 1.288.744a2.838 2.838 0 0 0 1.287-2.224c0-.819-.577-1.12-1.287-.744z",
    fill: "#E1EDF8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 155.496a1.086 1.086 0 0 1-.56-.142 1.39 1.39 0 0 1-.476-.544 1.394 1.394 0 0 1-.135-.71v-11.863a3.49 3.49 0 0 1 1.597-2.767l34.56-19.922a1.257 1.257 0 0 1 1.393-.09 1.257 1.257 0 0 1 .614 1.252v11.863a3.466 3.466 0 0 1-1.597 2.759l-34.56 19.955a1.664 1.664 0 0 1-.836.209zm35.806-35.405a.845.845 0 0 0-.41.134l-34.56 19.955a2.663 2.663 0 0 0-1.187 2.057V154.1a.62.62 0 0 0 .2.543.597.597 0 0 0 .577-.1l34.56-19.947a2.655 2.655 0 0 0 1.179-2.048v-11.871a.611.611 0 0 0-.209-.552.3.3 0 0 0-.15-.034z",
    fill: "#E1EDF8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 125.099a2.982 2.982 0 0 1-1.388 2.307l-29.343 16.938c-.761.443-1.388.134-1.388-.702a2.993 2.993 0 0 1 1.388-2.308l29.343-16.937c.736-.443 1.388-.134 1.388.702z",
    fill: "#E1EDF8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 131.127a2.974 2.974 0 0 1-1.388 2.315l-29.343 16.938c-.761.443-1.388.125-1.388-.703a2.995 2.995 0 0 1 1.388-2.315l29.31-16.946c.769-.435 1.421-.117 1.421.711z",
    fill: "#E0E0E0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m201.727 130.416-12.456 7.19v3.009l12.456-7.181a2.977 2.977 0 0 0 1.388-2.316c.033-.819-.619-1.137-1.388-.702z",
    fill: "#E1EDF8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m123.619 230.009.678-.393a.9.9 0 0 1 .902.092 2.837 2.837 0 0 1 1.288 2.223.902.902 0 0 1-.376.836l-.636.36-.108-.192a1.212 1.212 0 0 1-.368-.142 2.83 2.83 0 0 1-1.271-2.224 1.341 1.341 0 0 1 0-.335l-.109-.225z",
    fill: "#E0E0E0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M124.564 230.084a2.839 2.839 0 0 1 1.288 2.224c0 .836-.577 1.153-1.288.744a2.853 2.853 0 0 1-1.287-2.232c-.009-.82.568-1.146 1.287-.736z",
    fill: "#F0F0F0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m122.215 226.631 5.217 3.001a3.257 3.257 0 0 1 1.479 2.559v2.993c0 .944-.66 1.329-1.479.836l-5.217-2.993a3.278 3.278 0 0 1-1.48-2.567v-2.993c0-.911.661-1.304 1.48-.836z",
    fill: "#E0E0E0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m122.215 226.631 5.217 3.001a3.257 3.257 0 0 1 1.479 2.559v2.993c0 .944-.66 1.329-1.479.836l-5.217-2.993a3.278 3.278 0 0 1-1.48-2.567v-2.993c0-.911.661-1.304 1.48-.836z",
    fill: "#000"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m123.619 230.009.678-.393a.9.9 0 0 1 .902.092 2.837 2.837 0 0 1 1.288 2.223.902.902 0 0 1-.376.836l-.636.36-.108-.192a1.212 1.212 0 0 1-.368-.142 2.83 2.83 0 0 1-1.271-2.224 1.341 1.341 0 0 1 0-.335l-.109-.225z",
    fill: "#E0E0E0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M124.564 230.084a2.839 2.839 0 0 1 1.288 2.224c0 .836-.577 1.153-1.288.744a2.853 2.853 0 0 1-1.287-2.232c-.009-.82.568-1.146 1.287-.736z",
    fill: "#F0F0F0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m133.1 231.748 25.297 14.596a1.803 1.803 0 0 1 .836 1.413v6.989c0 .527-.368.736-.836.476L133.1 240.626a1.812 1.812 0 0 1-.836-1.421v-6.981c.016-.527.384-.736.836-.476z",
    fill: "#000"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M133.819 234.824a1.753 1.753 0 0 0 .836 1.363l22.22 12.816c.452.259.836.075.836-.41a1.753 1.753 0 0 0-.836-1.363l-22.237-12.816c-.452-.259-.819-.075-.819.41z",
    fill: "#E0E0E0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M133.819 238.377a1.753 1.753 0 0 0 .836 1.363l22.22 12.816c.452.259.836.075.836-.418a1.752 1.752 0 0 0-.836-1.355l-22.22-12.816c-.469-.267-.836-.075-.836.41z",
    fill: "#F0F0F0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m134.638 237.967 12.272 7.073v1.772l-12.272-7.072a1.757 1.757 0 0 1-.836-1.363c.017-.485.385-.677.836-.41zM122.215 212.143l5.217 2.993a3.278 3.278 0 0 1 1.479 2.567v3.001c0 .945-.66 1.321-1.479.836l-5.217-3.001a3.248 3.248 0 0 1-1.48-2.558v-2.993c0-.937.661-1.313 1.48-.845z",
    fill: "#E0E0E0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m122.215 212.143 5.217 2.993a3.278 3.278 0 0 1 1.479 2.567v3.001c0 .945-.66 1.321-1.479.836l-5.217-3.001a3.248 3.248 0 0 1-1.48-2.558v-2.993c0-.937.661-1.313 1.48-.845z",
    fill: "#000"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m123.619 215.521.678-.393a.93.93 0 0 1 .902.092 2.853 2.853 0 0 1 1.288 2.232.903.903 0 0 1-.376.836l-.636.368-.108-.192a1.189 1.189 0 0 1-.368-.143 2.843 2.843 0 0 1-1.288-2.232 1.367 1.367 0 0 1 0-.326l-.092-.242z",
    fill: "#E0E0E0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M124.564 215.588a2.859 2.859 0 0 1 1.288 2.232c0 .836-.577 1.145-1.288.735a2.828 2.828 0 0 1-1.287-2.223c-.009-.82.568-1.154 1.287-.744z",
    fill: "#F0F0F0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m122.215 197.731 5.217 3.001a3.264 3.264 0 0 1 1.479 2.558v2.993c0 .945-.66 1.329-1.479.836l-5.217-2.993a3.282 3.282 0 0 1-1.48-2.566v-2.985c0-.928.661-1.279 1.48-.844z",
    fill: "#E0E0E0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m122.215 197.731 5.217 3.001a3.264 3.264 0 0 1 1.479 2.558v2.993c0 .945-.66 1.329-1.479.836l-5.217-2.993a3.282 3.282 0 0 1-1.48-2.566v-2.985c0-.928.661-1.279 1.48-.844z",
    fill: "#000"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m123.619 201.108.678-.393a.899.899 0 0 1 .902.092 2.831 2.831 0 0 1 1.288 2.224.9.9 0 0 1-.376.836l-.636.359-.108-.192a1.162 1.162 0 0 1-.368-.142 2.839 2.839 0 0 1-1.288-2.224 1.27 1.27 0 0 1 0-.326l-.092-.234z",
    fill: "#E1EDF8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m123.619 201.108.678-.393a.899.899 0 0 1 .902.092 2.831 2.831 0 0 1 1.288 2.224.9.9 0 0 1-.376.836l-.636.359-.108-.192a1.162 1.162 0 0 1-.368-.142 2.839 2.839 0 0 1-1.288-2.224 1.27 1.27 0 0 1 0-.326l-.092-.234z",
    fill: "#000"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M124.564 201.183a2.839 2.839 0 0 1 1.288 2.224c0 .836-.577 1.154-1.288.744a2.832 2.832 0 0 1-1.287-2.224c-.009-.819.568-1.153 1.287-.744z",
    fill: "#E1EDF8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m133.1 202.847 25.297 14.597a1.809 1.809 0 0 1 .836 1.421v6.98c0 .527-.368.736-.836.477L133.1 211.725a1.794 1.794 0 0 1-.836-1.412v-6.989c.016-.519.384-.736.836-.477z",
    fill: "#E0E0E0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M133.819 205.932a1.744 1.744 0 0 0 .836 1.354l22.22 12.816c.452.268.836.075.836-.41a1.753 1.753 0 0 0-.836-1.362l-22.22-12.816c-.469-.259-.836-.075-.836.418zM134.638 209.067l12.272 7.072v1.773l-12.272-7.073a1.763 1.763 0 0 1-.836-1.362c.017-.477.385-.669.836-.41z",
    fill: "#E1EDF8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m123.619 201.108.678-.393a.899.899 0 0 1 .902.092 2.831 2.831 0 0 1 1.288 2.224.9.9 0 0 1-.376.836l-.636.359-.108-.192a1.162 1.162 0 0 1-.368-.142 2.839 2.839 0 0 1-1.288-2.224 1.27 1.27 0 0 1 0-.326l-.092-.234z",
    fill: "#E0E0E0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M124.564 201.183a2.839 2.839 0 0 1 1.288 2.224c0 .836-.577 1.154-1.288.744a2.832 2.832 0 0 1-1.287-2.224c-.009-.819.568-1.153 1.287-.744z",
    fill: "#F0F0F0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m133.1 202.847 25.297 14.597a1.809 1.809 0 0 1 .836 1.421v6.98c0 .527-.368.736-.836.477L133.1 211.725a1.794 1.794 0 0 1-.836-1.412v-6.989c.016-.519.384-.736.836-.477z",
    fill: "#000"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M133.819 205.932a1.744 1.744 0 0 0 .836 1.354l22.22 12.816c.452.268.836.075.836-.41a1.753 1.753 0 0 0-.836-1.362l-22.22-12.816c-.469-.259-.836-.075-.836.418z",
    fill: "#E0E0E0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M133.819 209.477a1.753 1.753 0 0 0 .836 1.362l22.22 12.816c.452.259.836.075.836-.41a1.753 1.753 0 0 0-.836-1.362l-22.22-12.816c-.469-.259-.836-.067-.836.41z",
    fill: "#F0F0F0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m134.638 209.067 12.272 7.072v1.773l-12.272-7.073a1.763 1.763 0 0 1-.836-1.362c.017-.477.385-.669.836-.41z",
    fill: "#E0E0E0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m133.1 217.301 25.297 14.589a1.809 1.809 0 0 1 .836 1.421v6.98c0 .527-.368.736-.836.477L133.1 226.18a1.834 1.834 0 0 1-.836-1.421v-6.989c.016-.519.384-.736.836-.469z",
    fill: "#000"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M133.819 220.378a1.77 1.77 0 0 0 .836 1.363l22.22 12.816c.452.259.836.075.836-.418a1.745 1.745 0 0 0-.836-1.363l-22.22-12.816c-.469-.259-.836-.092-.836.418z",
    fill: "#E0E0E0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M133.819 223.931a1.744 1.744 0 0 0 .836 1.354l22.22 12.816c.452.268.836.075.836-.409a1.745 1.745 0 0 0-.836-1.363l-22.22-12.816c-.469-.259-.836-.075-.836.418z",
    fill: "#F0F0F0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m134.638 223.513 15.349 8.895v1.772l-15.349-8.853a1.758 1.758 0 0 1-.836-1.354c.017-.535.385-.719.836-.46zM132.682 92.094a1.672 1.672 0 0 1-1.547-1.079L129.296 86l-8.845 5.125a1.208 1.208 0 0 1-1.344.091 1.208 1.208 0 0 1-.587-1.211v-40.68a3.34 3.34 0 0 1 1.538-2.675l44.726-25.824a1.337 1.337 0 0 1 1.346-.092 1.35 1.35 0 0 1 .585 1.212V62.65a3.345 3.345 0 0 1-1.538 2.675L136.945 81.62l-2.667 9.28a1.62 1.62 0 0 1-1.53 1.195h-.066zm-2.977-7.19 2.166 5.852a.834.834 0 0 0 .836.569.836.836 0 0 0 .836-.636l2.725-9.597 28.499-16.46a2.566 2.566 0 0 0 1.154-1.999V21.962c0-.268-.075-.468-.201-.535a.584.584 0 0 0-.56.092l-44.726 25.824a2.573 2.573 0 0 0-1.137 1.981v40.688c0 .268.067.468.201.535a.586.586 0 0 0 .56-.092l9.647-5.55z",
    fill: "#E0E0E0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M141.652 40.596v15.34l-9.313 14.865c-3.286-4.18-2.324-14.739 2.809-23.065 2.073-3.353 3.912-5.501 6.504-7.14z",
    fill: "#E6E6E6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M154.309 54.123c-1.839 9.321-8.277 17.982-14.614 19.529a6.192 6.192 0 0 1-6.295-1.539l9.38-15.173 11.529-2.817z",
    fill: "#E0E0E0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m154.551 52.51-11.035 2.708 6.195-16.31c3.946 1.48 5.785 6.704 4.84 13.601z",
    fill: "#F5F5F5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m148.54 38.79-5.584 14.714V39.81a7.79 7.79 0 0 1 5.584-1.02z",
    fill: "#EBEBEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 271.006-46.08 26.602-46.088-26.602 46.088-26.61 46.08 26.61z",
    fill: "url(#c)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m123.669 271.006-46.08 26.602-46.088-26.602 46.088-26.61 46.08 26.61z",
    fill: "#000"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.59 297.608v-3.319l-43.205-24.947-2.884 1.664 46.088 26.602z",
    fill: "#000"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M77.59 297.616v18.208a6.36 6.36 0 0 0 3.067-.727l19.964-11.529 21.201-12.247a4.05 4.05 0 0 0 1.847-3.194v-17.121l-46.08 26.61z",
    fill: "url(#d)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M77.59 297.616v18.208a6.36 6.36 0 0 0 3.067-.727l19.964-11.529 21.201-12.247a4.05 4.05 0 0 0 1.847-3.194v-17.121l-46.08 26.61z",
    fill: "#fff"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 271.006v17.113a4.077 4.077 0 0 0 1.84 3.194l18.325 10.575 22.856 13.2c.945.499 2 .749 3.068.728v-18.2l-46.088-26.61z",
    fill: "url(#e)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.5 271.006v17.113a4.077 4.077 0 0 0 1.84 3.194l18.325 10.575 22.856 13.2c.945.499 2 .749 3.068.728v-18.2l-46.088-26.61z",
    fill: "#fff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 251.051-46.08 26.61-46.088-26.61 46.088-26.61 46.08 26.61z",
    fill: "url(#f)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m123.669 251.051-46.08 26.61-46.088-26.61 46.088-26.61 46.08 26.61z",
    fill: "#000"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.59 277.661v-3.328l-43.205-24.946-2.884 1.664 46.088 26.61z",
    fill: "#000"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 264.352-46.08 26.609v-13.3l46.08-26.61v13.301z",
    fill: "url(#g)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "m123.669 264.352-46.08 26.609v-13.3l46.08-26.61v13.301z",
    fill: "#fff"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M77.59 290.961 31.5 264.352v-13.301l46.09 26.61v13.3z",
    fill: "url(#h)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.59 290.961 31.5 264.352v-13.301l46.09 26.61v13.3z",
    fill: "#fff"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 271.006v-3.327l-40.32 23.282v3.328l40.32-23.283z",
    fill: "#455A64"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M34.385 266.015v3.327l43.204 24.947v-3.328l-43.204-24.946z",
    fill: "url(#i)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M34.385 266.015v3.327l43.204 24.947v-3.328l-43.204-24.946z",
    fill: "#37474F"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 231.095-46.08 26.602-46.088-26.602 46.088-26.609 46.08 26.609z",
    fill: "url(#j)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m123.669 231.095-46.08 26.602-46.088-26.602 46.088-26.609 46.08 26.609z",
    fill: "#000"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.59 257.697v-3.319l-43.205-24.946-2.884 1.663 46.088 26.602z",
    fill: "#000"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 244.396-46.08 26.61v-13.309l46.08-26.602v13.301z",
    fill: "url(#k)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "m123.669 244.396-46.08 26.61v-13.309l46.08-26.602v13.301z",
    fill: "#fff"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m77.59 271.006-46.09-26.61v-13.301l46.09 26.602v13.309z",
    fill: "url(#l)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m77.59 271.006-46.09-26.61v-13.301l46.09 26.602v13.309z",
    fill: "#fff"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 251.051v-3.327l-40.32 23.282v3.327l40.32-23.282z",
    fill: "#455A64"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M34.385 246.06v3.327l43.204 24.946v-3.327L34.385 246.06z",
    fill: "#37474F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 231.095v-3.327l-40.32 23.283v3.327l40.32-23.283z",
    fill: "#455A64"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M34.385 226.105v3.327l43.204 24.946v-3.327l-43.204-24.946z",
    fill: "#37474F"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 211.14-46.08 26.61-46.088-26.61 46.088-26.601 46.08 26.601z",
    fill: "url(#m)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m123.669 211.14-46.08 26.61-46.088-26.61 46.088-26.601 46.08 26.601z",
    fill: "#fff"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m123.669 211.14-46.08 26.61-46.088-26.61 46.088-26.601 46.08 26.601z",
    fill: "#000"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.59 234.423v3.327L31.5 211.14l2.885-1.655 43.204 24.938z",
    fill: "#000"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 224.441-46.08 26.61V237.75l46.08-26.61v13.301z",
    fill: "url(#n)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "m123.669 224.441-46.08 26.61V237.75l46.08-26.61v13.301z",
    fill: "#fff"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m77.59 251.051-46.09-26.61V211.14l46.09 26.61v13.301z",
    fill: "url(#o)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m77.59 251.051-46.09-26.61V211.14l46.09 26.61v13.301z",
    fill: "#fff"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 211.149v-3.328l-40.32 23.283v3.319l40.32-23.274z",
    fill: "#455A64"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M34.385 206.158v3.327l43.204 24.938v-3.319l-43.204-24.946z",
    fill: "#37474F"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 191.151-46.08 26.602-46.088-26.602 46.088-26.609 46.08 26.609z",
    fill: "url(#p)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m123.669 191.151-46.08 26.602-46.088-26.602 46.088-26.609 46.08 26.609z",
    fill: "#fff"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m123.669 191.151-46.08 26.602-46.088-26.602 46.088-26.609 46.08 26.609z",
    fill: "#000"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.59 214.434v3.319L31.5 191.151l2.885-1.663 43.204 24.946z",
    fill: "#000"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m123.669 204.452-46.08 26.602v-13.301l46.08-26.602v13.301z",
    fill: "url(#q)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "m123.669 204.452-46.08 26.602v-13.301l46.08-26.602v13.301z",
    fill: "#fff"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M77.59 231.054 31.5 204.452v-13.301l46.09 26.602v13.301z",
    fill: "url(#r)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.59 231.054 31.5 204.452v-13.301l46.09 26.602v13.301z",
    fill: "#fff"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m33.34 170.134 42.427-24.478a4.098 4.098 0 0 1 3.686 0l42.377 24.478a4.092 4.092 0 0 1 1.839 3.194v11.177l-46.113 26.602L31.5 184.505v-11.177a4.093 4.093 0 0 1 1.839-3.194z",
    fill: "url(#s)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m33.34 170.134 42.427-24.478a4.098 4.098 0 0 1 3.686 0l42.377 24.478a4.092 4.092 0 0 1 1.839 3.194v11.177l-46.113 26.602L31.5 184.505v-11.177a4.093 4.093 0 0 1 1.839-3.194z",
    fill: "#fff"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M77.564 197.179v13.928l46.105-26.602v-11.177a4.123 4.123 0 0 0-1.513-2.96c.677.594.56 1.38-.334 1.898L79.42 196.744c-.572.3-1.21.449-1.856.435z",
    fill: "url(#t)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M77.564 197.179v13.928l46.105-26.602v-11.177a4.123 4.123 0 0 0-1.513-2.96c.677.594.56 1.38-.334 1.898L79.42 196.744c-.572.3-1.21.449-1.856.435z",
    fill: "#fff"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m121.83 172.266-42.41 24.478a4.067 4.067 0 0 1-3.678 0L33.34 172.266a1.129 1.129 0 0 1 0-2.132l42.427-24.478a4.098 4.098 0 0 1 3.687 0l42.376 24.478a1.127 1.127 0 0 1 .549 1.72 1.127 1.127 0 0 1-.549.412z",
    fill: "url(#u)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "m121.83 172.266-42.41 24.478a4.067 4.067 0 0 1-3.678 0L33.34 172.266a1.129 1.129 0 0 1 0-2.132l42.427-24.478a4.098 4.098 0 0 1 3.687 0l42.376 24.478a1.127 1.127 0 0 1 .549 1.72 1.127 1.127 0 0 1-.549.412z",
    fill: "#fff"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 191.151v-3.319l-40.32 23.275v3.327l40.32-23.283z",
    fill: "#455A64"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M34.385 186.169v3.319l43.204 24.946v-3.327l-43.204-24.938z",
    fill: "#37474F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M41.524 292.215a1.405 1.405 0 0 1 .644 1.104c0 .41-.293.577-.644.368a1.4 1.4 0 0 1-.635-1.104c0-.409.284-.577.635-.368zM46.816 295.292a1.406 1.406 0 0 1 .644 1.103c0 .41-.285.577-.644.368a1.392 1.392 0 0 1-.635-1.103c.033-.402.317-.552.635-.368zM52.091 298.318a1.395 1.395 0 0 1 .636 1.095c0 .41-.285.577-.636.368a1.393 1.393 0 0 1-.635-1.095c0-.41.284-.568.635-.368zM57.375 301.37a1.393 1.393 0 0 1 .635 1.095c0 .401-.284.568-.635.368a1.395 1.395 0 0 1-.636-1.096c0-.409.285-.568.636-.367z",
    fill: "#455A64"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m35.313 276.507 5.409 3.11a3.382 3.382 0 0 1 1.538 2.658v3.11c0 .978-.686 1.371-1.538.886l-5.41-3.109a3.391 3.391 0 0 1-1.538-2.659v-3.11c0-.978.686-1.371 1.539-.886z",
    fill: "#fff",
    opacity: 0.75
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m36.784 280.01.702-.41a.927.927 0 0 1 .937.101 2.951 2.951 0 0 1 1.337 2.307.927.927 0 0 1-.393.836l-.652.376-.117-.192a1.569 1.569 0 0 1-.384-.151 2.963 2.963 0 0 1-1.338-2.315 1.36 1.36 0 0 1 0-.335l-.092-.217z",
    fill: "url(#v)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m36.784 280.01.702-.41a.927.927 0 0 1 .937.101 2.951 2.951 0 0 1 1.337 2.307.927.927 0 0 1-.393.836l-.652.376-.117-.192a1.569 1.569 0 0 1-.384-.151 2.963 2.963 0 0 1-1.338-2.315 1.36 1.36 0 0 1 0-.335l-.092-.217z",
    fill: "#000"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M37.737 280.06a2.962 2.962 0 0 1 1.338 2.316c0 .836-.594 1.195-1.338.769a2.951 2.951 0 0 1-1.33-2.249c0-.886.594-1.237 1.33-.836z",
    fill: "url(#w)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m35.313 256.535 5.409 3.118a3.35 3.35 0 0 1 1.538 2.659v3.101c0 .978-.686 1.38-1.538.886l-5.41-3.109a3.391 3.391 0 0 1-1.538-2.659v-3.11c0-.978.686-1.371 1.539-.886z",
    fill: "#fff",
    opacity: 0.75
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m36.784 260.038.702-.401a.925.925 0 0 1 .937.091 2.968 2.968 0 0 1 1.337 2.308.957.957 0 0 1-.393.836l-.652.376-.117-.201a1.299 1.299 0 0 1-.384-.15 2.953 2.953 0 0 1-1.338-2.307 1.426 1.426 0 0 1 0-.343l-.092-.209z",
    fill: "url(#x)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m36.784 260.038.702-.401a.925.925 0 0 1 .937.091 2.968 2.968 0 0 1 1.337 2.308.957.957 0 0 1-.393.836l-.652.376-.117-.201a1.299 1.299 0 0 1-.384-.15 2.953 2.953 0 0 1-1.338-2.307 1.426 1.426 0 0 1 0-.343l-.092-.209z",
    fill: "#000"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M37.737 260.113a2.962 2.962 0 0 1 1.338 2.316c0 .836-.594 1.195-1.338.769a2.954 2.954 0 0 1-1.33-2.307c0-.853.594-1.196 1.33-.778z",
    fill: "url(#y)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m35.313 236.588 5.409 3.11a3.382 3.382 0 0 1 1.538 2.658v3.11c0 .978-.686 1.371-1.538.886l-5.41-3.076a3.391 3.391 0 0 1-1.538-2.658v-3.11c0-1.02.686-1.413 1.539-.92z",
    fill: "#fff",
    opacity: 0.75
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m36.784 240.082.702-.401a.927.927 0 0 1 .937.101 2.951 2.951 0 0 1 1.337 2.307.927.927 0 0 1-.393.836l-.652.376-.117-.192a1.569 1.569 0 0 1-.384-.151 2.963 2.963 0 0 1-1.338-2.315 1.36 1.36 0 0 1 0-.335l-.092-.226z",
    fill: "url(#z)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m36.784 240.082.702-.401a.927.927 0 0 1 .937.101 2.951 2.951 0 0 1 1.337 2.307.927.927 0 0 1-.393.836l-.652.376-.117-.192a1.569 1.569 0 0 1-.384-.151 2.963 2.963 0 0 1-1.338-2.315 1.36 1.36 0 0 1 0-.335l-.092-.226z",
    fill: "#000"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M37.737 240.158a2.962 2.962 0 0 1 1.338 2.315c0 .836-.594 1.196-1.338.77a2.96 2.96 0 0 1-1.33-2.316c0-.845.594-1.196 1.33-.769z",
    fill: "url(#A)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m35.313 216.649 5.409 3.11a3.39 3.39 0 0 1 1.538 2.659v3.11c0 .978-.686 1.371-1.538.886l-5.41-3.118a3.342 3.342 0 0 1-1.538-2.659v-3.101c0-1.012.686-1.38 1.539-.887z",
    fill: "#fff",
    opacity: 0.75
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m36.784 220.152.702-.409a.941.941 0 0 1 .97.125 2.963 2.963 0 0 1 1.337 2.316.938.938 0 0 1-.392.836l-.653.376-.116-.201a1.262 1.262 0 0 1-.385-.142 2.952 2.952 0 0 1-1.38-2.349 1.49 1.49 0 0 1 0-.343l-.083-.209z",
    fill: "url(#B)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m36.784 220.152.702-.409a.941.941 0 0 1 .97.125 2.963 2.963 0 0 1 1.337 2.316.938.938 0 0 1-.392.836l-.653.376-.116-.201a1.262 1.262 0 0 1-.385-.142 2.952 2.952 0 0 1-1.38-2.349 1.49 1.49 0 0 1 0-.343l-.083-.209z",
    fill: "#000"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M37.737 220.227a2.968 2.968 0 0 1 1.338 2.308c0 .836-.594 1.195-1.338.777a2.942 2.942 0 0 1-1.33-2.315c0-.853.594-1.196 1.33-.77z",
    fill: "url(#C)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m35.313 196.652 5.409 3.152a3.35 3.35 0 0 1 1.538 2.658v3.102c0 .978-.686 1.379-1.538.886l-5.41-3.11a3.344 3.344 0 0 1-1.538-2.7v-3.11c0-.97.686-1.363 1.539-.878z",
    fill: "#fff",
    opacity: 0.75
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m36.784 200.155.702-.401a.925.925 0 0 1 .937.092 2.956 2.956 0 0 1 1.337 2.307.955.955 0 0 1-.393.836l-.652.376-.117-.2a1.114 1.114 0 0 1-.384-.151 2.944 2.944 0 0 1-1.338-2.307 1.426 1.426 0 0 1 0-.343l-.092-.209z",
    fill: "url(#D)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m36.784 200.155.702-.401a.925.925 0 0 1 .937.092 2.956 2.956 0 0 1 1.337 2.307.955.955 0 0 1-.393.836l-.652.376-.117-.2a1.114 1.114 0 0 1-.384-.151 2.944 2.944 0 0 1-1.338-2.307 1.426 1.426 0 0 1 0-.343l-.092-.209z",
    fill: "#000"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M37.737 200.239a2.93 2.93 0 0 1 1.338 2.307c0 .836-.594 1.196-1.338.769a2.944 2.944 0 0 1-1.33-2.307c0-.853.594-1.204 1.33-.769z",
    fill: "url(#E)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "m35.313 176.68 5.409 3.119a3.34 3.34 0 0 1 1.538 2.658v3.135c0 .978-.686 1.379-1.538.886l-5.41-3.11a3.339 3.339 0 0 1-1.538-2.658v-3.102c0-1.02.686-1.413 1.539-.928z",
    fill: "#fff",
    opacity: 0.75
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m36.784 180.183.702-.401a.925.925 0 0 1 .937.092 2.963 2.963 0 0 1 1.337 2.315.948.948 0 0 1-.393.836l-.652.377-.117-.201a1.132 1.132 0 0 1-.384-.15 2.962 2.962 0 0 1-1.338-2.308 1.426 1.426 0 0 1 0-.343l-.092-.217z",
    fill: "url(#F)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m36.784 180.183.702-.401a.925.925 0 0 1 .937.092 2.963 2.963 0 0 1 1.337 2.315.948.948 0 0 1-.393.836l-.652.377-.117-.201a1.132 1.132 0 0 1-.384-.15 2.962 2.962 0 0 1-1.338-2.308 1.426 1.426 0 0 1 0-.343l-.092-.217z",
    fill: "#000"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M37.737 180.267a2.93 2.93 0 0 1 1.338 2.307c0 .836-.594 1.196-1.338.769a2.943 2.943 0 0 1-1.33-2.307c0-.853.594-1.196 1.33-.769z",
    fill: "url(#G)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "m119.255 276.883-22.856 13.209a3.395 3.395 0 0 0-1.53 2.658v3.11c0 .979.686 1.38 1.53.887l22.856-13.193a3.394 3.394 0 0 0 1.53-2.658v-3.11c0-.995-.685-1.388-1.53-.903z",
    fill: "#455A64"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M119.172 279.517v1.504a.681.681 0 0 1-.309.535l-.343.201c-.176.092-.31 0-.31-.184v-1.513a.66.66 0 0 1 .31-.527l.343-.2c.167-.109.309-.017.309.184z",
    fill: "url(#H)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M117.617 280.411v1.505a.68.68 0 0 1-.309.535l-.343.201c-.167.092-.309 0-.309-.184v-1.505a.673.673 0 0 1 .309-.527l.343-.2c.175-.101.309-.026.309.175z",
    fill: "url(#I)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M116.062 281.306v1.504a.68.68 0 0 1-.301.535l-.351.201c-.167.092-.301 0-.301-.184v-1.505a.672.672 0 0 1 .301-.526l.351-.201c.167-.1.301-.025.301.176z",
    fill: "url(#J)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 282.2v1.505a.68.68 0 0 1-.309.535l-.343.201c-.176.092-.309 0-.309-.184v-1.505a.646.646 0 0 1 .309-.527l.343-.2c.15-.101.309-.025.309.175zM112.96 283.095v1.504a.673.673 0 0 1-.309.536l-.343.2c-.167.092-.309 0-.309-.184v-1.505a.682.682 0 0 1 .309-.526l.343-.201c.209-.1.309-.025.309.176z",
    fill: "#37474F"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M111.414 283.989v1.505a.68.68 0 0 1-.31.535l-.351.201c-.167.092-.301 0-.301-.184v-1.505a.657.657 0 0 1 .088-.299.665.665 0 0 1 .213-.228l.351-.2c.168-.101.31-.025.31.175z",
    fill: "url(#K)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M109.859 284.884v1.505a.68.68 0 0 1-.309.535l-.343.2c-.167.092-.31 0-.31-.184v-1.505a.683.683 0 0 1 .31-.526l.343-.201c.167-.1.309-.025.309.176z",
    fill: "url(#L)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M108.304 285.778v1.505a.676.676 0 0 1-.301.535l-.351.201c-.167.092-.301 0-.301-.184v-1.505a.668.668 0 0 1 .301-.527l.351-.2c.167-.101.301-.025.301.175z",
    fill: "url(#M)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M106.757 286.673v1.505a.68.68 0 0 1-.309.535l-.343.2c-.175.092-.309 0-.309-.184v-1.504a.654.654 0 0 1 .309-.527l.343-.201c.167-.1.309-.025.309.176z",
    fill: "url(#N)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M105.202 287.584v1.505a.673.673 0 0 1-.309.535l-.343.2c-.167.092-.309 0-.309-.183v-1.505a.675.675 0 0 1 .309-.527l.343-.201c.176-.117.309-.041.309.176z",
    fill: "url(#O)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M103.664 288.462v1.505a.674.674 0 0 1-.301.535l-.351.2c-.167.092-.301 0-.301-.184v-1.504a.7.7 0 0 1 .301-.535l.351-.193c.15-.1.301-.025.301.176z",
    fill: "url(#P)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M102.101 289.356v1.505a.677.677 0 0 1-.31.535l-.342.201c-.167.092-.31 0-.31-.184v-1.505a.688.688 0 0 1 .31-.527l.342-.2c.201-.101.31-.025.31.175z",
    fill: "url(#Q)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M100.546 290.251v1.513a.676.676 0 0 1-.301.535l-.352.201c-.167.092-.309 0-.309-.184v-1.505a.674.674 0 0 1 .31-.527l.351-.2c.167-.109.301.008.301.167z",
    fill: "#37474F"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M99 291.145v1.505a.688.688 0 0 1-.31.535l-.343.201c-.175.092-.31 0-.31-.184v-1.505a.679.679 0 0 1 .31-.535l.343-.192c.167-.101.31-.042.31.175z",
    fill: "url(#R)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M97.444 292.04v1.505a.682.682 0 0 1-.31.535l-.342.2c-.167.092-.31 0-.31-.184V292.6a.697.697 0 0 1 .31-.535l.343-.192c.175-.109.31-.034.31.167z",
    fill: "url(#S)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m119.255 256.936-22.856 13.192a3.395 3.395 0 0 0-1.53 2.659v3.093c0 .978.686 1.371 1.53.886l22.856-13.2a3.397 3.397 0 0 0 1.53-2.659v-3.085c0-.978-.685-1.379-1.53-.886z",
    fill: "#455A64"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M119.172 259.561v1.513a.683.683 0 0 1-.309.527l-.343.201c-.176.1-.31 0-.31-.176v-1.505a.671.671 0 0 1 .31-.535l.343-.2c.167-.092.309-.017.309.175z",
    fill: "url(#T)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M117.617 260.456v1.513a.675.675 0 0 1-.31.527l-.342.2a.193.193 0 0 1-.291-.065.198.198 0 0 1-.019-.11v-1.505a.69.69 0 0 1 .31-.535l.342-.201c.176-.092.31-.016.31.176z",
    fill: "#37474F"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M116.062 261.35v1.513a.672.672 0 0 1-.301.527l-.351.201c-.167.1-.301 0-.301-.176v-1.505a.674.674 0 0 1 .301-.535l.351-.2c.167-.092.301-.017.301.175z",
    fill: "url(#U)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 262.245v1.513a.675.675 0 0 1-.309.527l-.343.2c-.176.101-.309 0-.309-.175v-1.505a.664.664 0 0 1 .309-.535l.343-.201c.15-.092.309-.016.309.176zM112.96 263.139v1.514a.65.65 0 0 1-.309.526l-.343.201a.196.196 0 0 1-.213.016.194.194 0 0 1-.096-.192v-1.505a.68.68 0 0 1 .309-.535l.343-.2c.209-.092.309-.017.309.175z",
    fill: "#37474F"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M111.414 264.034v1.513a.675.675 0 0 1-.31.527l-.351.2c-.167.101-.301 0-.301-.175v-1.505a.676.676 0 0 1 .301-.535l.351-.201c.168-.092.31-.016.31.176z",
    fill: "url(#V)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M109.859 264.928v1.514a.682.682 0 0 1-.31.526l-.342.201a.2.2 0 0 1-.105.04.188.188 0 0 1-.186-.105.193.193 0 0 1-.019-.111v-1.504a.694.694 0 0 1 .31-.536l.342-.2c.168-.092.31-.017.31.175z",
    fill: "url(#W)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M108.304 265.848v1.513a.676.676 0 0 1-.301.527l-.351.2c-.167.101-.301 0-.301-.175v-1.505a.674.674 0 0 1 .301-.535l.351-.201c.167-.117.301-.041.301.176z",
    fill: "url(#X)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M106.757 266.684v1.513a.673.673 0 0 1-.309.527l-.343.2c-.175.101-.309 0-.309-.175v-1.505a.67.67 0 0 1 .309-.535l.343-.201c.167-.058.309.017.309.176z",
    fill: "#37474F"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M105.202 267.612v1.513a.646.646 0 0 1-.309.527l-.343.2a.19.19 0 0 1-.213.016.19.19 0 0 1-.096-.191v-1.505a.68.68 0 0 1 .309-.535l.343-.201c.175-.1.309-.016.309.176z",
    fill: "url(#Y)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M103.664 268.506v1.522a.668.668 0 0 1-.301.527l-.351.2c-.167.101-.301 0-.301-.175v-1.505a.675.675 0 0 1 .301-.535l.351-.201c.15-.108.301.017.301.167z",
    fill: "#37474F"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M102.101 269.401v1.513a.688.688 0 0 1-.31.527l-.342.2a.193.193 0 0 1-.31-.175v-1.505a.68.68 0 0 1 .31-.535l.342-.201a.2.2 0 0 1 .105-.04.189.189 0 0 1 .109.025c.033.018.06.047.077.081a.198.198 0 0 1 .019.11z",
    fill: "url(#Z)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M100.546 270.296v1.513a.657.657 0 0 1-.088.299.653.653 0 0 1-.213.227l-.351.201a.19.19 0 0 1-.105.04.19.19 0 0 1-.186-.105.194.194 0 0 1-.019-.111v-1.496a.686.686 0 0 1 .31-.535l.351-.201c.167-.1.301-.025.301.168z",
    fill: "#37474F"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M99 271.19v1.513a.673.673 0 0 1-.31.527l-.343.201c-.175.1-.31-.001-.31-.176v-1.505a.669.669 0 0 1 .31-.535l.343-.201a.19.19 0 0 1 .214-.015c.033.018.06.047.076.081a.19.19 0 0 1 .02.11z",
    fill: "url(#aa)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M97.444 272.085v1.513a.653.653 0 0 1-.31.526l-.342.201a.182.182 0 0 1-.104.04.189.189 0 0 1-.187-.105.195.195 0 0 1-.018-.111v-1.504a.689.689 0 0 1 .309-.535l.343-.201c.175-.1.31-.017.31.176z",
    fill: "url(#ab)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "m119.255 236.964-22.856 13.192a3.395 3.395 0 0 0-1.53 2.659v3.101c0 .978.686 1.38 1.53.886l22.856-13.192a3.394 3.394 0 0 0 1.53-2.658v-3.102c0-.986-.685-1.379-1.53-.886z",
    fill: "#455A64"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M119.172 239.589v1.505a.68.68 0 0 1-.309.535l-.343.201c-.176.1-.31 0-.31-.176v-1.505a.671.671 0 0 1 .31-.535l.343-.2a.19.19 0 0 1 .213-.016.194.194 0 0 1 .096.191z",
    fill: "url(#ac)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M117.617 240.484v1.505a.68.68 0 0 1-.31.535l-.342.2a.193.193 0 0 1-.291-.065.198.198 0 0 1-.019-.11v-1.513a.689.689 0 0 1 .31-.527l.342-.201c.176-.1.31-.017.31.176z",
    fill: "url(#ad)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M116.062 241.378v1.505a.68.68 0 0 1-.301.535l-.351.201c-.167.1-.301 0-.301-.176v-1.505a.674.674 0 0 1 .301-.535l.351-.2c.167-.101.301-.017.301.175z",
    fill: "url(#ae)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 242.273v1.505a.68.68 0 0 1-.309.535l-.343.2c-.176.101-.309 0-.309-.175v-1.513a.661.661 0 0 1 .309-.527l.343-.201a.196.196 0 0 1 .213-.016.19.19 0 0 1 .077.082.19.19 0 0 1 .019.11z",
    fill: "url(#af)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M112.96 243.167v1.505a.662.662 0 0 1-.309.535l-.343.201a.196.196 0 0 1-.213.016.194.194 0 0 1-.096-.192v-1.513a.68.68 0 0 1 .309-.527l.343-.2c.209-.101.309-.017.309.175zM111.414 244.062v1.505a.68.68 0 0 1-.31.535l-.351.2c-.167.101-.301 0-.301-.175v-1.513a.667.667 0 0 1 .089-.299.671.671 0 0 1 .212-.228l.351-.201a.196.196 0 0 1 .214-.016.19.19 0 0 1 .077.082.19.19 0 0 1 .019.11z",
    fill: "#37474F"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M109.859 244.948v1.505a.694.694 0 0 1-.31.535l-.342.2a.193.193 0 0 1-.31-.175V245.5a.689.689 0 0 1 .31-.527l.342-.201a.2.2 0 0 1 .105-.04.189.189 0 0 1 .109.025c.033.018.06.047.077.081a.198.198 0 0 1 .019.11z",
    fill: "url(#ag)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M108.304 245.851v1.505a.676.676 0 0 1-.301.535l-.351.2c-.167.101-.301 0-.301-.175v-1.513a.679.679 0 0 1 .301-.527l.351-.201c.167-.1.301-.016.301.176z",
    fill: "url(#ah)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M106.757 246.745v1.547a.68.68 0 0 1-.309.535l-.343.201c-.175.1-.309 0-.309-.176v-1.513a.669.669 0 0 1 .309-.527l.343-.2a.191.191 0 0 1 .273.038.185.185 0 0 1 .036.095z",
    fill: "url(#ai)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M105.202 247.64v1.488a.67.67 0 0 1-.309.535l-.343.201a.196.196 0 0 1-.213.016.19.19 0 0 1-.077-.082.19.19 0 0 1-.019-.11v-1.513a.68.68 0 0 1 .309-.527l.343-.2c.175-.084.309.008.309.192z",
    fill: "#37474F"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M103.664 248.534v1.505a.675.675 0 0 1-.301.535l-.351.201c-.167.1-.301 0-.301-.176v-1.471a.682.682 0 0 1 .301-.527l.351-.2c.15-.109.301-.059.301.133z",
    fill: "url(#aj)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M102.101 249.429v1.505a.694.694 0 0 1-.31.535l-.342.2a.193.193 0 0 1-.31-.175v-1.53a.693.693 0 0 1 .31-.527l.342-.2a.194.194 0 0 1 .11-.044.19.19 0 0 1 .19.119.195.195 0 0 1 .01.117z",
    fill: "url(#ak)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M100.546 250.323v1.505a.676.676 0 0 1-.301.535l-.351.201a.197.197 0 0 1-.214.016.194.194 0 0 1-.096-.192v-1.513a.68.68 0 0 1 .31-.526l.351-.201c.167-.1.301-.017.301.175z",
    fill: "#37474F"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M99 251.218v1.505a.684.684 0 0 1-.31.535l-.343.2c-.175.101-.31 0-.31-.175v-1.513a.672.672 0 0 1 .31-.527l.343-.201a.19.19 0 0 1 .214-.015c.033.018.06.047.076.081a.19.19 0 0 1 .02.11z",
    fill: "url(#al)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M97.444 252.113v1.504a.67.67 0 0 1-.31.535l-.342.201a.19.19 0 0 1-.104.04.189.189 0 0 1-.187-.105.195.195 0 0 1-.018-.111v-1.513a.685.685 0 0 1 .309-.526l.343-.201c.175-.1.31-.017.31.176z",
    fill: "#37474F"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "m119.255 217.017-22.856 13.201a3.392 3.392 0 0 0-1.53 2.658v3.102c0 .978.686 1.379 1.53.886l22.856-13.192a3.397 3.397 0 0 0 1.53-2.659v-3.11c0-.978-.685-1.379-1.53-.886z",
    fill: "#455A64"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M119.172 219.651v1.504a.681.681 0 0 1-.309.535l-.343.201c-.176.1-.31 0-.31-.175v-1.514a.673.673 0 0 1 .31-.526l.343-.201a.196.196 0 0 1 .213-.016.194.194 0 0 1 .096.192z",
    fill: "url(#am)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M117.617 220.545v1.505a.68.68 0 0 1-.31.535l-.342.201a.196.196 0 0 1-.214.016.196.196 0 0 1-.096-.192v-1.513a.693.693 0 0 1 .31-.527l.342-.2c.176-.101.31-.017.31.175z",
    fill: "#37474F"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M116.062 221.44v1.504a.688.688 0 0 1-.301.536l-.351.2c-.167.1-.301 0-.301-.175v-1.514a.678.678 0 0 1 .301-.526l.351-.201c.167-.1.301-.017.301.176z",
    fill: "url(#an)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 222.376v1.505a.68.68 0 0 1-.309.535l-.343.2c-.176.101-.309 0-.309-.175v-1.513a.669.669 0 0 1 .309-.527l.343-.201a.189.189 0 0 1 .213-.015.19.19 0 0 1 .096.191z",
    fill: "url(#ao)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M112.96 223.212v1.505a.673.673 0 0 1-.309.535l-.343.2a.19.19 0 0 1-.213.016.19.19 0 0 1-.096-.191v-1.513a.68.68 0 0 1 .309-.527l.343-.201c.209-.083.309 0 .309.176z",
    fill: "url(#ap)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M111.414 224.123v1.505a.68.68 0 0 1-.31.535l-.351.201c-.167.1-.301 0-.301-.176v-1.513a.69.69 0 0 1 .301-.527l.351-.2a.193.193 0 0 1 .31.175zM109.859 225.018v1.538a.694.694 0 0 1-.31.535l-.342.201a.196.196 0 0 1-.214.016.196.196 0 0 1-.096-.192v-1.513a.693.693 0 0 1 .31-.527l.309-.192a.196.196 0 0 1 .1-.067.195.195 0 0 1 .243.201z",
    fill: "#37474F"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M108.304 225.912v1.48a.676.676 0 0 1-.301.535l-.351.201c-.167.1-.301 0-.301-.176v-1.513a.682.682 0 0 1 .301-.527l.351-.2c.167-.076.301.008.301.2z",
    fill: "url(#aq)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M106.757 226.807v1.505a.68.68 0 0 1-.309.535l-.343.2c-.175.101-.309 0-.309-.175v-1.48a.658.658 0 0 1 .309-.527l.343-.2a.189.189 0 0 1 .096-.039.2.2 0 0 1 .102.016.195.195 0 0 1 .111.165z",
    fill: "#37474F"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M105.202 227.701v1.505a.674.674 0 0 1-.309.535l-.343.201a.196.196 0 0 1-.213.016.195.195 0 0 1-.096-.192v-1.538a.68.68 0 0 1 .309-.527l.343-.2c.175-.109.309.008.309.2z",
    fill: "url(#ar)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M103.664 228.596v1.505a.674.674 0 0 1-.301.535l-.351.2c-.167.101-.301 0-.301-.175v-1.513a.679.679 0 0 1 .301-.527l.351-.201c.15-.1.301-.016.301.176z",
    fill: "url(#as)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M102.101 229.49v1.505a.698.698 0 0 1-.091.305.698.698 0 0 1-.219.23l-.342.201a.193.193 0 0 1-.265-.064.195.195 0 0 1-.028-.095v-1.513a.675.675 0 0 1 .309-.527l.343-.2a.192.192 0 0 1 .095-.029.182.182 0 0 1 .097.024.192.192 0 0 1 .101.163z",
    fill: "url(#at)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M100.546 230.385v1.505a.676.676 0 0 1-.301.535l-.351.2a.19.19 0 0 1-.29-.065.19.19 0 0 1-.02-.11v-1.513a.682.682 0 0 1 .31-.527l.351-.201c.167-.1.301-.016.301.176z",
    fill: "#37474F"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M99 231.279v1.505a.688.688 0 0 1-.31.535l-.343.201c-.175.1-.31 0-.31-.176v-1.513a.656.656 0 0 1 .31-.527l.343-.2a.19.19 0 0 1 .29.065.192.192 0 0 1 .02.11z",
    fill: "url(#au)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M97.444 232.174v1.505a.669.669 0 0 1-.31.535l-.342.2a.19.19 0 0 1-.29-.065.191.191 0 0 1-.02-.11v-1.513a.682.682 0 0 1 .31-.527l.343-.201c.175-.1.31-.016.31.176z",
    fill: "url(#av)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "m119.255 197.028-22.856 13.193a3.395 3.395 0 0 0-1.53 2.658v3.11c0 .978.686 1.379 1.53.886l22.856-13.192a3.394 3.394 0 0 0 1.53-2.658v-3.11c0-.978-.685-1.371-1.53-.887z",
    fill: "#455A64"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M119.172 199.662v1.505a.705.705 0 0 1-.309.535l-.343.2c-.176.092-.31 0-.31-.184v-1.504a.681.681 0 0 1 .31-.535l.343-.193c.167-.1.309-.025.309.176z",
    fill: "url(#aw)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M117.617 200.556v1.505a.696.696 0 0 1-.309.535l-.343.201c-.167.092-.309 0-.309-.184v-1.505a.704.704 0 0 1 .309-.535l.343-.192c.175-.1.309-.025.309.175z",
    fill: "#37474F"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M116.062 201.476v1.505a.695.695 0 0 1-.301.535l-.351.2c-.167.092-.301 0-.301-.183v-1.505a.7.7 0 0 1 .301-.535l.351-.193c.167-.125.301-.05.301.176z",
    fill: "url(#ax)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 202.312v1.505a.692.692 0 0 1-.093.303.695.695 0 0 1-.216.232l-.343.2c-.176.092-.309 0-.309-.183v-1.505a.667.667 0 0 1 .309-.535l.343-.193c.15-.066.309.009.309.176z",
    fill: "url(#ay)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M112.96 203.24v1.505a.671.671 0 0 1-.309.535l-.343.192c-.167.1-.309 0-.309-.175v-1.505a.696.696 0 0 1 .309-.535l.343-.193c.209-.1.309-.025.309.176z",
    fill: "url(#az)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M111.414 204.134v1.522a.701.701 0 0 1-.31.535l-.351.192c-.167.101-.301 0-.301-.175v-1.505a.703.703 0 0 1 .301-.535l.351-.192c.168-.117.31-.042.31.158zM109.859 205.029v1.505a.705.705 0 0 1-.309.535l-.343.192c-.167.1-.31 0-.31-.175v-1.505a.71.71 0 0 1 .31-.535l.309-.226c.201-.067.343 0 .343.209z",
    fill: "#37474F"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M108.304 205.924v1.504a.7.7 0 0 1-.301.535l-.351.193c-.167.1-.301 0-.301-.176v-1.488a.703.703 0 0 1 .301-.535l.351-.192c.167-.109.301-.042.301.159z",
    fill: "url(#aA)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M106.757 206.818v1.505a.704.704 0 0 1-.309.535l-.343.192c-.175.1-.309 0-.309-.175v-1.505a.667.667 0 0 1 .309-.535l.343-.193c.167-.1.309-.025.309.176z",
    fill: "#37474F"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M105.202 207.713v1.504a.667.667 0 0 1-.309.535l-.343.193c-.167.1-.309 0-.309-.176v-1.505a.692.692 0 0 1 .093-.303.695.695 0 0 1 .216-.232l.343-.192c.176-.1.309-.025.309.176z",
    fill: "url(#aB)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M103.664 208.607v1.505a.695.695 0 0 1-.301.535l-.351.192c-.167.101-.301 0-.301-.175v-1.505a.703.703 0 0 1 .301-.535l.351-.192c.15-.101.301-.026.301.175z",
    fill: "url(#aC)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M102.101 209.502v1.504a.71.71 0 0 1-.31.535l-.342.193c-.167.1-.31 0-.31-.176v-1.505a.705.705 0 0 1 .31-.535l.342-.192c.201-.1.31-.025.31.176z",
    fill: "url(#aD)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M100.546 210.396v1.505a.703.703 0 0 1-.301.535l-.352.192c-.167.101-.309 0-.309-.175v-1.505a.698.698 0 0 1 .31-.535l.351-.192c.167-.101.301-.026.301.175z",
    fill: "#37474F"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M99 211.291v1.504a.705.705 0 0 1-.31.535l-.343.193c-.175.1-.31 0-.31-.176v-1.505a.675.675 0 0 1 .31-.535l.343-.192c.167-.1.31-.025.31.176z",
    fill: "url(#aE)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M97.444 212.185v1.505a.679.679 0 0 1-.31.535l-.342.192c-.167.101-.31 0-.31-.175v-1.505a.697.697 0 0 1 .31-.535l.343-.192c.175-.101.31-.025.31.175z",
    fill: "url(#aF)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "m119.255 177.073-22.856 13.192a3.414 3.414 0 0 0-1.53 2.659v3.11c0 .978.686 1.371 1.53.886l22.856-13.192a3.4 3.4 0 0 0 1.53-2.659v-3.11c0-.978-.685-1.379-1.53-.886z",
    fill: "#455A64"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M119.172 179.74v1.505a.705.705 0 0 1-.309.535l-.343.192c-.176.1-.31 0-.31-.175v-1.505a.681.681 0 0 1 .31-.535l.343-.201c.167-.125.309-.05.309.184z",
    fill: "#37474F"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M117.617 180.576v1.505a.692.692 0 0 1-.093.303.695.695 0 0 1-.216.232l-.343.192c-.167.1-.309 0-.309-.175v-1.505a.705.705 0 0 1 .309-.535l.343-.201c.175-.067.309.008.309.184z",
    fill: "url(#aG)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M116.062 181.496V183a.7.7 0 0 1-.301.535l-.351.193c-.167.1-.301 0-.301-.176v-1.505a.699.699 0 0 1 .301-.535l.351-.2c.167-.092.301-.017.301.184zM114.532 182.39v1.53a.688.688 0 0 1-.093.303.695.695 0 0 1-.216.232l-.343.192c-.176.101-.309 0-.309-.175v-1.505a.671.671 0 0 1 .309-.535l.343-.201c.15-.117.309-.042.309.159zM112.96 183.285v1.471a.671.671 0 0 1-.309.535l-.343.192c-.167.101-.309 0-.309-.175v-1.505a.688.688 0 0 1 .093-.303.695.695 0 0 1 .216-.232l.343-.201c.209-.058.309.017.309.218z",
    fill: "#37474F"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M111.414 184.179v1.505a.701.701 0 0 1-.31.535l-.351.192c-.167.101-.301 0-.301-.175v-1.48a.703.703 0 0 1 .301-.535l.351-.201c.168-.1.31-.041.31.159z",
    fill: "url(#aH)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M109.859 185.074v1.504a.696.696 0 0 1-.309.536l-.343.192c-.167.1-.31 0-.31-.176v-1.538a.701.701 0 0 1 .31-.535l.343-.201c.167-.058.309.017.309.218z",
    fill: "url(#aI)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M108.304 185.968v1.505a.703.703 0 0 1-.301.535l-.351.192c-.167.101-.301 0-.301-.175v-1.505a.703.703 0 0 1 .301-.535l.351-.201c.167-.092.301-.016.301.184z",
    fill: "#37474F"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M106.757 186.863v1.505a.708.708 0 0 1-.309.535l-.343.192c-.175.1-.309 0-.309-.176v-1.505a.67.67 0 0 1 .309-.535l.343-.2c.167-.092.309-.017.309.184z",
    fill: "url(#aJ)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M105.202 187.757v1.505a.671.671 0 0 1-.309.535l-.343.192c-.167.101-.309 0-.309-.175v-1.505a.688.688 0 0 1 .093-.303.695.695 0 0 1 .216-.232l.343-.201c.176-.092.309-.016.309.184zM103.664 188.652v1.505a.699.699 0 0 1-.301.535l-.351.192c-.167.1-.301 0-.301-.176v-1.504a.675.675 0 0 1 .301-.536l.351-.2c.15-.092.301-.017.301.184zM102.101 189.546v1.505a.675.675 0 0 1-.31.527l-.342.2c-.167.101-.31 0-.31-.175v-1.505a.694.694 0 0 1 .31-.535l.342-.201c.201-.092.31-.016.31.184z",
    fill: "#37474F"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M100.546 190.441v1.505a.662.662 0 0 1-.301.526l-.352.201c-.167.1-.309 0-.309-.176v-1.504a.685.685 0 0 1 .31-.535l.351-.201c.167-.092.301-.017.301.184z",
    fill: "url(#aK)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M99 191.335v1.505a.705.705 0 0 1-.31.535l-.343.192c-.175.101-.31 0-.31-.175v-1.505a.669.669 0 0 1 .31-.535l.343-.201c.167-.092.31-.016.31.184zM97.444 192.23v1.505a.648.648 0 0 1-.31.526l-.342.201c-.167.1-.31 0-.31-.176v-1.504a.685.685 0 0 1 .31-.535l.343-.201c.175-.092.31-.017.31.184z",
    fill: "#37474F"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "m90.781 295.76-.702-.401a.957.957 0 0 0-.936.1 2.939 2.939 0 0 0-1.338 2.307.952.952 0 0 0 .393.836l.652.377.117-.201c.136-.029.265-.08.385-.15a2.967 2.967 0 0 0 1.337-2.308 1.426 1.426 0 0 0 0-.343l.092-.217z",
    fill: "url(#aL)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m90.781 295.76-.702-.401a.957.957 0 0 0-.936.1 2.939 2.939 0 0 0-1.338 2.307.952.952 0 0 0 .393.836l.652.377.117-.201c.136-.029.265-.08.385-.15a2.967 2.967 0 0 0 1.337-2.308 1.426 1.426 0 0 0 0-.343l.092-.217z",
    fill: "#000"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M89.811 295.835a2.948 2.948 0 0 0-1.337 2.316c0 .836.593 1.196 1.337.769a2.945 2.945 0 0 0 1.313-2.307c0-.853-.577-1.204-1.313-.778z",
    fill: "url(#aM)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.811 295.835a2.948 2.948 0 0 0-1.337 2.316c0 .836.593 1.196 1.337.769a2.945 2.945 0 0 0 1.313-2.307c0-.853-.577-1.204-1.313-.778z",
    fill: "#000"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m84.988 299.104-.702-.401a.928.928 0 0 0-.937.1 2.954 2.954 0 0 0-1.337 2.307.93.93 0 0 0 .393.836l.652.368.117-.192c.134-.033.263-.084.384-.15a2.957 2.957 0 0 0 1.338-2.316 1.36 1.36 0 0 0-.042-.335l.134-.217z",
    fill: "url(#aN)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m84.988 299.104-.702-.401a.928.928 0 0 0-.937.1 2.954 2.954 0 0 0-1.337 2.307.93.93 0 0 0 .393.836l.652.368.117-.192c.134-.033.263-.084.384-.15a2.957 2.957 0 0 0 1.338-2.316 1.36 1.36 0 0 0-.042-.335l.134-.217z",
    fill: "#000"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M84.018 299.179a2.963 2.963 0 0 0-1.338 2.316c0 .836.602 1.196 1.338.769a2.942 2.942 0 0 0 1.33-2.316c0-.844-.594-1.195-1.33-.769z",
    fill: "url(#aO)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.018 299.179a2.963 2.963 0 0 0-1.338 2.316c0 .836.602 1.196 1.338.769a2.942 2.942 0 0 0 1.33-2.316c0-.844-.594-1.195-1.33-.769z",
    fill: "#000"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "m90.781 275.805-.702-.402a.935.935 0 0 0-.936.092 2.939 2.939 0 0 0-1.338 2.308.956.956 0 0 0 .393.836l.652.376.117-.201c.136-.029.265-.08.385-.15a2.954 2.954 0 0 0 1.337-2.307 1.426 1.426 0 0 0 0-.343l.092-.209z",
    fill: "url(#aP)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m90.781 275.805-.702-.402a.935.935 0 0 0-.936.092 2.939 2.939 0 0 0-1.338 2.308.956.956 0 0 0 .393.836l.652.376.117-.201c.136-.029.265-.08.385-.15a2.954 2.954 0 0 0 1.337-2.307 1.426 1.426 0 0 0 0-.343l.092-.209z",
    fill: "#000"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M89.811 275.88a2.91 2.91 0 0 0-1.337 2.307c0 .836.593 1.196 1.337.769a2.944 2.944 0 0 0 1.33-2.307c-.017-.844-.594-1.187-1.33-.769z",
    fill: "url(#aQ)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.811 275.88a2.91 2.91 0 0 0-1.337 2.307c0 .836.593 1.196 1.337.769a2.944 2.944 0 0 0 1.33-2.307c-.017-.844-.594-1.187-1.33-.769z",
    fill: "#000"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "m84.988 279.149-.702-.402a.957.957 0 0 0-.937.101 2.955 2.955 0 0 0-1.337 2.307.955.955 0 0 0 .393.836l.652.376.117-.2a1.33 1.33 0 0 0 .384-.151 2.955 2.955 0 0 0 1.338-2.307c0-.116-.014-.231-.042-.343l.134-.217z",
    fill: "url(#aR)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m84.988 279.149-.702-.402a.957.957 0 0 0-.937.101 2.955 2.955 0 0 0-1.337 2.307.955.955 0 0 0 .393.836l.652.376.117-.2a1.33 1.33 0 0 0 .384-.151 2.955 2.955 0 0 0 1.338-2.307c0-.116-.014-.231-.042-.343l.134-.217z",
    fill: "#000"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M84.018 279.224a2.963 2.963 0 0 0-1.338 2.316c0 .836.602 1.195 1.338.769a2.956 2.956 0 0 0 1.33-2.308c0-.852-.594-1.203-1.33-.777z",
    fill: "url(#aS)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.018 279.224a2.963 2.963 0 0 0-1.338 2.316c0 .836.602 1.195 1.338.769a2.956 2.956 0 0 0 1.33-2.308c0-.852-.594-1.203-1.33-.777z",
    fill: "#000"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "m90.781 255.858-.702-.41a.935.935 0 0 0-.936.092 2.948 2.948 0 0 0-1.338 2.316.944.944 0 0 0 .393.836l.652.376.117-.201c.137-.025.267-.076.385-.15a2.953 2.953 0 0 0 1.337-2.307 1.426 1.426 0 0 0 0-.343l.092-.209z",
    fill: "url(#aT)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m90.781 255.858-.702-.41a.935.935 0 0 0-.936.092 2.948 2.948 0 0 0-1.338 2.316.944.944 0 0 0 .393.836l.652.376.117-.201c.137-.025.267-.076.385-.15a2.953 2.953 0 0 0 1.337-2.307 1.426 1.426 0 0 0 0-.343l.092-.209z",
    fill: "#000"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M89.811 255.933a2.91 2.91 0 0 0-1.337 2.307c0 .836.593 1.196 1.337.77a2.951 2.951 0 0 0 1.33-2.308c-.017-.886-.594-1.195-1.33-.769z",
    fill: "url(#aU)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.811 255.933a2.91 2.91 0 0 0-1.337 2.307c0 .836.593 1.196 1.337.77a2.951 2.951 0 0 0 1.33-2.308c-.017-.886-.594-1.195-1.33-.769z",
    fill: "#000"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "m84.988 259.16-.702-.401a.925.925 0 0 0-.937.092 2.955 2.955 0 0 0-1.337 2.307.955.955 0 0 0 .393.836l.652.376.117-.2a1.33 1.33 0 0 0 .384-.151 2.944 2.944 0 0 0 1.338-2.307c0-.116-.014-.231-.042-.343l.134-.209z",
    fill: "url(#aV)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m84.988 259.16-.702-.401a.925.925 0 0 0-.937.092 2.955 2.955 0 0 0-1.337 2.307.955.955 0 0 0 .393.836l.652.376.117-.2a1.33 1.33 0 0 0 .384-.151 2.944 2.944 0 0 0 1.338-2.307c0-.116-.014-.231-.042-.343l.134-.209z",
    fill: "#000"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M84.018 259.269a2.963 2.963 0 0 0-1.338 2.315c0 .836.602 1.196 1.338.77a2.956 2.956 0 0 0 1.33-2.308c0-.886-.594-1.195-1.33-.777z",
    fill: "url(#aW)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.018 259.269a2.963 2.963 0 0 0-1.338 2.315c0 .836.602 1.196 1.338.77a2.956 2.956 0 0 0 1.33-2.308c0-.886-.594-1.195-1.33-.777z",
    fill: "#000"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "m90.781 235.902-.702-.409a.925.925 0 0 0-.936.092 2.939 2.939 0 0 0-1.338 2.316.946.946 0 0 0 .393.836l.652.376.117-.201c.137-.026.267-.077.385-.15a2.953 2.953 0 0 0 1.337-2.308 1.426 1.426 0 0 0 0-.343l.092-.209z",
    fill: "url(#aX)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m90.781 235.902-.702-.409a.925.925 0 0 0-.936.092 2.939 2.939 0 0 0-1.338 2.316.946.946 0 0 0 .393.836l.652.376.117-.201c.137-.026.267-.077.385-.15a2.953 2.953 0 0 0 1.337-2.308 1.426 1.426 0 0 0 0-.343l.092-.209z",
    fill: "#000"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M89.811 235.978a2.925 2.925 0 0 0-1.337 2.307c0 .836.593 1.196 1.337.769a2.942 2.942 0 0 0 1.33-2.307c-.017-.853-.594-1.196-1.33-.769z",
    fill: "url(#aY)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.811 235.978a2.925 2.925 0 0 0-1.337 2.307c0 .836.593 1.196 1.337.769a2.942 2.942 0 0 0 1.33-2.307c-.017-.853-.594-1.196-1.33-.769z",
    fill: "#000"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "m84.988 239.238-.702-.401a.925.925 0 0 0-.937.092 2.955 2.955 0 0 0-1.337 2.307.955.955 0 0 0 .393.836l.652.376.117-.2c.135-.03.265-.08.384-.151a2.944 2.944 0 0 0 1.338-2.307c0-.116-.014-.231-.042-.343l.134-.209z",
    fill: "url(#aZ)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m84.988 239.238-.702-.401a.925.925 0 0 0-.937.092 2.955 2.955 0 0 0-1.337 2.307.955.955 0 0 0 .393.836l.652.376.117-.2c.135-.03.265-.08.384-.151a2.944 2.944 0 0 0 1.338-2.307c0-.116-.014-.231-.042-.343l.134-.209z",
    fill: "#000"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M84.018 239.322a2.929 2.929 0 0 0-1.338 2.282c0 .836.602 1.195 1.338.769a2.944 2.944 0 0 0 1.33-2.307c0-.828-.594-1.171-1.33-.744z",
    fill: "url(#ba)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.018 239.322a2.929 2.929 0 0 0-1.338 2.282c0 .836.602 1.195 1.338.769a2.944 2.944 0 0 0 1.33-2.307c0-.828-.594-1.171-1.33-.744z",
    fill: "#000"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "m90.781 215.905-.702-.401a.95.95 0 0 0-.936.1 2.93 2.93 0 0 0-1.338 2.308.929.929 0 0 0 .393.836l.652.368.117-.193c.134-.033.264-.083.385-.15a2.958 2.958 0 0 0 1.337-2.308 1.369 1.369 0 0 0 0-.342l.092-.218z",
    fill: "url(#bb)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m90.781 215.905-.702-.401a.95.95 0 0 0-.936.1 2.93 2.93 0 0 0-1.338 2.308.929.929 0 0 0 .393.836l.652.368.117-.193c.134-.033.264-.083.385-.15a2.958 2.958 0 0 0 1.337-2.308 1.369 1.369 0 0 0 0-.342l.092-.218z",
    fill: "#000"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M89.811 215.981a2.939 2.939 0 0 0-1.337 2.315c0 .836.593 1.196 1.337.769a2.949 2.949 0 0 0 1.33-2.315c-.017-.845-.594-1.196-1.33-.769z",
    fill: "url(#bc)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.811 215.981a2.939 2.939 0 0 0-1.337 2.315c0 .836.593 1.196 1.337.769a2.949 2.949 0 0 0 1.33-2.315c-.017-.845-.594-1.196-1.33-.769z",
    fill: "#000"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "m84.988 219.249-.702-.409a.928.928 0 0 0-.937.1 2.954 2.954 0 0 0-1.337 2.307.93.93 0 0 0 .393.836l.652.377.117-.193c.134-.033.263-.083.384-.15a2.963 2.963 0 0 0 1.338-2.316c0-.113-.014-.225-.042-.334l.134-.218z",
    fill: "url(#bd)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m84.988 219.249-.702-.409a.928.928 0 0 0-.937.1 2.954 2.954 0 0 0-1.337 2.307.93.93 0 0 0 .393.836l.652.377.117-.193c.134-.033.263-.083.384-.15a2.963 2.963 0 0 0 1.338-2.316c0-.113-.014-.225-.042-.334l.134-.218z",
    fill: "#000"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M84.018 219.325a2.953 2.953 0 0 0-1.338 2.315c0 .836.602 1.196 1.338.769a2.948 2.948 0 0 0 1.33-2.315c0-.845-.594-1.196-1.33-.769z",
    fill: "url(#be)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.018 219.325a2.953 2.953 0 0 0-1.338 2.315c0 .836.602 1.196 1.338.769a2.948 2.948 0 0 0 1.33-2.315c0-.845-.594-1.196-1.33-.769z",
    fill: "#000"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "m90.781 195.958-.702-.409a.928.928 0 0 0-.936.1 2.91 2.91 0 0 0-1.338 2.307.934.934 0 0 0 .393.836l.652.377.117-.193c.134-.033.264-.083.385-.15a2.963 2.963 0 0 0 1.337-2.316 1.352 1.352 0 0 0 0-.334l.092-.218z",
    fill: "url(#bf)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m90.781 195.958-.702-.409a.928.928 0 0 0-.936.1 2.91 2.91 0 0 0-1.338 2.307.934.934 0 0 0 .393.836l.652.377.117-.193c.134-.033.264-.083.385-.15a2.963 2.963 0 0 0 1.337-2.316 1.352 1.352 0 0 0 0-.334l.092-.218z",
    fill: "#000"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M89.811 196.034a2.939 2.939 0 0 0-1.337 2.315c0 .836.593 1.196 1.337.769a2.949 2.949 0 0 0 1.33-2.315c-.017-.853-.594-1.179-1.33-.769z",
    fill: "url(#bg)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.811 196.034a2.939 2.939 0 0 0-1.337 2.315c0 .836.593 1.196 1.337.769a2.949 2.949 0 0 0 1.33-2.315c-.017-.853-.594-1.179-1.33-.769z",
    fill: "#000"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m84.988 199.302-.703-.409a.944.944 0 0 0-.936.092 2.963 2.963 0 0 0-1.338 2.315.936.936 0 0 0 .393.836l.653.377.117-.201a1.26 1.26 0 0 0 .384-.142 2.963 2.963 0 0 0 1.338-2.316c0-.115-.015-.23-.042-.343l.134-.209z",
    fill: "url(#bh)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m84.988 199.302-.703-.409a.944.944 0 0 0-.936.092 2.963 2.963 0 0 0-1.338 2.315.936.936 0 0 0 .393.836l.653.377.117-.201a1.26 1.26 0 0 0 .384-.142 2.963 2.963 0 0 0 1.338-2.316c0-.115-.015-.23-.042-.343l.134-.209z",
    fill: "#000"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M84.018 199.378a2.954 2.954 0 0 0-1.338 2.307c0 .836.602 1.195 1.338.777a2.948 2.948 0 0 0 1.33-2.315c0-.853-.594-1.179-1.33-.769z",
    fill: "url(#bi)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.018 199.378a2.954 2.954 0 0 0-1.338 2.307c0 .836.602 1.195 1.338.777a2.948 2.948 0 0 0 1.33-2.315c0-.853-.594-1.179-1.33-.769z",
    fill: "#000"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "m46.607 241.888 26.259 15.149a1.9 1.9 0 0 1 .836 1.479v7.248c0 .544-.385.761-.836.494l-26.259-15.149a1.881 1.881 0 0 1-.836-1.471v-7.257c-.017-.543.368-.777.836-.493z",
    fill: "#455A64"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 245.09a1.845 1.845 0 0 0 .836 1.413l23.065 13.301c.469.267.836.075.836-.435a1.823 1.823 0 0 0-.836-1.404l-23.048-13.31c-.468-.267-.853-.075-.853.435z",
    fill: "url(#bj)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 248.777a1.845 1.845 0 0 0 .836 1.413l23.065 13.3c.469.268.836.076.836-.434a1.85 1.85 0 0 0-.836-1.413l-23.048-13.301c-.468-.267-.853-.05-.853.435z",
    fill: "#263238"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "m48.204 248.342 12.74 7.349v1.839l-12.74-7.34a1.848 1.848 0 0 1-.836-1.413c-.017-.485.368-.702.836-.435z",
    fill: "url(#bk)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m46.607 261.894 26.259 15.14a1.9 1.9 0 0 1 .836 1.479v7.249c0 .543-.385.76-.836.493l-26.259-15.149a1.878 1.878 0 0 1-.836-1.471v-7.256c-.017-.544.368-.761.836-.485z",
    fill: "#455A64"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 265.087a1.84 1.84 0 0 0 .836 1.413l23.065 13.301c.469.276.836.083.836-.427a1.819 1.819 0 0 0-.836-1.412l-23.048-13.309c-.468-.268-.853-.076-.853.434z",
    fill: "url(#bl)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 268.774a1.84 1.84 0 0 0 .836 1.413l23.082 13.301c.468.275.836.075.836-.427a1.827 1.827 0 0 0-.836-1.413l-23.065-13.292c-.468-.284-.853-.092-.853.418z",
    fill: "#263238"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "m48.204 268.356 15.934 9.196v1.848l-15.934-9.196a1.845 1.845 0 0 1-.836-1.413c-.017-.527.368-.719.836-.435z",
    fill: "url(#bm)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "m46.607 281.732 26.259 15.148a1.915 1.915 0 0 1 .836 1.472v7.256c0 .544-.385.761-.836.493l-26.259-15.173a1.9 1.9 0 0 1-.836-1.48v-7.214c-.017-.502.368-.761.836-.502z",
    fill: "#455A64"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 284.942a1.85 1.85 0 0 0 .836 1.413l23.065 13.301c.469.267.836.075.836-.435a1.845 1.845 0 0 0-.836-1.413l-23.048-13.3c-.468-.268-.853-.076-.853.434z",
    fill: "url(#bn)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 288.629a1.845 1.845 0 0 0 .836 1.413l23.065 13.301c.469.267.836.075.836-.435a1.845 1.845 0 0 0-.836-1.413l-23.048-13.301c-.468-.267-.853-.075-.853.435z",
    fill: "#263238"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "m48.204 288.194 19.127 11.027v1.848l-19.127-11.027a1.848 1.848 0 0 1-.836-1.413c-.017-.51.368-.702.836-.435z",
    fill: "url(#bo)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "m46.607 222.083 26.259 15.149a1.896 1.896 0 0 1 .836 1.471v7.257c0 .543-.385.76-.836.493l-26.259-15.149a1.89 1.89 0 0 1-.836-1.479v-7.248c-.017-.544.368-.761.836-.494z",
    fill: "#455A64"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 225.285a1.85 1.85 0 0 0 .836 1.413l23.065 13.301c.469.267.836.075.836-.435a1.845 1.845 0 0 0-.836-1.413l-23.048-13.267c-.468-.301-.853-.109-.853.401z",
    fill: "url(#bp)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 228.964a1.827 1.827 0 0 0 .836 1.413l23.065 13.309c.469.267.836.075.836-.435a1.84 1.84 0 0 0-.836-1.413l-23.048-13.301c-.468-.267-.853-.075-.853.427z",
    fill: "#263238"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "m48.204 228.537 20.724 11.955v1.839l-20.724-11.954a1.83 1.83 0 0 1-.836-1.413c-.017-.502.368-.694.836-.427z",
    fill: "url(#bq)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "m46.607 182.131 26.259 15.165a1.866 1.866 0 0 1 .836 1.471v7.257c0 .535-.385.761-.836.485l-26.259-15.165a1.865 1.865 0 0 1-.836-1.472v-7.248c-.017-.543.368-.761.836-.493z",
    fill: "#455A64"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 185.324a1.82 1.82 0 0 0 .836 1.413l23.065 13.309c.469.268.836.076.836-.434a1.84 1.84 0 0 0-.836-1.413l-23.048-13.301c-.468-.276-.853-.083-.853.426z",
    fill: "url(#br)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 189.011a1.82 1.82 0 0 0 .836 1.413l23.082 13.309c.468.268.836.075.836-.435a1.835 1.835 0 0 0-.836-1.412l-23.065-13.301c-.468-.276-.853-.084-.853.426z",
    fill: "#263238"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "m48.204 188.585 15.934 9.196v1.839l-15.934-9.196a1.82 1.82 0 0 1-.836-1.413c-.017-.51.368-.702.836-.426z",
    fill: "url(#bs)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m46.607 202.095 26.259 15.148a1.866 1.866 0 0 1 .836 1.471v7.248c0 .544-.385.77-.836.494l-26.259-15.149a1.862 1.862 0 0 1-.836-1.471v-7.248c-.017-.544.368-.761.836-.493z",
    fill: "#455A64"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 205.288a1.82 1.82 0 0 0 .836 1.413l23.065 13.309c.469.268.836.075.836-.435a1.835 1.835 0 0 0-.836-1.412l-23.048-13.301c-.468-.276-.853-.042-.853.426z",
    fill: "url(#bt)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M47.351 209a1.827 1.827 0 0 0 .836 1.413l23.065 13.301c.469.275.836.083.836-.427a1.827 1.827 0 0 0-.836-1.413l-23.048-13.325c-.468-.276-.853-.084-.853.451z",
    fill: "#263238"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "m48.204 208.549 20.724 11.946v1.881l-20.724-11.955a1.811 1.811 0 0 1-.836-1.413c-.017-.543.368-.735.836-.459z",
    fill: "url(#bu)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m78.668 189.162 30.848-17.782a1.753 1.753 0 0 0 .836-1.379v-1.037a1.786 1.786 0 0 0-.836-1.388l-30.848-17.848a1.785 1.785 0 0 0-1.597 0l-30.857 17.815a1.765 1.765 0 0 0-.836 1.388v1.036a1.74 1.74 0 0 0 .836 1.38l30.857 17.815a1.798 1.798 0 0 0 1.597 0z",
    fill: "url(#bv)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "m78.668 189.162 30.848-17.782a1.753 1.753 0 0 0 .836-1.379v-1.037a1.786 1.786 0 0 0-.836-1.388l-30.848-17.848a1.785 1.785 0 0 0-1.597 0l-30.857 17.815a1.765 1.765 0 0 0-.836 1.388v1.036a1.74 1.74 0 0 0 .836 1.38l30.857 17.815a1.798 1.798 0 0 0 1.597 0z",
    fill: "#000"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "m109.516 168.462-30.848 17.816a1.746 1.746 0 0 1-1.597 0l-30.857-17.816c-.443-.25-.443-.66 0-.919l30.857-17.815a1.785 1.785 0 0 1 1.597 0l30.848 17.815c.443.259.443.669 0 .919z",
    fill: "url(#bw)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M77.865 186.47v2.884c.29.01.579-.057.836-.192l30.815-17.782a1.753 1.753 0 0 0 .836-1.379v-1.045a1.8 1.8 0 0 0-.652-1.279c.284.259.242.601-.151.836l-30.882 17.765c-.245.133-.522.2-.802.192z",
    fill: "url(#bx)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.865 186.47v2.884c.29.01.579-.057.836-.192l30.815-17.782a1.753 1.753 0 0 0 .836-1.379v-1.045a1.8 1.8 0 0 0-.652-1.279c.284.259.242.601-.151.836l-30.882 17.765c-.245.133-.522.2-.802.192z",
    fill: "#000"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "m78.668 180.517 20.9-12.055a1.738 1.738 0 0 0 .836-1.379v-1.037a1.779 1.779 0 0 0-.836-1.387l-13.376-7.725a5.366 5.366 0 0 1-1.346-1.196l-6.43-8.602a1.055 1.055 0 0 0-1.346-.276l-20.899 12.047a1.772 1.772 0 0 0-.836 1.379v6.805a1.746 1.746 0 0 0 .836 1.38l20.9 12.055a1.797 1.797 0 0 0 1.597-.009z",
    fill: "#263238"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m77.07 177.633-13.375-7.724a4.799 4.799 0 0 1-.694-.519 4.422 4.422 0 0 1-.652-.685l-6.387-8.603a.836.836 0 0 1 .242-1.203l20.9-12.047a1.05 1.05 0 0 1 1.346.276l6.387 8.61c.336.485.755.907 1.237 1.246l13.46 7.708a.49.49 0 0 1 .326.464.493.493 0 0 1-.326.464l-20.9 12.047a1.788 1.788 0 0 1-1.563-.034z",
    fill: "#455A64"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m56.196 158.899 20.9-12.047a1.05 1.05 0 0 1 1.346.276l6.387 8.61c.197.245.415.471.652.678L62.993 169.39a4.422 4.422 0 0 1-.652-.685l-6.388-8.603a.836.836 0 0 1 .243-1.203z",
    fill: "#37474F"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M94.468 164.876a2.06 2.06 0 0 0-1.873 0c-.518.293-.518.777 0 1.078a2.047 2.047 0 0 0 1.873 0c.518-.301.518-.785 0-1.078z",
    fill: "url(#by)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M89.787 168.337c.729 0 1.32-.341 1.32-.761s-.591-.761-1.32-.761c-.73 0-1.321.341-1.321.761s.591.761 1.32.761z",
    fill: "url(#bz)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M86.05 170.494c.729 0 1.32-.341 1.32-.761s-.591-.761-1.32-.761c-.73 0-1.322.341-1.322.761s.592.761 1.321.761zM83.24 171.38a2.113 2.113 0 0 0-1.872 0 .58.58 0 0 0-.278.876.58.58 0 0 0 .278.211 2.111 2.111 0 0 0 1.873 0 .58.58 0 0 0 .277-.876.58.58 0 0 0-.277-.211z",
    fill: "#263238"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M90.723 164.55c.73 0 1.32-.341 1.32-.761s-.59-.761-1.32-.761c-.73 0-1.321.341-1.321.761s.591.761 1.32.761z",
    fill: "url(#bA)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M87.922 165.411a2.112 2.112 0 0 0-1.873 0 .58.58 0 0 0-.277.876.58.58 0 0 0 .277.211 2.112 2.112 0 0 0 1.873 0 .58.58 0 0 0 .278-.876.58.58 0 0 0-.278-.211z",
    fill: "#263238"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M83.24 168.88c.73 0 1.321-.34 1.321-.76 0-.421-.59-.761-1.32-.761-.73 0-1.321.34-1.321.761 0 .42.591.76 1.32.76z",
    fill: "url(#bB)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M80.431 169.708a2.111 2.111 0 0 0-1.847 0 .58.58 0 0 0-.278.876.58.58 0 0 0 .278.211 2.111 2.111 0 0 0 1.873 0 .578.578 0 0 0-.025-1.087zM88.85 161.632a2.041 2.041 0 0 0-1.864 0 .568.568 0 0 0 0 1.079 2.041 2.041 0 0 0 1.864 0 .568.568 0 0 0 0-1.079z",
    fill: "#263238"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M85.113 163.789a2.111 2.111 0 0 0-1.873 0 .58.58 0 0 0-.277.876.58.58 0 0 0 .278.211 2.111 2.111 0 0 0 1.872 0 .579.579 0 0 0 .278-.876.579.579 0 0 0-.278-.211z",
    fill: "url(#bC)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M81.368 165.954a2.058 2.058 0 0 0-1.873 0c-.518.301-.518.786 0 1.079a2.059 2.059 0 0 0 1.873 0c.56-.293.56-.778 0-1.079z",
    fill: "#263238"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M79.47 173.478a2.06 2.06 0 0 0-1.873 0 .575.575 0 0 0-.388.54.569.569 0 0 0 .388.539 2.06 2.06 0 0 0 1.873 0 .569.569 0 0 0 0-1.079z",
    fill: "url(#bD)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M76.661 171.857a2.03 2.03 0 0 0-1.864 0 .567.567 0 0 0 0 1.078 2.041 2.041 0 0 0 1.864 0 .569.569 0 0 0 0-1.078zM77.623 168.12a2.047 2.047 0 0 0-1.873 0c-.518.292-.518.777 0 1.078a2.06 2.06 0 0 0 1.873 0c.518-.326.518-.786 0-1.078z",
    fill: "#263238"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M86.05 160.01a2.06 2.06 0 0 0-1.873 0c-.519.301-.519.786 0 1.079a2.06 2.06 0 0 0 1.872 0 .569.569 0 0 0 0-1.079z",
    fill: "url(#bE)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M82.304 162.184a2.06 2.06 0 0 0-1.873 0c-.518.293-.518.777 0 1.078a2.047 2.047 0 0 0 1.873 0c.518-.309.518-.794 0-1.078z",
    fill: "#263238"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M78.584 164.333a2.1 2.1 0 0 0-1.873 0 .571.571 0 0 0-.383.543.575.575 0 0 0 .383.543 2.099 2.099 0 0 0 1.873 0 .573.573 0 0 0 .383-.543.58.58 0 0 0-.383-.543z",
    fill: "url(#bF)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M74.814 166.498a2.06 2.06 0 0 0-1.873 0 .569.569 0 0 0 0 1.078 2.06 2.06 0 0 0 1.873 0 .569.569 0 0 0 0-1.078z",
    fill: "#263238"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M73.86 170.235a2.047 2.047 0 0 0-1.872 0c-.519.301-.519.786 0 1.078a2.06 2.06 0 0 0 1.873 0 .569.569 0 0 0 0-1.078z",
    fill: "url(#bG)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M71.06 168.613a2.099 2.099 0 0 0-1.873 0 .573.573 0 0 0-.383.543.58.58 0 0 0 .383.544 2.109 2.109 0 0 0 1.873.008.578.578 0 0 0 0-1.095z",
    fill: "#263238"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M77.823 177.826v2.875c.29.01.577-.054.836-.184l20.9-12.055a1.734 1.734 0 0 0 .836-1.379v-1.037a1.758 1.758 0 0 0-.652-1.279c.293.251.243.594-.142.836l-20.9 12.055a1.75 1.75 0 0 1-.878.168z",
    fill: "#37474F"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M82.045 155.379a.7.7 0 0 0-.895-.192l-18.183 10.466a.534.534 0 0 0-.265.36.525.525 0 0 0 .107.435.692.692 0 0 0 .894.184l18.158-10.476a.53.53 0 0 0 .262-.348.544.544 0 0 0-.078-.429z",
    fill: "#263238"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M82.045 155.379a.7.7 0 0 0-.895-.192l-13.518 7.774.753 1.012 13.493-7.791a.553.553 0 0 0 .266-.364.542.542 0 0 0-.099-.439z",
    fill: "url(#bH)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M80.549 153.364a.705.705 0 0 0-.894-.192L61.47 163.639a.522.522 0 0 0-.267.587.527.527 0 0 0 .1.207.705.705 0 0 0 .903.184l18.158-10.475a.546.546 0 0 0 .184-.778z",
    fill: "#263238"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M80.549 153.364a.705.705 0 0 0-.895-.192l-4.514 2.608.752 1.012 4.514-2.6a.555.555 0 0 0 .267-.38.543.543 0 0 0-.124-.448z",
    fill: "url(#bI)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M79.044 151.316a.71.71 0 0 0-.903-.192l-18.175 10.5a.526.526 0 0 0-.167.794.694.694 0 0 0 .895.184l18.183-10.45a.544.544 0 0 0 .167-.836z",
    fill: "#263238"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M79.044 151.316a.71.71 0 0 0-.903-.192l-9.455 5.442.752 1.012 9.439-5.426a.533.533 0 0 0 .296-.375.527.527 0 0 0-.13-.461z",
    fill: "url(#bJ)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M77.539 149.335a.7.7 0 0 0-.895-.193L58.47 159.609a.533.533 0 0 0-.297.375.527.527 0 0 0 .13.461.705.705 0 0 0 .903.184l18.149-10.475a.537.537 0 0 0 .184-.819z",
    fill: "#263238"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M77.539 149.335a.7.7 0 0 0-.895-.193l-16.502 9.497.752 1.012 16.478-9.514a.529.529 0 0 0 .27-.362.536.536 0 0 0-.103-.44z",
    fill: "url(#bK)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "m139.353 321.668-9.196-5.284a3.406 3.406 0 0 0-3.135 0l-49.976 28.884a2.84 2.84 0 0 1-2.508 0L13.986 310.29c-.267-.159-.418-.351-.418-.535 0-.184.15-.376.418-.527l27.655-15.968h.05a.167.167 0 0 0 0-.117.507.507 0 0 0-.234-.401.164.164 0 0 0-.15 0 .072.072 0 0 0-.05 0L13.593 308.71a1.178 1.178 0 0 0 0 2.19l60.569 34.97c.485.259 1.029.391 1.58.384a3.205 3.205 0 0 0 1.563-.384l50.009-28.867a2.79 2.79 0 0 1 2.508 0l9.196 5.283a.324.324 0 0 0 .249.032.325.325 0 0 0 .231-.402.328.328 0 0 0-.154-.198l.009-.05zm5.283-3.043-14.446-8.36a3.394 3.394 0 0 0-3.135 0l-50.01 28.892a2.84 2.84 0 0 1-2.507 0L24.553 310.29c-.267-.159-.418-.351-.418-.535 0-.184.15-.376.418-.527l22.455-12.916s.067-.067.067-.142a.504.504 0 0 0-.234-.402.141.141 0 0 0-.067-.016.141.141 0 0 0-.067.016.107.107 0 0 0-.058.042l-22.405 12.85a1.311 1.311 0 0 0-.744 1.095 1.286 1.286 0 0 0 .744 1.095l50.001 28.867a3.19 3.19 0 0 0 1.58.385 3.126 3.126 0 0 0 1.563-.385l50.01-28.867a2.827 2.827 0 0 1 2.508 0l14.438 8.36a.32.32 0 0 0 .443-.126.313.313 0 0 0 .043-.13.313.313 0 0 0-.202-.329h.008zm10.567-6.103-25.013-14.438a3.453 3.453 0 0 0-3.135 0l-50.01 28.876a2.84 2.84 0 0 1-2.507 0l-28.859-16.67c-.268-.159-.418-.351-.418-.535 0-.184.15-.376.418-.527l11.804-6.813h.05a.186.186 0 0 0 0-.126.49.49 0 0 0-.234-.393.158.158 0 0 0-.07-.016.159.159 0 0 0-.072.016l-11.87 6.847a1.174 1.174 0 0 0-.744 1.095 1.18 1.18 0 0 0 .743 1.095l28.876 16.67c.485.261 1.03.39 1.58.377a3.111 3.111 0 0 0 1.563-.377l50.009-28.875a2.827 2.827 0 0 1 2.508 0l25.005 14.446a.323.323 0 0 0 .249.032.292.292 0 0 0 .113-.059.306.306 0 0 0 .081-.098.33.33 0 0 0 .048-.425.332.332 0 0 0-.115-.102zm-5.283 3.051-19.73-11.386a3.406 3.406 0 0 0-3.135 0l-50.01 28.867a2.786 2.786 0 0 1-2.507 0L35.112 310.29c-.26-.159-.418-.351-.418-.535 0-.184.159-.376.418-.527l17.138-9.89a.183.183 0 0 0 .059-.15.476.476 0 0 0-.226-.393.182.182 0 0 0-.08-.017.182.182 0 0 0-.08.017l-17.137 9.898a1.175 1.175 0 0 0-.758 1.095 1.172 1.172 0 0 0 .758 1.095l39.434 22.773c.486.259 1.03.391 1.58.385a3.217 3.217 0 0 0 1.563-.385l50.01-28.875a2.827 2.827 0 0 1 2.508 0l19.721 11.386a.326.326 0 0 0 .443-.117.318.318 0 0 0-.125-.477z",
    fill: "url(#bL)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m139.353 321.668-9.196-5.284a3.406 3.406 0 0 0-3.135 0l-49.976 28.884a2.84 2.84 0 0 1-2.508 0L13.986 310.29c-.267-.159-.418-.351-.418-.535 0-.184.15-.376.418-.527l27.655-15.968h.05a.167.167 0 0 0 0-.117.507.507 0 0 0-.234-.401.164.164 0 0 0-.15 0 .072.072 0 0 0-.05 0L13.593 308.71a1.178 1.178 0 0 0 0 2.19l60.569 34.97c.485.259 1.029.391 1.58.384a3.205 3.205 0 0 0 1.563-.384l50.009-28.867a2.79 2.79 0 0 1 2.508 0l9.196 5.283a.324.324 0 0 0 .249.032.325.325 0 0 0 .231-.402.328.328 0 0 0-.154-.198l.009-.05zm5.283-3.043-14.446-8.36a3.394 3.394 0 0 0-3.135 0l-50.01 28.892a2.84 2.84 0 0 1-2.507 0L24.553 310.29c-.267-.159-.418-.351-.418-.535 0-.184.15-.376.418-.527l22.455-12.916s.067-.067.067-.142a.504.504 0 0 0-.234-.402.141.141 0 0 0-.067-.016.141.141 0 0 0-.067.016.107.107 0 0 0-.058.042l-22.405 12.85a1.311 1.311 0 0 0-.744 1.095 1.286 1.286 0 0 0 .744 1.095l50.001 28.867a3.19 3.19 0 0 0 1.58.385 3.126 3.126 0 0 0 1.563-.385l50.01-28.867a2.827 2.827 0 0 1 2.508 0l14.438 8.36a.32.32 0 0 0 .443-.126.313.313 0 0 0 .043-.13.313.313 0 0 0-.202-.329h.008zm5.284-3.052-19.73-11.386a3.406 3.406 0 0 0-3.135 0l-50.01 28.867a2.786 2.786 0 0 1-2.507 0L35.112 310.29c-.26-.159-.418-.351-.418-.535 0-.184.159-.376.418-.527l17.138-9.89a.183.183 0 0 0 .059-.15.476.476 0 0 0-.226-.393.182.182 0 0 0-.08-.017.182.182 0 0 0-.08.017l-17.137 9.898a1.175 1.175 0 0 0-.758 1.095 1.172 1.172 0 0 0 .758 1.095l39.434 22.773c.486.259 1.03.391 1.58.385a3.217 3.217 0 0 0 1.563-.385l50.01-28.875a2.827 2.827 0 0 1 2.508 0l19.721 11.386a.326.326 0 0 0 .443-.117.318.318 0 0 0-.125-.477zm5.283-3.051-25.013-14.438a3.453 3.453 0 0 0-3.135 0l-50.01 28.876a2.84 2.84 0 0 1-2.507 0l-28.859-16.67c-.268-.159-.418-.351-.418-.535 0-.184.15-.376.418-.527l11.804-6.813h.05a.186.186 0 0 0 0-.126.49.49 0 0 0-.234-.393.158.158 0 0 0-.07-.016.159.159 0 0 0-.072.016l-11.87 6.847a1.174 1.174 0 0 0-.744 1.095 1.18 1.18 0 0 0 .743 1.095l28.876 16.67c.485.261 1.03.39 1.58.377a3.111 3.111 0 0 0 1.563-.377l50.009-28.875a2.827 2.827 0 0 1 2.508 0l25.005 14.446a.323.323 0 0 0 .249.032.292.292 0 0 0 .113-.059.306.306 0 0 0 .081-.098.33.33 0 0 0 .048-.425.332.332 0 0 0-.115-.102z",
    fill: "#fff"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M58.796 108.964a.377.377 0 0 0-.385.385v35.881a.372.372 0 0 0 .11.274.378.378 0 0 0 .275.11.383.383 0 0 0 .393-.384v-35.881a.385.385 0 0 0-.393-.385z",
    fill: "url(#bM)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.796 108.964a.377.377 0 0 0-.385.385v35.881a.372.372 0 0 0 .11.274.378.378 0 0 0 .275.11.383.383 0 0 0 .393-.384v-35.881a.385.385 0 0 0-.393-.385z",
    fill: "#fff"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M57.099 111.631a3.768 3.768 0 0 1 1.672-2.943c.936-.535 1.672-.1 1.672.987a3.739 3.739 0 0 1-1.672 2.934c-.911.544-1.672.109-1.672-.978z",
    fill: "url(#bN)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "m80.08 87.838-1.137-.66a2.677 2.677 0 0 1-1.195-1.739l-4.924-37.21a1.454 1.454 0 0 0-2.332-1.145L45.144 61.697a2.332 2.332 0 0 1-3.185-.836l-.836-1.43a2.34 2.34 0 0 0-3.194-.836L26.21 65.35a3.78 3.78 0 0 0-1.714 3.478l5.852 43.99a2.699 2.699 0 0 0 1.17 1.714l1.146.652a.69.69 0 0 0 .71.075L80.8 87.88a.71.71 0 0 1-.719-.041z",
    fill: "url(#bO)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m80.08 87.838-1.137-.66a2.677 2.677 0 0 1-1.195-1.739l-4.924-37.21a1.454 1.454 0 0 0-2.332-1.145L45.144 61.697a2.332 2.332 0 0 1-3.185-.836l-.836-1.43a2.34 2.34 0 0 0-3.194-.836L26.21 65.35a3.78 3.78 0 0 0-1.714 3.478l5.852 43.99a2.699 2.699 0 0 0 1.17 1.714l1.146.652a.69.69 0 0 0 .71.075L80.8 87.88a.71.71 0 0 1-.719-.041z",
    fill: "#000"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m31.517 114.532 1.146.652a.69.69 0 0 0 .71.075L80.8 87.88a.71.71 0 0 1-.719-.067l-1.136-.66a2.39 2.39 0 0 1-.745-.736l-47.426 27.404c.196.286.45.528.744.711z",
    fill: "#000"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M31.768 110.586V73.568a2.992 2.992 0 0 1 1.346-2.34L74.68 47.233c.744-.435 1.346-.084 1.346.777v37.044a2.968 2.968 0 0 1-1.346 2.332l-41.533 23.985c-.744.426-1.379.075-1.379-.786z",
    fill: "#F0F0F0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M33.373 115.284a.714.714 0 0 0 .301-.652V77.974a4.473 4.473 0 0 1 2.023-3.503L79.07 49.433c1.12-.644 2.023-.109 2.023 1.162v36.658a.71.71 0 0 1-.293.652l-47.426 27.379z",
    fill: "url(#bP)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M33.373 115.284a.714.714 0 0 0 .301-.652V77.974a4.473 4.473 0 0 1 2.023-3.503L79.07 49.433c1.12-.644 2.023-.109 2.023 1.162v36.658a.71.71 0 0 1-.293.652l-47.426 27.379z",
    fill: "#fff"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M119.397 341.088c0 2.299 1.723 3.762 3.838 5.016l86.777 50.101a8.48 8.48 0 0 0 7.666 0l139.988-80.824c2.123-1.229 3.837-2.801 3.837-5.091 0-2.291-1.714-3.712-3.837-4.933l-86.802-50.16a8.443 8.443 0 0 0-7.666 0l-139.963 80.825c-2.124 1.22-3.838 2.742-3.838 5.066z",
    fill: "#37474F"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "m123.235 340.444 86.776 50.102a8.499 8.499 0 0 0 7.667 0l139.988-80.825c2.123-1.22 2.123-3.202 0-4.422l-86.802-50.102a8.443 8.443 0 0 0-7.666 0l-139.963 80.825c-2.124 1.22-2.124 3.202 0 4.422z",
    fill: "#455A64"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M213.849 391.474v5.626a7.848 7.848 0 0 1-3.837-.911l-86.777-50.102c-2.115-1.22-3.838-2.692-3.838-5.016 0-2.148 1.547-3.645 3.537-4.865-1.672 1.162-1.672 3.118.301 4.255l86.777 50.101a7.748 7.748 0 0 0 3.837.912z",
    fill: "#263238"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M117.734 336.607c-1.672-.769-2.14-2.106-2.299-4.456l-7.524-110.059a7.63 7.63 0 0 1 3.545-6.471l139.996-80.824c2.115-1.221 3.662-1.889 5.618-.552 1.956 1.338 1.998 2.073 2.157 4.431l7.524 110.051a7.627 7.627 0 0 1-3.545 6.479l-139.988 80.866c-2.115 1.179-3.319 1.538-5.484.535z",
    fill: "#37474F"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M259.235 138.667c-.167-2.34-2.015-3.26-4.13-2.04l-139.996 80.825a7.23 7.23 0 0 0-2.617 2.817l-3.653-1.839a7.433 7.433 0 0 1 2.625-2.817l139.988-80.816c2.124-1.229 3.679-1.898 5.626-.552 1.948 1.346 1.99 2.082 2.157 4.422z",
    fill: "#455A64"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M122.934 336.189c-1.931 1.137-3.152 1.279-5.2.418-1.563-.66-2.132-2.107-2.299-4.456l-7.524-110.059a6.691 6.691 0 0 1 .919-3.654l3.654 1.823a6.81 6.81 0 0 0-.92 3.653l7.524 110.06c.151 2.19 2.04 3.285 3.846 2.215z",
    fill: "#263238"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "m117.542 221.657 134.721-77.748c1.271-.736 2.383-.184 2.508 1.229l7.022 102.669a4.602 4.602 0 0 1-2.123 3.888l-134.722 77.748c-1.27.735-2.382.183-2.508-1.229l-7.022-102.67a4.561 4.561 0 0 1 2.124-3.887z",
    fill: "#000"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M117.542 221.657a4.557 4.557 0 0 0-2.124 3.887l6.905 100.964 133.175-76.87a4.604 4.604 0 0 0 2.132-3.887l-6.905-100.964-133.183 76.87z",
    fill: "url(#bQ)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.542 221.657a4.557 4.557 0 0 0-2.124 3.887l6.905 100.964 133.175-76.87a4.604 4.604 0 0 0 2.132-3.887l-6.905-100.964-133.183 76.87z",
    fill: "#fff"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "m135.072 336.666 128.652-74.271a3.994 3.994 0 0 1 3.612 0l4.682 2.625a1.104 1.104 0 0 1 0 2.09l-128.661 74.262a4.008 4.008 0 0 1-3.62 0l-4.665-2.616a1.106 1.106 0 0 1-.542-1.688c.134-.188.324-.328.542-.402zM147.704 344.123l128.653-74.279a3.68 3.68 0 0 1 3.302-.175l33.482 19.328c.836.476.685 1.337-.31 1.906L184.33 365.081a3.685 3.685 0 0 1-3.344.184l-33.633-19.228c-.785-.485-.643-1.337.351-1.914z",
    fill: "#263238"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "m259.16 301.044 4.03-2.324c.175-.101.192-.251 0-.343l-3.854-2.224a.663.663 0 0 0-.586 0l-4.021 2.324c-.175.1-.192.251 0 .334l3.846 2.224a.629.629 0 0 0 .585.009zm-5.852-8.051-4.03 2.332c-.167.092-.183.251 0 .335l3.854 2.224a.65.65 0 0 0 .586 0l4.029-2.325c.167-.1.184-.25 0-.342l-3.854-2.224a.685.685 0 0 0-.585 0zm-13.017 7.524-6.813 3.937c-.167.101-.184.251 0 .335l3.854 2.224a.634.634 0 0 0 .585 0l6.814-3.938c.175-.1.184-.251 0-.334l-3.854-2.224a.64.64 0 0 0-.594-.008l.008.008zm7.132-4.113-4.03 2.324c-.167.1-.184.251 0 .343l3.854 2.223a.66.66 0 0 0 .585 0l4.03-2.324c.167-.1.184-.25 0-.334l-3.854-2.224a.64.64 0 0 0-.552-.017l-.033.009zm-15.801 9.121-4.029 2.324c-.176.1-.184.25 0 .342l3.854 2.224a.685.685 0 0 0 .585 0l4.021-2.332c.176-.092.192-.243.042-.335l-3.854-2.223a.63.63 0 0 0-.627-.009l.008.009zm-5.902 3.394-4.021 2.324c-.176.1-.192.251-.042.334l3.854 2.232a.66.66 0 0 0 .585 0l4.03-2.324c.175-.1.192-.251 0-.334l-3.854-2.232a.66.66 0 0 0-.552 0zm15.107 9.079 4.029-2.324c.167-.101.184-.251 0-.343l-3.854-2.224a.685.685 0 0 0-.585 0l-4.03 2.333c-.167.091-.184.242 0 .334l3.854 2.224a.637.637 0 0 0 .586 0zm-5.852 3.394 4.029-2.324c.167-.101.184-.251 0-.335l-3.854-2.223a.635.635 0 0 0-.585 0l-4.03 2.324c-.167.1-.184.25 0 .342l3.854 2.224a.669.669 0 0 0 .527-.008h.059zm-5.852 3.402 4.029-2.324c.167-.1.184-.251 0-.342l-3.854-2.224a.66.66 0 0 0-.585 0l-4.03 2.324c-.167.1-.184.251 0 .334l3.854 2.224a.63.63 0 0 0 .527.008h.059zm-5.852 3.395 4.021-2.325c.175-.1.192-.25.042-.334l-3.854-2.224a.638.638 0 0 0-.586 0l-4.029 2.324c-.176.101-.192.251 0 .343l3.854 2.224a.662.662 0 0 0 .493-.008h.059zm30.096-23.751 4.029-2.324c.176-.092.184-.251 0-.335l-3.854-2.223a.635.635 0 0 0-.585 0l-4.021 2.324c-.176.1-.193.25-.042.342l3.854 2.224a.657.657 0 0 0 .56-.008h.059zm-6.58 10.157 8.987-5.183c.176-.1.184-.251 0-.343l-9.355-5.4a.66.66 0 0 0-.585 0l-4.648 2.683c-.176.101-.184.251 0 .343l4.949 2.859c.159.084.142.234 0 .334l-3.712 2.149c-.175.1-.192.251-.041.334l3.853 2.233a.665.665 0 0 0 .477-.009h.075zm-26.919-2.282-4.029 2.332c-.168.092-.184.243 0 .335l3.853 2.223a.638.638 0 0 0 .586 0l4.029-2.324c.176-.1.184-.25 0-.342l-3.854-2.224a.659.659 0 0 0-.585 0zm-5.852 3.402-4.03 2.324c-.167.101-.183.251 0 .343l3.854 2.224a.663.663 0 0 0 .586 0l4.029-2.324c.167-.1.184-.251 0-.334l-3.854-2.224a.633.633 0 0 0-.652-.009h.067zm-32.604 36.291a.66.66 0 0 0 .585 0l4.03-2.324c.175-.1.184-.251 0-.334l-3.854-2.224a.637.637 0 0 0-.585 0l-4.03 2.324c-.175.1-.192.251 0 .343l3.854 2.215zm-14.513-9.104-4.071 2.366c-.176.092-.193.251 0 .334l3.854 2.224a.63.63 0 0 0 .585 0l4.021-2.324c.176-.1.192-.251.042-.343l-3.854-2.223a.685.685 0 0 0-.619-.034h.042zm7.466 6.822a.659.659 0 0 0 .585 0l4.021-2.324c.175-.101.192-.251 0-.335l-3.846-2.232a.659.659 0 0 0-.585 0l-3.996 2.324c-.176.101-.192.251 0 .335l3.821 2.232zm16.235 3.653 4.029-2.332c.176-.092.192-.251 0-.335l-3.854-2.223a.634.634 0 0 0-.585 0l-4.021 2.324c-.176.1-.192.25 0 .342l3.845 2.224a.69.69 0 0 0 .544 0h.042zm-6.471 3.411a.634.634 0 0 0 .585 0l4.03-2.324c.175-.1.184-.251 0-.334l-3.854-2.233a.674.674 0 0 0-.585 0l-4.03 2.325c-.167.1-.184.25 0 .334l3.854 2.232zm-11.344-17.28-4.03 2.324c-.176.1-.184.251 0 .334l3.854 2.233a.66.66 0 0 0 .585 0l4.03-2.325c.167-.1.184-.25 0-.334l-3.854-2.232a.662.662 0 0 0-.627 0h.042zm29.435-16.996-4.088 2.324c-.176.1-.184.251 0 .343l3.854 2.224a.66.66 0 0 0 .585 0l4.03-2.324c.167-.101.184-.251 0-.335l-3.854-2.224a.639.639 0 0 0-.569-.008h.042zm-23.592 13.56-4.029 2.324c-.168.1-.184.251 0 .343l3.854 2.224a.659.659 0 0 0 .585 0l4.029-2.333c.168-.092.184-.242 0-.334l-3.854-2.224a.63.63 0 0 0-.585 0zm29.436-16.996-4.03 2.333c-.167.092-.184.25 0 .334l3.854 2.224a.637.637 0 0 0 .585 0l4.03-2.324c.167-.101.184-.251 0-.343l-3.854-2.224a.682.682 0 0 0-.585.034v-.034zm-11.771 6.805-4.013 2.358c-.176.1-.192.25 0 .334l3.854 2.224a.634.634 0 0 0 .585 0l4.021-2.324c.176-.101.193-.251 0-.343l-3.854-2.224a.638.638 0 0 0-.593.009v-.034zm-5.894 3.394-4.021 2.324c-.176.101-.192.251-.042.343l3.854 2.224a.66.66 0 0 0 .585 0l4.013-2.274c.176-.092.184-.251 0-.334l-3.854-2.224a.628.628 0 0 0-.535-.025v-.034zm-5.852 3.403-4.03 2.324c-.167.1-.183.251 0 .334l3.854 2.224a.637.637 0 0 0 .586 0l3.979-2.324c.167-.1.184-.251 0-.343l-3.837-2.165a.66.66 0 0 0-.585 0l.033-.05zm26.877 2.282 4.03-2.332c.176-.092.184-.251 0-.335l-3.854-2.223a.635.635 0 0 0-.585 0l-4.03 2.324c-.167.1-.184.25 0 .342l3.854 2.224a.687.687 0 0 0 .552.034l.033-.034zm54.926-49.508-4.03 2.324c-.175.101-.192.251 0 .335l3.854 2.223a.635.635 0 0 0 .585 0l4.021-2.324c.176-.1.193-.25.042-.342l-3.854-2.224a.665.665 0 0 0-.652.042l.034-.034zm-7.19 4.147-4.029 2.324c-.168.1-.184.251 0 .334l3.853 2.232a.664.664 0 0 0 .586 0l4.029-2.324c.167-.1.184-.251 0-.334l-3.854-2.232a.66.66 0 0 0-.585 0zm13.017-7.524-4.03 2.324c-.167.1-.184.251 0 .343l3.854 2.223a.66.66 0 0 0 .585 0l4.03-2.324c.167-.1.184-.251 0-.334l-3.854-2.224a.632.632 0 0 0-.56 0l-.025-.008zm-32.538 30.23 4.022-2.325c.175-.1.192-.25 0-.342l-3.846-2.224a.66.66 0 0 0-.585 0l-4.03 2.324c-.175.1-.192.251 0 .334l3.896 2.258a.643.643 0 0 0 .568-.017l-.025-.008zm39.008-33.649a.66.66 0 0 0-.585 0l-4.03 2.324c-.167.1-.183.25 0 .334l3.854 2.224a.637.637 0 0 0 .586 0l4.029-2.324c.167-.101.184-.251 0-.343l-3.854-2.215zm-61.371 52.935 4.03-2.324c.176-.1.192-.251 0-.343l-3.854-2.224a.66.66 0 0 0-.585 0l-4.021 2.325c-.176.1-.193.25 0 .334l3.845 2.224a.623.623 0 0 0 .585.008zm72.197-41.683 4.03-2.324c.167-.1.184-.251 0-.334l-3.854-2.224a.635.635 0 0 0-.585 0l-3.988 2.341c-.167.1-.184.25 0 .342l3.854 2.224a.66.66 0 0 0 .543-.025zm-11.394.226 4.029-2.333c.176-.092.184-.242 0-.334l-3.854-2.224a.659.659 0 0 0-.585 0l-3.996 2.341c-.167.1-.184.251 0 .343l3.854 2.224a.673.673 0 0 0 .552-.017zm6.094-8.293a.66.66 0 0 0-.585 0l-4.021 2.324c-.176.1-.192.251 0 .334l3.837 2.249a.623.623 0 0 0 .585 0l4.03-2.324c.175-.1.192-.251 0-.334l-3.846-2.249zm1.246-.711 9.355 5.401a.63.63 0 0 0 .585 0l4.029-2.324c.168-.101.184-.251 0-.343l-9.296-5.417a.624.624 0 0 0-.585 0l-4.03 2.324c-.2.125-.209.267-.058.359zm-13.602 7.524-4.029 2.324c-.168.1-.184.251 0 .335l3.854 2.232a.656.656 0 0 0 .585 0l4.029-2.324c.167-.101.184-.251 0-.335l-3.854-2.232a.656.656 0 0 0-.585.008v-.008zm-44.308 25.582-4.029 2.324c-.168.1-.184.251 0 .334l3.854 2.224a.63.63 0 0 0 .585 0l4.029-2.324c.167-.1.184-.251 0-.335l-3.854-2.232a.663.663 0 0 0-.585.017v-.008zm55.494-20.9a.63.63 0 0 0 .585 0l4.029-2.324c.168-.101.184-.251 0-.343l-3.82-2.249a.69.69 0 0 0-.585 0l-3.988 2.349c-.167.092-.184.251 0 .335l3.779 2.232zm-49.608 17.514-4.022 2.324c-.175.1-.192.251-.041.343l3.854 2.223a.67.67 0 0 0 .585 0l4.029-2.332c.176-.092.184-.251 0-.334l-3.854-2.224a.623.623 0 0 0-.551-.008v.008zm-46.131 37.762a.634.634 0 0 0 .585 0l4.021-2.324c.176-.1.193-.251 0-.343l-3.854-2.224a.666.666 0 0 0-.576 0l-4.03 2.333c-.175.092-.192.251 0 .334l3.854 2.224zm-6.847-7.173-4.021 2.316c-.176.1-.184.251 0 .343l3.854 2.223a.672.672 0 0 0 .585 0l4.03-2.332c.167-.092.184-.243 0-.334l-3.854-2.224a.631.631 0 0 0-.594 0v.008zm13.318 3.754 4.021-2.324c.175-.101.192-.251 0-.335l-3.804-2.232a.634.634 0 0 0-.585 0l-4.03 2.324c-.175.101-.184.251 0 .335l3.854 2.232a.672.672 0 0 0 .544-.009v.009zm5.852-3.394 4.029-2.324c.167-.101.184-.251 0-.343l-3.812-2.224a.66.66 0 0 0-.585 0l-4.03 2.332c-.167.092-.184.243 0 .335l3.854 2.224a.665.665 0 0 0 .577-.009l-.033.009zm5.852-3.403 4.029-2.324c.167-.1.184-.251 0-.343l-3.854-2.224a.673.673 0 0 0-.585 0l-4.03 2.325c-.167.1-.183.25 0 .334l3.854 2.224a.639.639 0 0 0 .653 0l-.067.008zm-19.228-.351-3.963 2.316c-.167.1-.184.25 0 .334l3.854 2.224a.634.634 0 0 0 .585 0l4.03-2.324c.167-.101.184-.251 0-.343l-3.854-2.224a.665.665 0 0 0-.56.009l-.092.008zm5.852-3.403-4.03 2.325c-.167.1-.184.25 0 .342l3.854 2.224a.66.66 0 0 0 .585 0l4.03-2.324c.167-.1.184-.251 0-.334l-3.854-2.224a.635.635 0 0 0-.46-.017l-.125.008zm23.675-13.618-4.029 2.324c-.168.1-.184.251 0 .343l3.854 2.224a.659.659 0 0 0 .585 0l4.029-2.324c.168-.101.184-.251 0-.335l-3.854-2.232a.63.63 0 0 0-.585 0zm-5.852 3.394-4.029 2.333c-.176.092-.193.25 0 .334l3.854 2.224a.63.63 0 0 0 .585 0l4.021-2.324c.176-.101.192-.251.042-.343l-3.854-2.224a.684.684 0 0 0-.669.017l.05-.017zm11.738-6.738-4.03 2.324c-.167.1-.184.251 0 .343l3.854 2.224a.66.66 0 0 0 .585 0l4.03-2.333c.167-.092.184-.242 0-.334l-3.854-2.224a.66.66 0 0 0-.585 0zm-23.551 13.602-4.029 2.282c-.167.1-.184.251 0 .334l3.854 2.224a.635.635 0 0 0 .585 0l4.03-2.324c.175-.1.184-.251 0-.343l-3.854-2.223a.664.664 0 0 0-.586.008v.042zm5.853-3.403-4.022 2.324c-.175.101-.192.251 0 .343l3.846 2.224a.66.66 0 0 0 .585 0l4.03-2.324c.175-.101.192-.251 0-.335l-3.854-2.223a.637.637 0 0 0-.527-.051l-.058.042zm-7.525 22.137 4.022-2.324c.175-.1.192-.25 0-.342l-3.854-2.224a.66.66 0 0 0-.586 0l-4.029 2.324c-.176.1-.192.251 0 .334l3.854 2.224a.637.637 0 0 0 .652-.033l-.059.041zm-31.049-1.463-3.854-2.223a.63.63 0 0 0-.585 0l-3.971 2.282c-.175.1-.192.251 0 .343l3.854 2.224a.674.674 0 0 0 .585 0l4.03-2.325c.117-.108.117-.242-.008-.342l-.051.041zm7.675 1.923-3.854-2.223a.675.675 0 0 0-.585 0l-6.195 3.578c-.167.1-.184.25 0 .342l3.854 2.224a.66.66 0 0 0 .585 0l6.195-3.57c.192-.15.201-.301.025-.393l-.025.042zm-13.351-6.362-3.879-2.19a.69.69 0 0 0-.585 0l-4.958 2.867c-.167.101-.184.251 0 .335l3.854 2.224a.637.637 0 0 0 .585 0l4.958-2.859c.142-.134.159-.285.025-.377zm3.804-2.19a.659.659 0 0 0 .585 0l4.03-2.324c.167-.1.183-.251 0-.334l-3.854-2.224a.638.638 0 0 0-.586 0l-3.979 2.315c-.167.101-.184.251 0 .343l3.804 2.224zm16.678 10.793-3.854-2.224a.66.66 0 0 0-.585 0l-7.742 4.473c-.175.092-.192.242-.041.334l3.854 2.224a.659.659 0 0 0 .585 0l7.75-4.473c.142-.092.158-.259.008-.334h.025zm2.717 4.79-3.879-2.207a.634.634 0 0 0-.585 0l-4.958 2.867c-.167.101-.184.251 0 .335l3.854 2.224a.637.637 0 0 0 .585 0l4.958-2.868c.134-.109.15-.259 0-.351h.025zm24.378-40.855a.659.659 0 0 0 .585 0l4.021-2.324c.176-.101.192-.251.042-.335l-3.854-2.224a.635.635 0 0 0-.585 0l-4.03 2.325c-.175.1-.184.25 0 .342l3.821 2.216zm-11.779 6.796a.67.67 0 0 0 .585 0l4.029-2.332c.176-.092.184-.251 0-.334l-3.845-2.266a.637.637 0 0 0-.586 0l-4.029 2.324c-.167.1-.184.251 0 .343l3.846 2.265zm-26.109 15.048a.638.638 0 0 0 .585 0l4.03-2.324c.167-.1.184-.25 0-.342l-3.854-2.224a.686.686 0 0 0-.585 0l-4.013 2.357c-.167.092-.184.243 0 .335l3.837 2.198zm31.994-18.475a.635.635 0 0 0 .585 0l4.03-2.324c.175-.101.192-.251 0-.343l-3.846-2.182a.66.66 0 0 0-.585 0l-4.021 2.324c-.176.1-.193.251 0 .334l3.837 2.191zm-11.796 6.855a.66.66 0 0 0 .585 0l4.03-2.324c.167-.1.184-.251 0-.334l-3.854-2.233a.66.66 0 0 0-.585 0l-4.03 2.324c-.167.101-.184.251 0 .335l3.854 2.232zm-3.82 30.932a.637.637 0 0 0-.586 0l-6.194 3.578c-.176.1-.193.251 0 .334l3.853 2.224a.627.627 0 0 0 .586 0l6.203-3.578c.167-.1.184-.251 0-.334l-3.862-2.224zm-4.624-26.025a.693.693 0 0 0 .586 0l4.021-2.332c.175-.092.192-.243 0-.335l-3.846-2.223a.62.62 0 0 0-.585 0l-4.03 2.324c-.175.1-.192.251 0 .343l3.854 2.223zm-5.893 3.403a.659.659 0 0 0 .585 0l4.029-2.324c.176-.101.184-.251 0-.335l-3.82-2.307a.66.66 0 0 0-.585 0l-4.055 2.341c-.176.1-.192.251 0 .334l3.846 2.291zm119.548-40.354a.66.66 0 0 0-.586 0l-9.915 5.727c-.175.092-.192.251 0 .334l3.854 2.224a.637.637 0 0 0 .586 0l9.915-5.727c.167-.1.183-.251 0-.334l-3.854-2.224zm-13.017 7.524a.66.66 0 0 0-.585 0l-4.03 2.324c-.167.101-.184.251 0 .335l3.854 2.223a.638.638 0 0 0 .586 0l4.029-2.324c.167-.1.184-.251 0-.342l-3.854-2.216zm-79.42 44.308 4.03-2.324c.167-.1.184-.251 0-.334l-3.854-2.224a.638.638 0 0 0-.586 0l-4.029 2.324c-.167.1-.184.251 0 .343l3.854 2.223a.65.65 0 0 0 .56-.1l.025.092zm67.716-37.486a.66.66 0 0 0-.585 0l-4.03 2.324c-.175.1-.184.251 0 .334l3.854 2.224a.638.638 0 0 0 .586 0l4.029-2.324c.167-.1.184-.251 0-.343l-3.854-2.215zm30.673-17.707a.634.634 0 0 0-.585 0l-4.03 2.324c-.167.101-.184.251 0 .343l3.854 2.224a.66.66 0 0 0 .585 0l4.03-2.332c.167-.092.184-.243 0-.335l-3.854-2.224zm9.739-1.17-9.354-5.409a.663.663 0 0 0-.586 0l-4.029 2.324c-.176.1-.192.251 0 .335l9.355 5.4a.63.63 0 0 0 .585 0l4.029-2.324c.101-.184.117-.334-.033-.418l.033.092zm-62.415 31.584a.637.637 0 0 0-.586 0l-5.024 2.784c-.167.1-.184.251 0 .343l3.854 2.223a.66.66 0 0 0 .585 0l4.958-2.859c.175-.1.184-.25 0-.334l-3.787-2.157zm14.872-8.594a.66.66 0 0 0-.585 0l-6.228 3.553c-.168.1-.184.251 0 .334l3.854 2.224a.63.63 0 0 0 .585 0l6.195-3.578c.175-.1.183-.251 0-.334l-3.821-2.199zm-28.499 16.461a.693.693 0 0 0-.585 0l-33.198 19.069c-.167.1-.184.251 0 .334l3.854 2.233a.674.674 0 0 0 .585 0l33.148-19.137c.175-.1.192-.25.041-.342l-3.845-2.157zm-35.012 20.214a.685.685 0 0 0-.585 0l-4.991 2.826c-.176.1-.192.251-.042.334l3.854 2.224a.624.624 0 0 0 .585 0l4.958-2.859c.175-.1.192-.251 0-.343l-3.779-2.182zm41.8-24.152a.659.659 0 0 0-.585 0l-4.958 2.859c-.167.101-.183.251 0 .335l3.854 2.232a.66.66 0 0 0 .586 0l4.957-2.859c.167-.101.184-.251 0-.343l-3.854-2.224zm-48.647 28.09a.63.63 0 0 0-.585 0l-4.957 2.867c-.168.092-.184.243 0 .335l3.854 2.224a.642.642 0 0 0 .585 0l4.957-2.868c.167-.1.184-.251 0-.334l-3.854-2.224zm62.282-35.948a.63.63 0 0 0-.585 0l-4.957 2.867c-.176.092-.193.243 0 .335l3.854 2.224a.642.642 0 0 0 .585 0l4.957-2.868c.167-.092.184-.251 0-.334l-3.854-2.224zm21.034-12.264a.635.635 0 0 0-.585 0l-4.03 2.324c-.167.1-.184.251 0 .343l3.854 2.223a.66.66 0 0 0 .585 0l4.03-2.324c.167-.1.184-.251 0-.334l-3.854-2.232zm13.184-9.196 4.029-2.324c.176-.101.184-.251 0-.343l-3.854-2.224a.659.659 0 0 0-.585 0l-4.029 2.324c-.168.101-.184.251 0 .335l3.854 2.223a.63.63 0 0 0 .61 0l-.025.009zm-23.993 1.12 4.021-2.324c.175-.1.192-.251.041-.334l-3.853-2.224a.627.627 0 0 0-.586 0l-4.029 2.374c-.176.1-.184.251 0 .343l3.854 2.224a.673.673 0 0 0 .552-.059zm-15.642 21.736 11.779-6.797c.167-.1.184-.25 0-.342l-3.854-2.224a.66.66 0 0 0-.585 0l-11.746 6.855c-.167.1-.184.251 0 .334l3.854 2.224a.63.63 0 0 0 .552-.05zm33.189-19.479a.693.693 0 0 0 .585 0l4.03-2.332c.167-.092.184-.251 0-.335l-3.829-2.207a.634.634 0 0 0-.585 0l-4.03 2.324c-.167.101-.184.251 0 .343l3.829 2.207zm-4.916-3.202 4.022-2.324c.175-.1.192-.251.041-.334l-3.854-2.224a.626.626 0 0 0-.585 0l-4.029 2.324c-.176.1-.192.251 0 .343l3.854 2.224a.66.66 0 0 0 .551.025v-.034zm-34.158 26.084 4.029-2.333c.167-.1.184-.251 0-.334l-3.854-2.224a.634.634 0 0 0-.585 0l-4.03 2.324c-.167.1-.184.251 0 .343l3.854 2.224a.697.697 0 0 0 .586.033v-.033zm26.058-15.366a.659.659 0 0 0 .585 0l4.029-2.324c.176-.101.193-.251 0-.335l-3.854-2.223a.63.63 0 0 0-.585 0l-4.021 2.324c-.175.1-.192.25 0 .342l3.846 2.216zm-55.494 32.353 4.03-2.324c.167-.1.183-.251 0-.334l-3.854-2.224a.638.638 0 0 0-.586 0l-4.029 2.324c-.167.1-.184.251 0 .343l3.854 2.223a.654.654 0 0 0 .585.025v-.033zm5.852-3.394 4.03-2.324c.175-.101.183-.251 0-.343l-3.854-2.224a.692.692 0 0 0-.586 0l-4.021 2.333c-.175.092-.192.251-.042.334l3.854 2.224a.629.629 0 0 0 .652.033l-.033-.033zm-11.771 6.797 4.03-2.325c.167-.1.184-.25 0-.342l-3.854-2.224a.66.66 0 0 0-.586 0l-4.029 2.324c-.167.1-.184.251 0 .334l3.854 2.224a.644.644 0 0 0 .304.102.648.648 0 0 0 .315-.06l-.034-.033zm23.55-13.594 4.03-2.332c.167-.092.184-.243 0-.335l-3.854-2.223a.66.66 0 0 0-.585 0l-3.938 2.374c-.176.1-.184.251 0 .343l3.854 2.223a.648.648 0 0 0 .527-.016l-.034-.034zm-5.852 3.394 4.021-2.324c.176-.1.193-.251 0-.334l-3.845-2.232a.66.66 0 0 0-.585 0l-4.03 2.324c-.175.1-.192.251 0 .334l3.854 2.232a.652.652 0 0 0 .585.034v-.034zm11.771-6.796 4.03-2.324c.167-.101.184-.251 0-.343l-3.854-2.224a.66.66 0 0 0-.586 0l-4.004 2.383c-.167.1-.184.25 0 .334l3.854 2.224a.63.63 0 0 0 .56-.017v-.033zm32.128-47.284a.642.642 0 0 0 .585 0l4.021-2.325c.176-.1.192-.25 0-.342l-1.028-.594a.66.66 0 0 0-.586 0l-4.029 2.324c-.167.101-.184.251 0 .335l1.037.602zm-29.26 18.525a.63.63 0 0 0 .585 0l4.021-2.324c.176-.1.192-.251 0-.343l-3.854-2.223a.66.66 0 0 0-.585 0l-4.03 2.324c-.175.1-.192.251 0 .334l3.863 2.232zm11.77-6.796a.637.637 0 0 0 .586 0l4.029-2.324c.167-.101.184-.251 0-.343l-3.854-2.224a.685.685 0 0 0-.585 0l-4.03 2.332c-.167.092-.183.251 0 .335l3.854 2.224zm-18.96 10.951a.66.66 0 0 0 .585 0l4.03-2.324c.167-.1.184-.251 0-.334l-3.854-2.224a.637.637 0 0 0-.585 0l-4.03 2.324c-.176.1-.184.251 0 .343l3.854 2.215zm13.075-7.524a.66.66 0 0 0 .585 0l4.03-2.324c.167-.1.184-.251 0-.334l-3.854-2.224a.637.637 0 0 0-.585 0l-4.03 2.324c-.167.1-.184.251 0 .343l3.854 2.215zm-24.871 14.354a.66.66 0 0 0 .585 0l4.03-2.324c.175-.1.184-.251 0-.334l-3.779-2.249a.634.634 0 0 0-.585 0l-4.021 2.324c-.176.1-.193.251 0 .343l3.77 2.24zm5.894-3.402a.633.633 0 0 0 .585 0l4.021-2.324c.176-.101.192-.251 0-.343l-3.845-2.224a.663.663 0 0 0-.586 0l-4.029 2.324c-.176.101-.192.251 0 .335l3.854 2.232zm30.556-19.278a.63.63 0 0 0 .585 0l4.029-2.324c.176-.101.184-.251 0-.343l-1.028-.585a.618.618 0 0 0-.577 0l-4.029 2.324c-.176.1-.193.25 0 .334l1.02.594zm17.664-10.191a.66.66 0 0 0 .586 0l4.029-2.324c.167-.101.184-.251 0-.335l-1.028-.593a.638.638 0 0 0-.585 0l-4.03 2.324c-.167.1-.184.251 0 .343l1.028.585zm8.093 4.673a.659.659 0 0 0 .585 0l4.029-2.324c.168-.1.184-.251 0-.334l-3.853-2.224a.638.638 0 0 0-.586 0l-4.029 2.324c-.167.1-.184.251 0 .343l3.854 2.215zm11.211 12.908 4.029-2.324c.176-.101.192-.251 0-.335l-3.854-2.223a.635.635 0 0 0-.585 0l-4.021 2.324c-.176.1-.193.251 0 .342l3.845 2.224a.662.662 0 0 0 .602-.008h-.016zM263.875 282.3a.66.66 0 0 0 .585 0l4.03-2.324c.175-.1.192-.25 0-.334l-1.02-.594a.66.66 0 0 0-.585 0l-4.03 2.333c-.175.092-.184.242 0 .334l1.02.585zm-48.187 29.469a.635.635 0 0 0 .585 0l4.03-2.324c.167-.1.184-.25 0-.342l-3.854-2.224a.66.66 0 0 0-.585 0l-4.03 2.324c-.167.1-.184.251 0 .334l3.854 2.232z",
    fill: "#455A64"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "m232.533 345.276.878.502 23.258 13.426 41.373-23.884.861-.494-24.135-13.927-42.235 24.377z",
    fill: "#263238"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "m297.516 335.629-22.748-13.125-40.83 23.583 22.731 13.117 40.847-23.575z",
    fill: "#37474F"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M128.426 228.721a4.57 4.57 0 0 0-2.123 3.879l6.897 100.964 133.183-76.87a4.57 4.57 0 0 0 2.123-3.879l-6.897-100.964-133.183 76.87z",
    fill: "#fff"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "m261.61 151.851-3.403-1.965-133.183 76.912a4.546 4.546 0 0 0-2.123 3.879l6.897 100.964 3.402 1.956 133.183-76.87a4.557 4.557 0 0 0 2.124-3.887l-6.897-100.989z",
    fill: "#E0E0E0"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M128.426 228.721a4.57 4.57 0 0 0-2.123 3.879l6.897 100.964 133.183-76.87a4.57 4.57 0 0 0 2.123-3.879l-6.897-100.964-133.183 76.87z",
    fill: "#fff"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "m260.832 153.239 6.813 99.626a3.791 3.791 0 0 1-1.713 3.101l-131.988 76.202-6.814-99.618a3.78 3.78 0 0 1 1.714-3.11l131.988-76.201zm.744-1.388-133.15 76.87a4.57 4.57 0 0 0-2.123 3.879l6.897 100.964 133.183-76.87a4.57 4.57 0 0 0 2.123-3.879l-6.897-100.964h-.033z",
    fill: "#F0F0F0"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M137.338 270.387a.889.889 0 0 1-.443-.108 1.05 1.05 0 0 1-.527-.903l-2.123-31.116a2.274 2.274 0 0 1 1.062-1.956l48.989-28.274a1.117 1.117 0 0 1 1.087-.083 1.064 1.064 0 0 1 .518.903l2.124 31.082a2.286 2.286 0 0 1-1.062 1.956l-48.981 28.282c-.193.125-.415.2-.644.217zm-2.291-32.202 2.124 31.141a.324.324 0 0 0 .1.242.398.398 0 0 0 .301-.067l48.99-28.282a1.467 1.467 0 0 0 .66-1.203l-2.123-31.141a.288.288 0 0 0-.101-.234s-.15 0-.301.058l-48.981 28.282a1.493 1.493 0 0 0-.669 1.204zM140.088 310.683a1.05 1.05 0 0 1-.451-.101 1.064 1.064 0 0 1-.518-.903l-2.124-31.141a2.291 2.291 0 0 1 1.062-1.956l118.269-68.284a1.105 1.105 0 0 1 1.087-.075 1.039 1.039 0 0 1 .526.894l2.124 31.149a2.255 2.255 0 0 1-1.062 1.948l-118.277 68.285a1.231 1.231 0 0 1-.636.184zM256.97 208.925a.433.433 0 0 0-.234.075l-118.278 68.284a1.467 1.467 0 0 0-.66 1.196l2.123 31.141a.304.304 0 0 0 .101.242s.15 0 .301-.058l118.268-68.285a1.455 1.455 0 0 0 .661-1.203l-2.124-31.141a.296.296 0 0 0-.091-.243l-.067-.008z",
    fill: "#F5F5F5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "m139.612 244.731 3.01-1.739c.459-.268.836-.092.894.384a1.614 1.614 0 0 1-.777 1.346l-3.01 1.739c-.46.268-.836.092-.895-.384a1.607 1.607 0 0 1 .778-1.346zM139.704 238.778l17.322-10.032c.518-.301.961-.1.995.435a1.805 1.805 0 0 1-.836 1.505l-17.322 10.032c-.51.292-.962.1-.995-.435a1.818 1.818 0 0 1 .836-1.505zM139.955 249.964l3.018-1.739c.459-.259.836-.092.886.385a1.587 1.587 0 0 1-.769 1.346l-3.018 1.68c-.46.259-.836.092-.886-.393a1.601 1.601 0 0 1 .769-1.279zM140.306 255.13l3.018-1.738c.459-.268.836-.092.886.384a1.608 1.608 0 0 1-.769 1.346l-3.01 1.739c-.46.268-.836.092-.894-.385a1.617 1.617 0 0 1 .769-1.346zM140.665 260.314l3.01-1.748c.46-.259.836-.092.895.393a1.607 1.607 0 0 1-.778 1.346l-3.01 1.739c-.459.259-.836.092-.894-.384a1.614 1.614 0 0 1 .777-1.346zM146.2 259.11a.238.238 0 0 1-.102-.02.234.234 0 0 1-.082-.064.185.185 0 0 1-.028-.068.184.184 0 0 1 .032-.141.184.184 0 0 1 .054-.05l37.62-21.736a.2.2 0 0 1 .276.059.164.164 0 0 1 .033.137.163.163 0 0 1-.083.113l-37.62 21.736a.165.165 0 0 1-.1.034zM145.84 253.918a.217.217 0 0 1-.175-.092.176.176 0 0 1-.028-.066.194.194 0 0 1 .002-.072.173.173 0 0 1 .084-.112l37.62-21.736a.21.21 0 0 1 .276.066c.014.02.023.043.027.067a.175.175 0 0 1-.001.072.185.185 0 0 1-.084.112l-37.621 21.736a.193.193 0 0 1-.1.025zM145.464 248.743a.216.216 0 0 1-.207-.156.164.164 0 0 1 .082-.186l37.62-21.736a.215.215 0 0 1 .275.058.174.174 0 0 1 .028.069.18.18 0 0 1-.086.19l-37.62 21.736-.092.025zM145.138 243.56a.2.2 0 0 1-.176-.083.189.189 0 0 1-.032-.067.185.185 0 0 1-.001-.074.153.153 0 0 1 .029-.068.168.168 0 0 1 .055-.051l37.62-21.736a.21.21 0 0 1 .284.059.174.174 0 0 1-.005.203.166.166 0 0 1-.054.048l-37.62 21.736-.1.033z",
    fill: "#E0E0E0"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "m146.894 258.441-.352-5.116 3.528-2.726 4.306-2.516 2.583-3.478 4.381-2.533 2.499-3.469 8.77-5.058 2.742-3.837 3.645-5.167 3.745-2.667 1.045 15.333-36.892 21.234z",
    fill: "url(#bR)",
    opacity: 0.3
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "m146.893 258.441-.259-3.829 4.707-2.759 4.063-3.31 4.347-2.491 4.381-3.537 4.355-2.541 2.5-3.47 4.489-2.6 2.391-3.394 3.035-3.787 2.09-1.204.794 11.688-36.893 21.234z",
    fill: "url(#bS)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M198.132 207.261c.192 2.776-1.179 5.911-3.051 6.997-1.873 1.087-3.553-.292-3.746-3.076-.192-2.784 1.179-5.911 3.052-6.989 1.872-1.078 3.519.293 3.745 3.068z",
    fill: "url(#bT)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M194.437 212.01a.46.46 0 0 1-.318-.117l-1.329-1.079a.515.515 0 0 1 .088-.845.508.508 0 0 1 .389-.036c.064.02.123.052.175.095l.761.619 1.622-4.648a.525.525 0 0 1 .635-.343.505.505 0 0 1 .338.455.49.49 0 0 1-.029.197l-1.864 5.342a.512.512 0 0 1-.343.318.45.45 0 0 1-.125.042z",
    fill: "#fff"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M199.394 226.255c.184 2.776-1.178 5.902-3.059 6.989-1.881 1.087-3.545-.293-3.737-3.068-.193-2.776 1.178-5.911 3.051-6.997 1.873-1.087 3.553.292 3.745 3.076z",
    fill: "#455A64"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M194.938 231.146a.471.471 0 0 1-.209-.042.511.511 0 0 1-.259-.669l2.115-4.849a.519.519 0 0 1 .677-.267.514.514 0 0 1 .259.669l-2.123 4.857a.505.505 0 0 1-.46.301z",
    fill: "#fff"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M197.296 229.783a.507.507 0 0 1-.326-.109l-2.592-2.132a.513.513 0 0 1-.205-.558.502.502 0 0 1 .261-.318.512.512 0 0 1 .588.091l2.591 2.131a.502.502 0 0 1-.317.895z",
    fill: "#fff"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "m220.194 191.302-18.216 10.517c-.301.175-.561 0-.586-.376v-.101a1.121 1.121 0 0 1 .485-.995l18.217-10.517c.292-.167.551 0 .577.377v.1a1.144 1.144 0 0 1-.477.995zM220.453 195.122l-18.216 10.534c-.293.167-.552 0-.585-.376v-.109a1.138 1.138 0 0 1 .485-.986l18.216-10.517c.293-.176.552 0 .577.376v.1a1.15 1.15 0 0 1-.477.978zM220.704 198.968l-18.216 10.517c-.293.167-.552 0-.577-.376V209a1.16 1.16 0 0 1 .485-.995l18.216-10.517c.293-.167.552 0 .585.376v.101a1.145 1.145 0 0 1-.493 1.003zM221.49 210.296l-18.217 10.517c-.301.167-.56 0-.585-.377v-.1a1.138 1.138 0 0 1 .493-.995l18.217-10.517c.292-.175.552 0 .577.377v.1a1.163 1.163 0 0 1-.485.995zM221.749 214.108l-18.217 10.517c-.292.175-.56 0-.585-.376v-.101a1.143 1.143 0 0 1 .485-.995l18.217-10.516c.292-.168.551 0 .576.376v.1a1.146 1.146 0 0 1-.476.995zM222.008 217.92l-18.216 10.525c-.293.168-.552 0-.577-.376v-.109a1.132 1.132 0 0 1 .485-.986l18.216-10.525c.293-.167.552 0 .577.384v.101a1.144 1.144 0 0 1-.485.986z",
    fill: "#E0E0E0"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M232.349 187.49c.193 2.775-1.178 5.902-3.051 6.989-1.873 1.086-3.553-.293-3.745-3.068-.193-2.776 1.178-5.911 3.059-6.998 1.881-1.087 3.545.293 3.737 3.077z",
    fill: "url(#bU)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M228.688 192.28a.52.52 0 0 1-.318-.117l-1.321-1.087a.513.513 0 0 1-.205-.558.507.507 0 0 1 .464-.373.51.51 0 0 1 .385.145l.761.627 1.672-4.656a.496.496 0 0 1 .257-.288.496.496 0 0 1 .556.079.492.492 0 0 1 .167.348.496.496 0 0 1-.027.195l-1.865 5.342a.531.531 0 0 1-.342.326l-.184.017z",
    fill: "#fff"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M233.645 206.492c.193 2.775-1.179 5.91-3.051 6.997-1.873 1.087-3.553-.292-3.745-3.076-.193-2.784 1.178-5.911 3.059-6.989 1.881-1.079 3.545.276 3.737 3.068z",
    fill: "#455A64"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M229.189 211.374a.518.518 0 0 1-.468-.719l2.124-4.849a.51.51 0 0 1 .927.41l-2.115 4.849a.51.51 0 0 1-.468.309z",
    fill: "#fff"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M231.572 210.012a.537.537 0 0 1-.326-.117l-2.592-2.132a.512.512 0 0 1-.186-.34.505.505 0 0 1 .111-.371.517.517 0 0 1 .719-.075l2.592 2.132a.52.52 0 0 1 .075.719.543.543 0 0 1-.393.184z",
    fill: "#fff"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "m254.445 171.53-18.216 10.517c-.293.168-.552 0-.577-.376v-.1a1.142 1.142 0 0 1 .485-.995l18.216-10.517c.293-.175.552 0 .577.376v.109a1.165 1.165 0 0 1-.485.986zM254.704 175.343l-18.216 10.517c-.293.175-.552 0-.577-.377v-.1a1.15 1.15 0 0 1 .485-.995l18.208-10.5c.292-.167.56 0 .585.376v.101a1.125 1.125 0 0 1-.485.978zM254.98 179.155l-18.216 10.525c-.293.167-.552 0-.577-.376v-.109a1.138 1.138 0 0 1 .485-.986l18.216-10.526c.301-.167.56 0 .585.377v.108a1.124 1.124 0 0 1-.493.987zM255.741 190.516l-18.217 10.517c-.292.175-.552 0-.585-.376v-.101a1.168 1.168 0 0 1 .485-.994l18.216-10.517c.293-.168.552 0 .577.376v.1a1.146 1.146 0 0 1-.476.995zM256 194.337l-18.217 10.483c-.292.167-.552 0-.577-.376v-.109a1.14 1.14 0 0 1 .485-.986l18.208-10.484c.293-.175.552 0 .586.376v.101a1.163 1.163 0 0 1-.485.995zM256.259 198.132l-18.217 10.534c-.292.167-.551 0-.576-.377v-.125a1.148 1.148 0 0 1 .485-.995l18.216-10.517c.301-.167.56 0 .585.376v.101a1.114 1.114 0 0 1-.493 1.003z",
    fill: "#E0E0E0"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M240.225 233.436a.133.133 0 0 1 0-.1.199.199 0 0 1 .066-.075l1.363-.786a.085.085 0 0 1 .038-.009c.013 0 .026.003.037.009a.108.108 0 0 1 0 .075v.326a.25.25 0 0 1 0 .109.193.193 0 0 1-.067.075l-1.019.585v.619c.057-.063.122-.119.192-.167l.159-.101c.117-.073.248-.124.384-.15a.545.545 0 0 1 .31 0 .488.488 0 0 1 .225.226.93.93 0 0 1 .101.418c.025.183.025.368 0 .551a1.823 1.823 0 0 1-.469.836 2.189 2.189 0 0 1-.367.276c-.132.087-.28.147-.435.176a.525.525 0 0 1-.309 0 .397.397 0 0 1-.201-.184.911.911 0 0 1-.092-.309.133.133 0 0 1 0-.109.193.193 0 0 1 .067-.075l.292-.168a.073.073 0 0 1 .095.025c.007.01.012.022.014.034a.342.342 0 0 0 .084.134c.033.026.074.04.117.042a.23.23 0 0 0 .142 0l.159-.076a.84.84 0 0 0 .326-.342.84.84 0 0 0 .1-.469.28.28 0 0 0-.036-.155.28.28 0 0 0-.114-.112.346.346 0 0 0-.343.042.839.839 0 0 0-.276.234.62.62 0 0 0-.067.092l-.084.067-.334.192a.05.05 0 0 1-.033.013.051.051 0 0 1-.034-.013l-.042-.067.051-1.689zM244.304 232.216a1.23 1.23 0 0 1 0 .192v.635c.017.178.017.357 0 .535a1.602 1.602 0 0 1-.133.494 1.676 1.676 0 0 1-.719.794 1.05 1.05 0 0 1-.46.159.426.426 0 0 1-.309-.092.682.682 0 0 1-.201-.301 2.28 2.28 0 0 1-.092-.468c0-.109 0-.243-.042-.393-.042-.151 0-.285 0-.41a3.077 3.077 0 0 1 0-.543 1.74 1.74 0 0 1 .41-.945c.129-.141.278-.262.443-.36.14-.086.297-.14.46-.158a.426.426 0 0 1 .309.092.68.68 0 0 1 .201.301c.06.15.105.307.133.468zm-1.404 1.672a.77.77 0 0 0 .159.443c.083.083.209.083.376 0a.762.762 0 0 0 .351-.393c.065-.188.094-.387.084-.585v-.786a.842.842 0 0 0-.159-.443c-.084-.084-.209-.084-.376 0a.823.823 0 0 0-.351.393 1.53 1.53 0 0 0-.084.585v.401c0 .142-.008.243 0 .36v.025zM245.358 230.377a.416.416 0 0 0-.235.083.85.85 0 0 0-.234.184 1.07 1.07 0 0 0-.15.226.959.959 0 0 0-.092.242 1.233 1.233 0 0 0 0 .243v.51a.541.541 0 0 0 .058.192.276.276 0 0 0 .109.125.294.294 0 0 0 .176 0 .504.504 0 0 0 .234-.083.85.85 0 0 0 .234-.184.832.832 0 0 0 .15-.226.835.835 0 0 0 .092-.242 1.144 1.144 0 0 0 0-.234v-.519a.503.503 0 0 0-.058-.192.385.385 0 0 0-.109-.125.29.29 0 0 0-.175 0z",
    fill: "#455A64"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M238.051 233.587a14.612 14.612 0 0 1 1.672-4.398c.142-.242.293-.476.443-.71a10.488 10.488 0 0 1 2.951-3.018l-.209-3.01a14.204 14.204 0 0 0-4.28 4.389c-.159.234-.301.468-.443.711a20.066 20.066 0 0 0-2.408 6.395c-.05.268-.092.544-.125.836a15.132 15.132 0 0 0-.126 3.169c.054.947.231 1.882.527 2.784.075.217.151.418.234.618a5.63 5.63 0 0 0 3.06 3.227c.163.069.331.127.502.176a6.143 6.143 0 0 0 4.531-.711l-.201-3.009a4.421 4.421 0 0 1-3.118.484 2.766 2.766 0 0 1-.51-.167 4.128 4.128 0 0 1-2.124-2.257 6.457 6.457 0 0 1-.225-.61 8.18 8.18 0 0 1-.36-1.923 10.452 10.452 0 0 1 .084-2.165c.033-.268.075-.544.125-.811z",
    fill: "#F0F0F0"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M252.271 224.943c-.075-.209-.15-.418-.226-.611a6.052 6.052 0 0 0-3.268-3.461 3.886 3.886 0 0 0-.502-.167 6.516 6.516 0 0 0-4.849.761l.042.643.209 3.018.05.678a4.043 4.043 0 0 1 2.792-.443c.174.043.345.098.51.167a3.759 3.759 0 0 1 1.881 2.006c.087.199.162.403.226.61.176.56.285 1.138.326 1.723.037.65.012 1.302-.075 1.947 0 .276-.075.544-.125.836a13.333 13.333 0 0 1-1.48 3.946c-.142.243-.293.477-.443.711a9.505 9.505 0 0 1-2.65 2.7l.05.677.2 3.018.051.652a15.22 15.22 0 0 0 4.573-4.681c.158-.234.3-.477.443-.719a20.9 20.9 0 0 0 2.566-6.822c.05-.276.092-.543.134-.836.158-1.107.203-2.228.134-3.344a11.953 11.953 0 0 0-.569-3.009z",
    fill: "url(#bV)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.271 224.943c-.075-.209-.15-.418-.226-.611a6.052 6.052 0 0 0-3.268-3.461 3.886 3.886 0 0 0-.502-.167 6.516 6.516 0 0 0-4.849.761l.042.643.209 3.018.05.678a4.043 4.043 0 0 1 2.792-.443c.174.043.345.098.51.167a3.759 3.759 0 0 1 1.881 2.006c.087.199.162.403.226.61.176.56.285 1.138.326 1.723.037.65.012 1.302-.075 1.947 0 .276-.075.544-.125.836a13.333 13.333 0 0 1-1.48 3.946c-.142.243-.293.477-.443.711a9.505 9.505 0 0 1-2.65 2.7l.05.677.2 3.018.051.652a15.22 15.22 0 0 0 4.573-4.681c.158-.234.3-.477.443-.719a20.9 20.9 0 0 0 2.566-6.822c.05-.276.092-.543.134-.836.158-1.107.203-2.228.134-3.344a11.953 11.953 0 0 0-.569-3.009z",
    fill: "#fff",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M218.438 249.621a.063.063 0 0 1-.033.009.07.07 0 0 1-.034-.009.108.108 0 0 1 0-.075v-.56l-1.128.644a.078.078 0 0 1-.034.009.078.078 0 0 1-.033-.009.085.085 0 0 1 0-.076v-.326a.33.33 0 0 1 0-.133.527.527 0 0 1 .05-.134l.987-2.416a.354.354 0 0 1 .142-.201l.276-.159a.063.063 0 0 1 .033-.009c.012 0 .023.003.033.009a.085.085 0 0 1 0 .076l.134 1.855.31-.175a.05.05 0 0 1 .033-.013.05.05 0 0 1 .033.013l.042.067v.334a.143.143 0 0 1 0 .1.124.124 0 0 1-.025.045.143.143 0 0 1-.042.031l-.317.184.041.56a.246.246 0 0 1 0 .108.194.194 0 0 1-.066.076l-.402.175zm-.184-1.212-.058-.953-.552 1.354.61-.401zM221.373 245.784a1.23 1.23 0 0 1 0 .192v.636c.017.178.017.357 0 .535-.018.17-.063.337-.134.493a1.676 1.676 0 0 1-.719.794c-.14.087-.297.144-.46.167a.467.467 0 0 1-.317-.1.746.746 0 0 1-.193-.301 2.33 2.33 0 0 1-.092-.46c0-.117 0-.251-.041-.401-.042-.151 0-.284 0-.41a2.813 2.813 0 0 1 0-.535c.021-.175.066-.346.133-.51.07-.16.163-.31.276-.443.129-.141.279-.262.443-.359.139-.088.297-.142.46-.159a.426.426 0 0 1 .309.092c.093.08.163.184.201.301.061.151.106.308.134.468zm-1.405 1.672a.771.771 0 0 0 .159.443c.084.084.209.084.376 0a.724.724 0 0 0 .343-.384c.072-.19.103-.392.092-.594v-.786a.825.825 0 0 0-.159-.443c-.083-.084-.209-.084-.376 0a.843.843 0 0 0-.351.393 1.553 1.553 0 0 0-.084.585v.401c0 .143-.016.268 0 .385zM222.192 244.053a.504.504 0 0 1 .234-.083.294.294 0 0 1 .176 0 .394.394 0 0 1 .108.125c.032.06.052.125.059.193v.518c.007.078.007.156 0 .234a.835.835 0 0 1-.092.242.843.843 0 0 1-.151.226.822.822 0 0 1-.234.184.505.505 0 0 1-.234.084.307.307 0 0 1-.175 0 .272.272 0 0 1-.109-.126.517.517 0 0 1-.059-.192v-.51a1.397 1.397 0 0 1 0-.242.99.99 0 0 1 .092-.243 1.37 1.37 0 0 1 .151-.226.84.84 0 0 1 .234-.184zm1.463-.727a.26.26 0 0 1 .042-.1.201.201 0 0 1 .075-.067l.226-.125a.043.043 0 0 1 .029-.01c.01 0 .021.003.029.01a.072.072 0 0 1 0 .05l-1.58 4.063-.05.092a.21.21 0 0 1-.075.067l-.218.125a.11.11 0 0 1-.067 0 .077.077 0 0 1 0-.059l1.589-4.046zm-1.204 1.672V244.572a.288.288 0 0 0-.058-.134h-.151a.289.289 0 0 0-.142.142.477.477 0 0 0 0 .192v.084a.75.75 0 0 0 0 .134.653.653 0 0 0 0 .125v.084a.217.217 0 0 0 .058.125h.151a.3.3 0 0 0 .142-.15.439.439 0 0 0 0-.184v.008zm1.421-.209a.45.45 0 0 1 .234-.083.294.294 0 0 1 .176 0 .314.314 0 0 1 .109.125c.031.06.051.125.058.192.005.084.005.168 0 .251v.268c.007.077.007.156 0 .234-.02.083-.048.164-.084.242a1.079 1.079 0 0 1-.158.226c-.068.07-.144.132-.226.184a.694.694 0 0 1-.243.083.29.29 0 0 1-.175 0 .385.385 0 0 1-.109-.125.721.721 0 0 1-.058-.192v-.519a1.144 1.144 0 0 1 0-.234.922.922 0 0 1 .092-.242.81.81 0 0 1 .159-.226.694.694 0 0 1 .225-.192v.008zm.259.936a.278.278 0 0 0 0-.091v-.335a.218.218 0 0 0-.058-.134h-.151a.357.357 0 0 0-.142.151.708.708 0 0 0 0 .184v.092a.653.653 0 0 0 0 .125v.126a.461.461 0 0 1 0 .091c.009.046.03.089.059.126h.15a.299.299 0 0 0 .142-.151.444.444 0 0 0 0-.192v.008z",
    fill: "#455A64"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M224.533 251.695a10.33 10.33 0 0 1-2.943 3.009l-.293.184-.292.151a4.453 4.453 0 0 1-3.127.493 4.145 4.145 0 0 1-.501-.167 4.124 4.124 0 0 1-2.099-2.233 7.65 7.65 0 0 1-.585-2.524c-.046-.726-.02-1.454.075-2.174 0-.276.084-.543.134-.836a14.446 14.446 0 0 1 1.672-4.389 21.6 21.6 0 0 1 .443-.719 10.344 10.344 0 0 1 2.951-3.009l-.209-3.018a14.55 14.55 0 0 0-4.289 4.389c-.15.234-.292.476-.434.719a20.046 20.046 0 0 0-2.408 6.387c-.05.275-.092.543-.134.836a15.539 15.539 0 0 0-.117 3.168c.056.947.233 1.882.527 2.784.067.209.142.418.226.61a5.701 5.701 0 0 0 3.059 3.236c.164.066.331.122.502.167a6.108 6.108 0 0 0 4.539-.703c.101-.047.198-.1.293-.158.1-.059.201-.117.293-.184a14.315 14.315 0 0 0 4.288-4.381l-1.571-1.638z",
    fill: "#F0F0F0"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M229.123 238.971c-.076-.209-.151-.41-.234-.611a6.029 6.029 0 0 0-3.261-3.452l-.501-.176a6.545 6.545 0 0 0-4.849.761l.042.652.209 3.01v.685a4.076 4.076 0 0 1 2.8-.443c.175.039.346.095.51.167a3.743 3.743 0 0 1 1.881 1.998 7.115 7.115 0 0 1 .544 2.333c.04.65.017 1.302-.067 1.948 0 .275-.076.551-.134.836a13.018 13.018 0 0 1-1.471 3.945l.342.368 1.547 1.672.334.351a21.113 21.113 0 0 0 2.567-6.821c.05-.268.092-.544.125-.836a16.48 16.48 0 0 0 .134-3.344 11.99 11.99 0 0 0-.518-3.043z",
    fill: "url(#bW)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M195.549 259.453a.063.063 0 0 1 .037-.012c.014 0 .027.004.038.012v.401a.184.184 0 0 1 0 .109l-.05.108-.477 1.02a.844.844 0 0 1 .301-.067.48.48 0 0 1 .243.059.432.432 0 0 1 .158.2c.046.106.071.22.076.335.015.157.001.316-.042.468-.04.156-.102.305-.184.443a2.14 2.14 0 0 1-.686.677c-.138.08-.287.14-.443.176a.691.691 0 0 1-.326 0 .425.425 0 0 1-.209-.167.71.71 0 0 1-.1-.26.28.28 0 0 1 0-.108.202.202 0 0 1 .067-.075l.284-.168a.097.097 0 0 1 .067 0 .177.177 0 0 1 .05.059l.067.067a.133.133 0 0 0 .1 0 .306.306 0 0 0 .159 0 .92.92 0 0 0 .218-.101c.14-.076.261-.185.351-.317a.683.683 0 0 0 .117-.402c0-.142-.067-.217-.159-.225a.662.662 0 0 0-.36.117l-.301.175a.055.055 0 0 1-.037.014.06.06 0 0 1-.038-.014.095.095 0 0 1-.008-.037.1.1 0 0 1 .008-.038v-.326a.286.286 0 0 1 0-.109v-.108l.46-.978-.995.576a.057.057 0 0 1-.075 0 .073.073 0 0 1 0-.066v-.335a.211.211 0 0 1 0-.1.149.149 0 0 1 .067-.075l1.622-.928zM198.132 259.21a1.23 1.23 0 0 1 0 .192v.636c.017.178.017.357 0 .535a1.969 1.969 0 0 1-.134.493 1.6 1.6 0 0 1-.284.435 1.538 1.538 0 0 1-.435.359 1.034 1.034 0 0 1-.459.159.427.427 0 0 1-.31-.092.617.617 0 0 1-.2-.301 2.254 2.254 0 0 1-.092-.468c0-.109 0-.242-.042-.393-.042-.15 0-.284 0-.41a2.897 2.897 0 0 1 0-.543 1.783 1.783 0 0 1 .409-.945c.13-.141.279-.262.444-.359a.968.968 0 0 1 .459-.159.428.428 0 0 1 .31.092.619.619 0 0 1 .192.301c.068.149.116.306.142.468zm-1.404 1.672c.009.16.064.314.158.443.084.084.209.084.377 0a.707.707 0 0 0 .342-.393c.073-.186.104-.385.092-.585v-.786a.828.828 0 0 0-.159-.443c-.083-.083-.209-.083-.376 0a.762.762 0 0 0-.351.393 1.552 1.552 0 0 0-.083.585v.393c0 .142.008.251.025.343l-.025.05zM198.968 257.488a.422.422 0 0 1 .234-.084.31.31 0 0 1 .176 0 .41.41 0 0 1 .108.126.517.517 0 0 1 .059.192v.51c.008.081.008.162 0 .242a.99.99 0 0 1-.092.243 1.1 1.1 0 0 1-.151.226 1.045 1.045 0 0 1-.234.184.608.608 0 0 1-.234.083.29.29 0 0 1-.175 0 .385.385 0 0 1-.109-.125.522.522 0 0 1-.059-.193v-.518a1.306 1.306 0 0 1 0-.234.835.835 0 0 1 .092-.242.843.843 0 0 1 .151-.226.822.822 0 0 1 .234-.184zm1.455-.727a.558.558 0 0 1 .05-.101.21.21 0 0 1 .075-.067l.217-.125a.067.067 0 0 1 .067 0v.05l-1.58 4.055a.55.55 0 0 1-.05.1.21.21 0 0 1-.075.067l-.218.125a.063.063 0 0 1-.033.009.07.07 0 0 1-.034-.009.051.051 0 0 1-.006-.025c0-.008.002-.017.006-.025l1.581-4.054zm-1.196 1.672V258.006a.25.25 0 0 0-.058-.133h-.151a.349.349 0 0 0-.142.15.475.475 0 0 0 0 .184v.092a.653.653 0 0 0 0 .125.531.531 0 0 0 0 .126v.092a.217.217 0 0 0 .058.125h.151a.354.354 0 0 0 .142-.15.444.444 0 0 0 .008-.226l-.008.042zm1.421-.218a.614.614 0 0 1 .234-.083.374.374 0 0 1 .176 0c.05.027.089.071.109.125.031.06.051.125.058.192v.51c.008.081.008.162 0 .243a1.183 1.183 0 0 1-.242.468c-.071.07-.15.131-.234.184a.618.618 0 0 1-.235.083.37.37 0 0 1-.175 0 .345.345 0 0 1-.109-.133.427.427 0 0 1-.058-.184v-.519a1.144 1.144 0 0 1 0-.234.835.835 0 0 1 .092-.242c.042-.083.092-.161.15-.234.067-.081.142-.154.226-.217l.008.041zm.259.945V258.734a.246.246 0 0 0-.058-.134h-.151a.354.354 0 0 0-.142.15.475.475 0 0 0 0 .184v.092a.663.663 0 0 0 0 .126.653.653 0 0 0 0 .125v.084a.244.244 0 0 0 .059.133h.15a.296.296 0 0 0 .142-.15.44.44 0 0 0 .009-.184h-.009z",
    fill: "#455A64"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M203.432 259.996a14.446 14.446 0 0 1-2.115 5.1 10.4 10.4 0 0 1-2.951 3.018l-.293.183-.292.151a4.43 4.43 0 0 1-3.118.493 3.248 3.248 0 0 1-.502-.167 4.12 4.12 0 0 1-2.098-2.232 4.287 4.287 0 0 1-.234-.61 8.115 8.115 0 0 1-.36-1.915 11.12 11.12 0 0 1 .084-2.173c0-.276.075-.544.133-.836.309-1.546.874-3.03 1.672-4.389.143-.251.285-.485.443-.719a10.32 10.32 0 0 1 2.943-3.01l-.2-3.018a14.344 14.344 0 0 0-4.289 4.389 19.779 19.779 0 0 0-2.843 7.106c-.05.268-.1.543-.133.836a15.462 15.462 0 0 0-.126 3.16c.053.951.233 1.89.535 2.792.067.209.142.418.226.611a5.723 5.723 0 0 0 3.06 3.235c.162.069.33.125.501.167a6.163 6.163 0 0 0 4.54-.702c.095-.058.192-.111.293-.159l.292-.184a14.367 14.367 0 0 0 4.289-4.389 20.143 20.143 0 0 0 2.842-7.097l-2.299.359z",
    fill: "#F0F0F0"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M205.923 252.363a6.457 6.457 0 0 0-.225-.61 6.042 6.042 0 0 0-3.269-3.453 4.45 4.45 0 0 0-.502-.175 6.552 6.552 0 0 0-4.848.761l.05.652.2 3.009.051.686a3.97 3.97 0 0 1 2.8-.443c.172.039.34.095.502.167a3.687 3.687 0 0 1 1.881 2.023c.091.198.17.402.234.61.172.56.279 1.138.318 1.722.036.65.013 1.302-.067 1.948l.518-.075 2.291-.359.501-.084c.159-1.107.203-2.228.134-3.344a11.974 11.974 0 0 0-.569-3.035z",
    fill: "url(#bX)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.923 252.363a6.457 6.457 0 0 0-.225-.61 6.042 6.042 0 0 0-3.269-3.453 4.45 4.45 0 0 0-.502-.175 6.552 6.552 0 0 0-4.848.761l.05.652.2 3.009.051.686a3.97 3.97 0 0 1 2.8-.443c.172.039.34.095.502.167a3.687 3.687 0 0 1 1.881 2.023c.091.198.17.402.234.61.172.56.279 1.138.318 1.722.036.65.013 1.302-.067 1.948l.518-.075 2.291-.359.501-.084c.159-1.107.203-2.228.134-3.344a11.974 11.974 0 0 0-.569-3.035z",
    fill: "#fff",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M172.408 274.292a.963.963 0 0 0 .117-.31.765.765 0 0 0 0-.234.358.358 0 0 0-.108-.267c-.067-.05-.168-.042-.31.041a.692.692 0 0 0-.284.293c-.06.126-.097.262-.109.401a.288.288 0 0 1 0 .117l-.058.067-.293.159a.067.067 0 0 1-.067 0v-.075a1.697 1.697 0 0 1 .226-.878c.075-.138.164-.267.268-.384.1-.114.219-.21.351-.285a.786.786 0 0 1 .401-.133.5.5 0 0 1 .293.083.685.685 0 0 1 .183.243c.043.106.068.219.076.334.008.075.008.151 0 .226a.891.891 0 0 1 0 .242c0 .084-.059.176-.101.284-.041.109-.108.226-.184.36l-.618 1.179 1.003-.586a.065.065 0 0 1 .038-.013c.013 0 .027.005.037.013a.08.08 0 0 1 .008.034.076.076 0 0 1-.008.033v.335a.211.211 0 0 1 0 .1.178.178 0 0 1-.067.084l-1.672.978a.12.12 0 0 1-.075 0 .11.11 0 0 1 0-.076v-.284a.287.287 0 0 1 0-.159c0-.05.042-.092.05-.117l.903-1.805zM175.426 272.319a1.23 1.23 0 0 1 0 .192v.635c.017.178.017.357 0 .535a2.024 2.024 0 0 1-.134.502 1.6 1.6 0 0 1-.284.435 1.69 1.69 0 0 1-.434.351c-.139.09-.296.147-.46.167a.448.448 0 0 1-.318-.092.76.76 0 0 1-.192-.309 2.194 2.194 0 0 1-.092-.46c0-.117 0-.251-.042-.401-.042-.151 0-.285 0-.402a3.785 3.785 0 0 1 0-.543 2.04 2.04 0 0 1 .142-.502 1.67 1.67 0 0 1 .719-.802c.137-.088.291-.145.452-.167a.428.428 0 0 1 .317.092c.091.085.16.191.201.309.058.148.1.302.125.46zm-1.404 1.672a.837.837 0 0 0 .159.451c.083.073.209.073.376 0a.78.78 0 0 0 .343-.393c.072-.189.103-.391.092-.593v-.778a.84.84 0 0 0-.159-.451c-.084-.073-.209-.073-.377 0a.834.834 0 0 0-.351.393 1.59 1.59 0 0 0-.083.593v.393c0 .142-.017.251 0 .36v.025zM176.246 270.563a.61.61 0 0 1 .234-.084.307.307 0 0 1 .175 0c.049.03.087.074.109.126a.461.461 0 0 1 .058.184v.518c.008.078.008.156 0 .234a.823.823 0 0 1-.092.243c-.04.081-.09.157-.15.225a.836.836 0 0 1-.234.184.64.64 0 0 1-.234.092.294.294 0 0 1-.176-.042.229.229 0 0 1-.108-.125.48.48 0 0 1-.059-.184v-.518a1.144 1.144 0 0 1 0-.234 1.183 1.183 0 0 1 .242-.477c.072-.057.151-.105.235-.142zm1.454-.727.05-.092a.218.218 0 0 1 .076-.075l.217-.126h.067c.017 0 0 0 0 .059l-1.58 4.054a.43.43 0 0 1-.05.092l-.076.075-.217.126a.11.11 0 0 1-.067 0v-.059l1.58-4.054zm-1.195 1.672v-.343a.471.471 0 0 1 0-.092.218.218 0 0 0-.059-.125h-.15a.296.296 0 0 0-.142.15.439.439 0 0 0 0 .184v.426a.278.278 0 0 0 .058.134h.151a.293.293 0 0 0 .142-.142.477.477 0 0 0 0-.192zm1.421-.218a.504.504 0 0 1 .234-.083.294.294 0 0 1 .176 0c.05.027.089.071.108.125a.443.443 0 0 1 .059.184v.518c.007.078.007.157 0 .234a.841.841 0 0 1-.092.243 1.1 1.1 0 0 1-.151.226.84.84 0 0 1-.234.184.504.504 0 0 1-.234.083.25.25 0 0 1-.175 0 .265.265 0 0 1-.109-.125.485.485 0 0 1-.059-.184v-.518a1.318 1.318 0 0 1 0-.235c.02-.087.051-.171.092-.25.045-.079.095-.155.151-.226a.842.842 0 0 1 .234-.176zm.259.937V271.8a.284.284 0 0 0-.117-.1h-.15a.338.338 0 0 0-.143.142.516.516 0 0 0 0 .192v.092a.663.663 0 0 0 0 .126.653.653 0 0 0 0 .125v.084a.29.29 0 0 0 .059.134h.15a.293.293 0 0 0 .086-.057.275.275 0 0 0 .057-.086.489.489 0 0 0 .058-.225z",
    fill: "#455A64"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "m182.766 265.94-2.173 2.224c.2.623.321 1.269.359 1.923.046.722.02 1.447-.075 2.165 0 .276-.084.552-.134.836a14.492 14.492 0 0 1-1.672 4.397c-.142.243-.293.477-.443.711a10.246 10.246 0 0 1-2.951 3.009l-.293.193a3.215 3.215 0 0 1-.292.15 4.431 4.431 0 0 1-3.119.493 3.198 3.198 0 0 1-.501-.175 4.107 4.107 0 0 1-2.099-2.224 6.77 6.77 0 0 1-.234-.61 8.179 8.179 0 0 1-.359-1.923 11.691 11.691 0 0 1 .084-2.165c0-.276.075-.552.133-.836a14.497 14.497 0 0 1 2.115-5.108 10.223 10.223 0 0 1 2.943-3.01l-.201-3.018a14.352 14.352 0 0 0-4.288 4.389 19.779 19.779 0 0 0-2.843 7.106c-.05.268-.092.544-.133.836a15.462 15.462 0 0 0-.126 3.16c.062.95.241 1.888.535 2.792.067.209.142.41.226.611a5.723 5.723 0 0 0 3.06 3.235c.164.065.331.12.501.167a6.193 6.193 0 0 0 4.54-.702l.292-.167c.101-.05.193-.117.293-.176a14.356 14.356 0 0 0 4.289-4.389c.15-.234.292-.468.434-.71a20.057 20.057 0 0 0 2.408-6.396c.05-.267.092-.543.134-.836.145-1.046.187-2.105.125-3.16a11.405 11.405 0 0 0-.535-2.792z",
    fill: "#F0F0F0"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M179.74 261.392a7.2 7.2 0 0 0-.502-.167 6.493 6.493 0 0 0-4.84.761v.652l.201 3.009.05.678a4.019 4.019 0 0 1 2.8-.435c.172.039.339.092.502.159a3.734 3.734 0 0 1 1.881 2.006l.493-.502 2.174-2.223.468-.477a6.077 6.077 0 0 0-3.227-3.461z",
    fill: "url(#bY)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M148.724 287.584a.116.116 0 0 1 0-.084.24.24 0 0 1 0-.1l.736-1.254.05-.092s.042-.05.067-.058l.284-.168a.052.052 0 0 1 .034-.012.05.05 0 0 1 .033.012c.013.009.023.02.031.033a.092.092 0 0 1 .011.043l.201 3.001a.184.184 0 0 1 0 .109.195.195 0 0 1-.059.075l-.301.167a.05.05 0 0 1-.033.013.053.053 0 0 1-.034-.013v-.067l-.159-2.299-.476.836a.18.18 0 0 1-.075.067.067.067 0 0 1-.067 0l-.243-.209zM152.461 285.578a2.223 2.223 0 0 0 0 .2v.435c.004.064.004.128 0 .192.017.181.017.363 0 .544a2.03 2.03 0 0 1-.142.493 1.597 1.597 0 0 1-.276.435 1.917 1.917 0 0 1-.443.359 1.034 1.034 0 0 1-.459.159.427.427 0 0 1-.31-.092.619.619 0 0 1-.192-.301 1.827 1.827 0 0 1-.1-.468V286.731a3.785 3.785 0 0 1 0-.543c.021-.174.069-.343.142-.502a1.67 1.67 0 0 1 .719-.802.975.975 0 0 1 .451-.159.415.415 0 0 1 .318.092c.09.081.156.185.192.301.046.15.079.304.1.46zm-1.412 1.672c.011.16.069.314.167.443.075.083.2.075.368 0a.843.843 0 0 0 .351-.393c.065-.191.096-.392.092-.594v-.777a.771.771 0 0 0-.159-.443c-.084-.084-.201-.076-.376 0a.72.72 0 0 0-.343.384 1.603 1.603 0 0 0-.092.594v.393c0 .142-.017.259-.008.376v.017zM153.272 283.822a.677.677 0 0 1 .234-.084.4.4 0 0 1 .176.042.285.285 0 0 1 .117.126.672.672 0 0 1 .05.192 1.17 1.17 0 0 1 0 .251v.259c.008.08.008.162 0 .242a1.044 1.044 0 0 1-.084.243 1.215 1.215 0 0 1-.158.225 1.205 1.205 0 0 1-.226.184.64.64 0 0 1-.243.084.265.265 0 0 1-.167 0 .305.305 0 0 1-.117-.134.598.598 0 0 1-.058-.184v-.518a1.144 1.144 0 0 1 0-.234 1.19 1.19 0 0 1 .092-.243.84.84 0 0 1 .158-.225.838.838 0 0 1 .226-.226zm1.463-.727.05-.092a.189.189 0 0 1 .076-.067l.217-.126a.11.11 0 0 1 .067 0c.004.01.007.02.007.03 0 .01-.003.02-.007.029l-1.589 4.055a.55.55 0 0 1-.05.1.3.3 0 0 1-.075.067l-.217.125a.07.07 0 0 1-.034.009.063.063 0 0 1-.033-.009.043.043 0 0 1-.007-.025c0-.009.002-.017.007-.025l1.588-4.071zm-1.195 1.672a.471.471 0 0 0 0-.092v-.335a.197.197 0 0 0-.059-.133h-.15a.343.343 0 0 0-.142.15.708.708 0 0 0 0 .184V284.884a.384.384 0 0 0 0 .083.22.22 0 0 0 .05.134h.15a.3.3 0 0 0 .142-.15.67.67 0 0 0 .009-.184zm1.413-.218a.65.65 0 0 1 .234-.083.299.299 0 0 1 .292.167.612.612 0 0 1 .05.192 1.17 1.17 0 0 1 0 .251v.259a.707.707 0 0 1 0 .234.961.961 0 0 1-.083.251 1.277 1.277 0 0 1-.159.226 1.336 1.336 0 0 1-.226.184.668.668 0 0 1-.234.083.37.37 0 0 1-.175 0 .293.293 0 0 1-.117-.134 1.084 1.084 0 0 1-.059-.183v-.519a1.144 1.144 0 0 1 0-.234 1.22 1.22 0 0 1 .092-.242c.042-.085.096-.164.159-.234a.838.838 0 0 1 .226-.218zm.267.945a.471.471 0 0 0 0-.092v-.251a.194.194 0 0 0 0-.083.18.18 0 0 0-.058-.134h-.151a.354.354 0 0 0-.142.15.63.63 0 0 0 0 .184V285.611a.393.393 0 0 0 0 .084.2.2 0 0 0 .058.133h.151a.326.326 0 0 0 .134-.15.495.495 0 0 0 .008-.184z",
    fill: "#455A64"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "m151.709 275.086.042.644.209 3.017v.678a4.065 4.065 0 0 1 2.8-.443l.276-.728 1.296-3.21.259-.702a6.493 6.493 0 0 0-4.882.744z",
    fill: "url(#bZ)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m151.709 275.086.042.644.209 3.017v.678a4.065 4.065 0 0 1 2.8-.443l.276-.728 1.296-3.21.259-.702a6.493 6.493 0 0 0-4.882.744z",
    fill: "#fff",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M160.077 279.04a7.401 7.401 0 0 0-.226-.61 5.726 5.726 0 0 0-3.059-3.236l-1.212 3.236a4.105 4.105 0 0 1 2.098 2.224c.083.192.159.401.234.61.193.622.31 1.264.351 1.914.046.726.021 1.453-.075 2.174 0 .276-.084.552-.134.836a14.349 14.349 0 0 1-1.672 4.389c-.142.251-.293.485-.443.719a10.342 10.342 0 0 1-2.951 2.976l-.284.192-.301.151a4.418 4.418 0 0 1-3.119.485 2.98 2.98 0 0 1-.501-.168 4.105 4.105 0 0 1-2.099-2.223c-.083-.193-.158-.402-.234-.611a8.21 8.21 0 0 1-.351-1.922c-.045-.723-.02-1.448.076-2.166 0-.276.083-.551.133-.836a14.43 14.43 0 0 1 1.672-4.397c.142-.242.293-.477.443-.711a10.4 10.4 0 0 1 2.951-3.018l-.209-3.009a14.352 14.352 0 0 0-4.288 4.389c-.151.234-.301.468-.443.71a19.891 19.891 0 0 0-2.4 6.396c-.05.267-.092.543-.133.836a16.136 16.136 0 0 0-.126 3.168c.061.947.24 1.882.535 2.784.067.218.142.418.226.619a5.684 5.684 0 0 0 3.06 3.227l.501.175a6.16 6.16 0 0 0 4.54-.71l.292-.159c.101-.05.193-.117.293-.176a14.457 14.457 0 0 0 4.289-4.389 19.745 19.745 0 0 0 2.842-7.106c.05-.267.092-.543.134-.836.145-1.046.187-2.105.125-3.16a11.397 11.397 0 0 0-.535-2.767z",
    fill: "#F0F0F0"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "m259.996 249.646-119.314 68.87c-.292.167-.56 0-.585-.376v-.101a1.121 1.121 0 0 1 .485-.994l119.322-68.887c.293-.175.552 0 .577.376v.101a1.16 1.16 0 0 1-.485 1.011zM260.263 253.458l-119.322 68.887c-.292.175-.552 0-.577-.376v-.109a1.163 1.163 0 0 1 .485-.995l119.323-68.886c.292-.167.551 0 .576.376v.117a1.148 1.148 0 0 1-.485.986z",
    fill: "#E0E0E0"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "m261.601 151.843-3.394-1.957-133.183 76.912a4.726 4.726 0 0 0-2.04 2.893 3.696 3.696 0 0 0-.075.418 2.748 2.748 0 0 0 0 .385v.192l.342 5.016 3.403 1.964 135.482-78.216-.535-7.607z",
    fill: "#37474F"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "m261.601 151.843-133.175 76.912a4.526 4.526 0 0 0-1.764 2.065l-3.394-1.965a4.382 4.382 0 0 0-.284.836 4.726 4.726 0 0 1 2.04-2.893l133.183-76.912 3.394 1.957z",
    fill: "#455A64"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "m126.295 232.6.342 5.016-3.402-1.964-.343-5.016v-.193a3.075 3.075 0 0 1 0-.384 4.452 4.452 0 0 1 .359-1.254l3.395 1.964a3.866 3.866 0 0 0-.351 1.831z",
    fill: "#263238"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M237.24 85.94a1.88 1.88 0 0 1-.284-1.889 5.918 5.918 0 0 1 3.845-3.753 1.858 1.858 0 0 1 1.881.334l23.526 22.28a2.578 2.578 0 0 1 .484 2.717 8.307 8.307 0 0 1-5.383 5.25 2.589 2.589 0 0 1-2.709-.552l-21.36-24.386z",
    fill: "url(#ca)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M240.768 80.298c1.672-.427 2.633.568 2.173 2.224a5.967 5.967 0 0 1-3.845 3.753c-1.672.418-2.634-.577-2.166-2.224a5.923 5.923 0 0 1 3.838-3.753z",
    fill: "url(#cb)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M240.768 80.298c1.672-.427 2.633.568 2.173 2.224a5.967 5.967 0 0 1-3.845 3.753c-1.672.418-2.634-.577-2.166-2.224a5.923 5.923 0 0 1 3.838-3.753z",
    fill: "#000",
    opacity: 0.25
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M230.644 76.076a3.599 3.599 0 0 1 2.324-2.274 1.128 1.128 0 0 1 1.137.21l7.524 7.674a1.152 1.152 0 0 1 .167 1.145 3.573 3.573 0 0 1-2.324 2.265 1.129 1.129 0 0 1-1.137-.2l-7.524-7.666a1.148 1.148 0 0 1-.167-1.154z",
    fill: "#37474F"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M232.968 73.802a2.348 2.348 0 0 0-.384.142h-.067a3.545 3.545 0 0 0-1.873 2.132 1.152 1.152 0 0 0 .167 1.145l1.798 1.84a12.35 12.35 0 0 0 1.805-1.463l6.63 6.47c.338-.352.59-.779.736-1.245a1.163 1.163 0 0 0-.168-1.146l-7.524-7.674a1.127 1.127 0 0 0-1.12-.2z",
    fill: "#455A64"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "m242.223 84.01 23.75 23.224c.314-.5.559-1.04.728-1.605a2.558 2.558 0 0 0-.494-2.717l-23.516-22.28a1.912 1.912 0 0 1 .284 1.89 5.105 5.105 0 0 1-.752 1.488z",
    fill: "url(#cc)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m242.223 84.01 23.75 23.224c.314-.5.559-1.04.728-1.605a2.558 2.558 0 0 0-.494-2.717l-23.516-22.28a1.912 1.912 0 0 1 .284 1.89 5.105 5.105 0 0 1-.752 1.488z",
    fill: "#fff"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M208.381 89.67c3.804 2.19 9.046 1.872 14.848-1.472 11.595-6.688 20.992-22.973 20.992-36.366 0-6.688-2.349-11.395-6.145-13.585l-4.264-2.508c-3.803-2.19-9.053-1.873-14.847 1.471-11.595 6.688-20.992 22.974-20.992 36.366 0 6.688 2.349 11.395 6.145 13.585l4.263 2.508zm32.972-37.838c0 5.986-2.048 12.824-5.768 19.228-3.72 6.404-8.611 11.704-13.794 14.647-4.682 2.708-8.937 3.227-11.972 1.471-3.034-1.755-4.715-5.693-4.715-11.102 0-5.977 2.048-12.816 5.769-19.228 3.72-6.412 8.61-11.629 13.794-14.622 4.681-2.7 8.928-3.227 11.971-1.471 3.043 1.756 4.715 5.676 4.715 11.077z",
    fill: "url(#cd)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M208.381 89.67c3.804 2.19 9.046 1.872 14.848-1.472 11.595-6.688 20.992-22.973 20.992-36.366 0-6.688-2.349-11.395-6.145-13.585l-4.264-2.508c-3.803-2.19-9.053-1.873-14.847 1.471-11.595 6.688-20.992 22.974-20.992 36.366 0 6.688 2.349 11.395 6.145 13.585l4.263 2.508zm32.972-37.838c0 5.986-2.048 12.824-5.768 19.228-3.72 6.404-8.611 11.704-13.794 14.647-4.682 2.708-8.937 3.227-11.972 1.471-3.034-1.755-4.715-5.693-4.715-11.102 0-5.977 2.048-12.816 5.769-19.228 3.72-6.412 8.61-11.629 13.794-14.622 4.681-2.7 8.928-3.227 11.971-1.471 3.043 1.756 4.715 5.676 4.715 11.077z",
    fill: "#fff"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M223.212 39.71c-11.595 6.688-20.992 22.973-20.992 36.366s9.397 18.81 20.992 12.122c11.595-6.688 21.009-22.99 21.009-36.366 0-13.376-9.397-18.81-21.009-12.122zm13.376 1.02c3.035 1.756 4.715 5.701 4.715 11.102 0 5.977-2.048 12.816-5.768 19.228-3.72 6.412-8.561 11.704-13.744 14.647-4.682 2.708-8.929 3.227-11.972 1.471-3.043-1.755-4.715-5.693-4.715-11.102 0-5.977 2.049-12.816 5.769-19.228 3.72-6.412 8.611-11.637 13.794-14.622 4.681-2.725 8.928-3.252 11.971-1.496h-.05z",
    fill: "url(#ce)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M223.212 39.71c-11.595 6.688-20.992 22.973-20.992 36.366s9.397 18.81 20.992 12.122c11.595-6.688 21.009-22.99 21.009-36.366 0-13.376-9.397-18.81-21.009-12.122zm13.376 1.02c3.035 1.756 4.715 5.701 4.715 11.102 0 5.977-2.048 12.816-5.768 19.228-3.72 6.412-8.561 11.704-13.744 14.647-4.682 2.708-8.929 3.227-11.972 1.471-3.043-1.755-4.715-5.693-4.715-11.102 0-5.977 2.049-12.816 5.769-19.228 3.72-6.412 8.611-11.637 13.794-14.622 4.681-2.725 8.928-3.252 11.971-1.496h-.05z",
    fill: "#fff"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M202.237 76.076c0-8.786 4.046-18.818 10.107-26.568l-.05.058-4.247-2.466c-6.044 7.742-10.074 17.74-10.074 26.51 0 6.688 2.349 11.394 6.153 13.585l4.255 2.508.226.125c-3.929-2.173-6.37-6.93-6.37-13.752z",
    fill: "url(#cf)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M236.638 40.73a7.91 7.91 0 0 0-4.08-1.02 16.117 16.117 0 0 1 1.789 8.084c0 5.978-2.04 12.816-5.76 19.228-3.72 6.412-8.619 11.629-13.794 14.613a16.317 16.317 0 0 1-7.9 2.508 8 8 0 0 0 2.926 3.018c3.035 1.756 7.29 1.238 11.98-1.471 5.166-2.926 10.074-8.16 13.786-14.63 3.711-6.47 5.768-13.284 5.768-19.228 0-5.409-1.672-9.346-4.715-11.102z",
    fill: "url(#cg)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M238.185 50.001c0 5.986-2.049 12.824-5.769 19.228-3.72 6.404-8.611 11.629-13.794 14.614-3.862 2.232-7.432 2.976-10.266 2.181-2.107-2.064-3.252-5.525-3.252-9.981 0-5.978 2.048-12.816 5.768-19.228 3.721-6.412 8.611-11.637 13.794-14.622 3.863-2.232 7.432-2.976 10.266-2.182 2.107 2.073 3.253 5.534 3.253 9.99z",
    fill: "#fff"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M238.77 38.682c.084.056.165.118.242.184l-.401-.285-.167-.117.209.134.117.084zM239.096 38.924c.064.04.123.088.175.142a1.987 1.987 0 0 0-.25-.192l.075.05zM240.191 39.877l-.376-.35c.082.067.16.14.234.216l.142.134z",
    fill: "#000"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M360.918 236.287a.421.421 0 0 0-.296.122.421.421 0 0 0-.122.296v32.546l-26.936 15.566a.426.426 0 0 0-.159.568.434.434 0 0 0 .156.154.438.438 0 0 0 .212.055.463.463 0 0 0 .209-.05l27.17-15.692a.392.392 0 0 0 .209-.359v-32.788a.429.429 0 0 0-.131-.305.44.44 0 0 0-.144-.089.437.437 0 0 0-.168-.024z",
    fill: "url(#ch)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M360.918 236.287a.421.421 0 0 0-.296.122.421.421 0 0 0-.122.296v32.546l-26.936 15.566a.426.426 0 0 0-.159.568.434.434 0 0 0 .156.154.438.438 0 0 0 .212.055.463.463 0 0 0 .209-.05l27.17-15.692a.392.392 0 0 0 .209-.359v-32.788a.429.429 0 0 0-.131-.305.44.44 0 0 0-.144-.089.437.437 0 0 0-.168-.024z",
    fill: "#fff"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M359.221 237.683a3.77 3.77 0 0 1 1.672-2.943c.936-.535 1.672-.1 1.672.987a3.735 3.735 0 0 1-1.672 2.934c-.912.544-1.672.109-1.672-.978z",
    fill: "url(#ci)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "m282.852 76.477-1.73-.995 77.505-44.75 1.731.994-77.506 44.751z",
    fill: "#F0F0F0"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M360.358 31.726v119.038l-77.539 44.768.033-119.055 77.506-44.75z",
    fill: "#E1EDF8"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M359.94 32.445V150.53l-76.712 44.308V76.736l76.678-44.266m.418-.719-77.472 44.726v119.055l77.539-44.768V31.768l-.067-.017z",
    fill: "#EBEBEB"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "m282.852 76.477-.033 119.055-1.681-.97-.016-119.08 1.697.97.033.025z",
    fill: "#E0E0E0"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M298.452 108.764h.1a.133.133 0 0 1 .042.108v.46c.004.053.004.106 0 .159 0 .05-.042.125-.067.226l-1.212 4.422a.704.704 0 0 1-.05.142.251.251 0 0 1-.1.109l-.435.251a.078.078 0 0 1-.05.019.074.074 0 0 1-.05-.019.116.116 0 0 1-.042-.109v-.092l1.22-4.431-1.672.945a.089.089 0 0 1-.05.015.089.089 0 0 1-.05-.015.15.15 0 0 1-.042-.117v-.485a.37.37 0 0 1 .042-.15.236.236 0 0 1 .1-.118l2.316-1.32zM301.854 108.63v1.237c-.01.281-.043.561-.1.836a2.795 2.795 0 0 1-.66 1.38c-.187.205-.404.38-.644.518a1.597 1.597 0 0 1-.652.226.545.545 0 0 1-.427-.151.897.897 0 0 1-.234-.46 2.843 2.843 0 0 1-.092-.694V110.319a4.43 4.43 0 0 1 .092-.836c.044-.258.123-.508.234-.744a2.6 2.6 0 0 1 1.079-1.179c.193-.127.414-.204.644-.226a.525.525 0 0 1 .426.151.831.831 0 0 1 .234.459c.058.225.092.454.1.686zm-2.106 2.416a1.17 1.17 0 0 0 .175.669c.109.125.276.117.527 0 .231-.127.414-.327.518-.569.109-.283.169-.583.176-.886v-1.162a1.23 1.23 0 0 0-.176-.677c-.108-.126-.276-.117-.518 0-.234.129-.42.332-.527.577-.108.28-.167.577-.175.877v.594c0 .217-.009.401 0 .577zM303.142 106.03a.728.728 0 0 1 .334-.117.44.44 0 0 1 .243.058c.064.05.114.116.142.193.036.09.055.186.058.284v.769a1.309 1.309 0 0 1-.058.351c-.035.127-.083.25-.142.368-.068.12-.149.233-.243.334a1.158 1.158 0 0 1-.334.26.835.835 0 0 1-.335.125.428.428 0 0 1-.234-.059.386.386 0 0 1-.15-.192 1.02 1.02 0 0 1-.059-.284v-.769c.007-.119.027-.237.059-.351.034-.129.084-.253.15-.368.068-.119.146-.231.234-.335.098-.105.211-.195.335-.267zm2.098-1.045a1.2 1.2 0 0 1 .075-.142.42.42 0 0 1 .109-.101l.318-.175a.104.104 0 0 1 .092 0 .115.115 0 0 1 0 .083.146.146 0 0 1 0 .051l-2.575 6.019a1.174 1.174 0 0 1-.075.134.287.287 0 0 1-.118.1l-.309.184a.104.104 0 0 1-.092 0 .1.1 0 0 1-.01-.042.1.1 0 0 1 .01-.042v-.05l2.575-6.019zm-1.822 2.458a.6.6 0 0 0 0-.134v-.376a.6.6 0 0 0 0-.134.27.27 0 0 0-.067-.192c0-.05-.109 0-.209 0a.495.495 0 0 0-.209.225.952.952 0 0 0-.067.276v.636a.377.377 0 0 0 .067.2c.042.042.108 0 .209 0a.472.472 0 0 0 .209-.217.669.669 0 0 0 .067-.284zm1.989-.276a.663.663 0 0 1 .335-.117.427.427 0 0 1 .234.058.44.44 0 0 1 .15.193c.033.091.052.187.059.284v.777a1.893 1.893 0 0 1-.059.351 1.515 1.515 0 0 1-.15.36c-.068.118-.146.23-.234.334a1.73 1.73 0 0 1-.335.268.85.85 0 0 1-.334.117.38.38 0 0 1-.243-.059.43.43 0 0 1-.142-.192 1.018 1.018 0 0 1-.058-.284v-.769a1.66 1.66 0 0 1 .058-.351 2 2 0 0 1 .142-.368c.068-.121.149-.233.243-.335a1.35 1.35 0 0 1 .334-.267zm.276 1.413v-.644a.367.367 0 0 0-.067-.192h-.209a.437.437 0 0 0-.209.217.771.771 0 0 0-.067.276.6.6 0 0 0 0 .134v.376a.523.523 0 0 0 0 .125.322.322 0 0 0 .067.201c0 .042.109 0 .209 0a.514.514 0 0 0 .209-.217c.035-.089.058-.182.067-.276z",
    fill: "#455A64"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M294.556 100.872a29.922 29.922 0 0 0-4.08 9.823 23.92 23.92 0 0 0-.543 4.932 16.008 16.008 0 0 0 .543 4.306l2.793-2.818a11.363 11.363 0 0 1-.41-3.177c.006-1.226.144-2.448.41-3.645a22.116 22.116 0 0 1 3.009-7.256 15.044 15.044 0 0 1 4.866-4.924v-3.904a20.318 20.318 0 0 0-6.588 6.663z",
    fill: "#E0E0E0"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M311.828 98.38c-.736-2.6-2.182-4.372-4.071-5.116-1.89-.744-4.13-.476-6.588.945v3.904a5.567 5.567 0 0 1 4.865-.694 5.362 5.362 0 0 1 3.01 3.779 11.75 11.75 0 0 1 .41 3.177 17.666 17.666 0 0 1-.41 3.645 22.096 22.096 0 0 1-3.01 7.256 15.129 15.129 0 0 1-4.865 4.924 5.57 5.57 0 0 1-4.866.694 5.366 5.366 0 0 1-3.009-3.779l-2.793 2.818c.745 2.608 2.182 4.372 4.08 5.116 1.898.744 4.122.476 6.588-.945a20.411 20.411 0 0 0 6.588-6.688 29.9 29.9 0 0 0 4.071-9.798c.358-1.62.543-3.273.552-4.932a15.649 15.649 0 0 0-.552-4.306z",
    fill: "url(#cj)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M298.335 149.443a3.065 3.065 0 0 1-1.012.995c-.197.116-.412.2-.635.251a.836.836 0 0 1-.451-.042.562.562 0 0 1-.276-.251 1.162 1.162 0 0 1-.109-.393.353.353 0 0 1 .142-.267l.41-.234h.092a.29.29 0 0 1 .067.092.55.55 0 0 0 .083.109.332.332 0 0 0 .142.05.447.447 0 0 0 .218 0c.111-.038.218-.088.317-.151.206-.112.381-.273.51-.468a.994.994 0 0 0 .201-.594c0-.209-.067-.317-.201-.334a.841.841 0 0 0-.51.159l-.434.251h-.101a.132.132 0 0 1-.041-.109v-.535a.482.482 0 0 1 .041-.167c.022-.052.047-.102.076-.151l.727-1.446-1.438.836h-.1a.13.13 0 0 1-.042-.109v-.493a.328.328 0 0 1 .042-.15.225.225 0 0 1 .1-.117l2.282-1.321h.101a.123.123 0 0 1 .013.054.123.123 0 0 1-.013.054v.502a.427.427 0 0 1 0 .167.89.89 0 0 0-.076.159l-.769 1.513c.134-.061.279-.095.427-.1.116.004.23.042.326.109a.575.575 0 0 1 .209.292c.054.162.079.331.075.502.001.241-.035.481-.109.71a2.608 2.608 0 0 1-.284.627zM300.023 148.733a.6.6 0 0 1-.426-.151.99.99 0 0 1-.234-.46 3.385 3.385 0 0 1-.092-.702v-1.204c.007-.28.038-.56.092-.836.046-.259.125-.512.234-.752.11-.237.254-.456.426-.652.186-.21.406-.385.652-.518.143-.087.298-.152.46-.193v1.012c-.108-.075-.251-.075-.46.05a1.103 1.103 0 0 0-.518.569 2.446 2.446 0 0 0-.184.886v1.17c-.009.237.055.47.184.669.1.125.268.117.518 0 .193-.112.352-.274.46-.468v.995c-.141.13-.295.244-.46.342a1.498 1.498 0 0 1-.652.243zM301.194 147.052c.108-.28.167-.577.175-.877V145.004a1.195 1.195 0 0 0-.175-.669h-.059v-1.011a.708.708 0 0 1 .184 0 .53.53 0 0 1 .427.15.963.963 0 0 1 .242.46c.051.228.082.46.092.694v1.237a6.16 6.16 0 0 1-.092.836 3.069 3.069 0 0 1-.242.736 2.515 2.515 0 0 1-.427.644c-.058.067-.125.117-.184.175v-1.12s.042 0 .059-.084zM303.945 141.911a.382.382 0 0 0-.243-.067.78.78 0 0 0-.326.117 1.383 1.383 0 0 0-.343.276c-.092.101-.17.213-.234.334a1.452 1.452 0 0 0-.142.36 1.995 1.995 0 0 0-.067.351v.778a.97.97 0 0 0 .067.275.376.376 0 0 0 .142.193c.068.049.152.07.234.058a.721.721 0 0 0 .343-.117c.123-.07.233-.161.326-.267.095-.098.177-.207.243-.326a1.73 1.73 0 0 0 .142-.368c.034-.114.054-.232.058-.351v-.769a.733.733 0 0 0-.058-.285.374.374 0 0 0-.142-.192zm-.293 1.329v.134a.756.756 0 0 1-.075.276.46.46 0 0 1-.201.217c-.109.059-.175.067-.209 0a.307.307 0 0 1-.075-.192.999.999 0 0 0 0-.134v-.376a.999.999 0 0 0 0-.134.761.761 0 0 1 .075-.276.437.437 0 0 1 .209-.217c.092-.059.167-.067.201 0a.32.32 0 0 1 .075.201v.501zM304.855 144.419v.777c.007.097.027.193.059.285a.483.483 0 0 0 .142.192.459.459 0 0 0 .243.059.899.899 0 0 0 .334-.126c.125-.07.238-.161.334-.267.093-.098.172-.208.234-.326a1.55 1.55 0 0 0 .151-.368c.03-.115.05-.233.058-.351v-.77a.921.921 0 0 0-.058-.284.392.392 0 0 0-.151-.192.347.347 0 0 0-.225-.092.706.706 0 0 0-.335.117 1.044 1.044 0 0 0-.334.268 1.59 1.59 0 0 0-.385.693 2.016 2.016 0 0 0-.067.385zm.494.1v-.184a.562.562 0 0 1 0-.142.782.782 0 0 1 .067-.276.463.463 0 0 1 .209-.217c.1-.058.167-.067.209 0a.37.37 0 0 1 .066.201v.635a.936.936 0 0 1-.066.276.492.492 0 0 1-.209.226c-.101.058-.176.067-.209 0a.308.308 0 0 1-.067-.193.494.494 0 0 1 0-.133v-.193zM302.883 146.935l2.583-6.01a.78.78 0 0 1 .075-.143.317.317 0 0 1 .109-.1l.318-.184a.132.132 0 0 1 .092 0 .12.12 0 0 1 .008.042.12.12 0 0 1-.008.042.075.075 0 0 1 0 .042.14.14 0 0 1 0 .05l-2.592 5.994a1.2 1.2 0 0 1-.075.142.276.276 0 0 1-.117.1l-.31.184h-.092c-.025 0 0 0 0-.075v-.042a.099.099 0 0 0 .009-.042z",
    fill: "#455A64"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "m301.144 134.178-.009.008v-3.904l.009-.008v3.904z",
    fill: "url(#ck)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M309.429 140.448a11.834 11.834 0 0 0-.41-3.177 5.33 5.33 0 0 0-3.009-3.77 5.534 5.534 0 0 0-4.866.685v-3.904c2.458-1.421 4.74-1.672 6.588-.944 1.847.727 3.344 2.508 4.071 5.116.383 1.402.569 2.851.552 4.305a23.322 23.322 0 0 1-.552 4.933l-2.784.401c.263-1.198.4-2.419.41-3.645z",
    fill: "url(#cl)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M301.144 156.265v3.904l-.009.009v-3.905l.009-.008z",
    fill: "url(#cm)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M294.556 136.937a30.005 30.005 0 0 0-4.08 9.823 24.06 24.06 0 0 0-.543 4.932 15.968 15.968 0 0 0 .543 4.306c.745 2.608 2.182 4.38 4.08 5.124 1.898.744 4.122.468 6.579-.944v-3.905a5.574 5.574 0 0 1-4.857.686 5.355 5.355 0 0 1-3.009-3.779 11.363 11.363 0 0 1-.41-3.177c.006-1.226.144-2.448.41-3.644a22.173 22.173 0 0 1 3.009-7.257 15.06 15.06 0 0 1 4.857-4.916v-3.904a20.438 20.438 0 0 0-6.579 6.655z",
    fill: "#E0E0E0"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M309.019 144.085a22.119 22.119 0 0 1-3.043 7.231 15.132 15.132 0 0 1-4.866 4.924v3.904a20.44 20.44 0 0 0 6.588-6.688 30.025 30.025 0 0 0 4.13-9.773l-2.809.402zM322.905 89.176a.342.342 0 0 1-.159 0 .331.331 0 0 1-.167-.276v-6.136a.315.315 0 0 1 .167-.276l5.258-3.043a.351.351 0 0 1 .318 0 .332.332 0 0 1 .167.284v6.07a.339.339 0 0 1-.167.284l-5.258 3.035a.346.346 0 0 1-.159.058zm.326-6.211v5.325l4.606-2.659v-5.325l-4.606 2.659z",
    fill: "#E0E0E0"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M328.782 78.225a.64.64 0 0 0-.698.135.642.642 0 0 0-.138.207l-2.408 5.735-.577-.56a.63.63 0 0 0-.696-.14.64.64 0 0 0-.346.83c.033.077.08.146.139.205l1.237 1.212a.661.661 0 0 0 .452.184h.125a.633.633 0 0 0 .46-.376l2.776-6.596a.633.633 0 0 0-.326-.837z",
    fill: "url(#cn)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "m332.636 79.286 19.32-11.177c.46-.268.836-.075.836.435a1.816 1.816 0 0 1-.836 1.396l-19.32 11.152c-.468.267-.836.075-.836-.426a1.795 1.795 0 0 1 .836-1.38zM322.905 98.288a.342.342 0 0 1-.159 0 .332.332 0 0 1-.167-.284v-6.07a.333.333 0 0 1 .167-.284l5.258-3.034a.31.31 0 0 1 .318 0 .333.333 0 0 1 .167.284v6.07a.307.307 0 0 1-.167.276l-5.258 3.043a.342.342 0 0 1-.159 0zm.326-6.21v5.324l4.606-2.658v-5.292l-4.606 2.625z",
    fill: "#E0E0E0"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M328.782 87.329a.632.632 0 0 0-.697.135.628.628 0 0 0-.139.207l-2.408 5.735-.577-.552a.622.622 0 0 0-.452-.18.633.633 0 0 0-.626.645c.002.169.071.33.192.447l1.238 1.212a.65.65 0 0 0 .451.175h.125a.633.633 0 0 0 .46-.376l2.776-6.604a.65.65 0 0 0 .003-.493.638.638 0 0 0-.346-.351z",
    fill: "url(#co)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "m332.636 88.365 19.32-11.169c.459-.276.836-.083.836.427a1.832 1.832 0 0 1-.836 1.404l-19.354 11.169c-.468.268-.836.075-.836-.426a1.8 1.8 0 0 1 .87-1.405zM322.905 107.401a.28.28 0 0 1-.159-.05.318.318 0 0 1-.167-.276v-6.078a.332.332 0 0 1 .167-.276l5.258-3.034a.31.31 0 0 1 .318 0 .314.314 0 0 1 .167.276v6.077a.336.336 0 0 1-.167.276l-5.258 3.035a.282.282 0 0 1-.159.05zm.326-6.212v5.326l4.606-2.667v-5.325l-4.606 2.666z",
    fill: "#E0E0E0"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M328.782 96.441a.64.64 0 0 0-.698.135.641.641 0 0 0-.138.208l-2.408 5.735-.577-.56a.64.64 0 0 0-.903 0 .64.64 0 0 0-.188.451.645.645 0 0 0 .188.451l1.238 1.204a.655.655 0 0 0 .451.184h.126a.625.625 0 0 0 .459-.376l2.776-6.596a.638.638 0 0 0-.326-.836z",
    fill: "url(#cp)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "m332.636 97.444 19.32-11.169c.459-.267.836-.075.836.427a1.82 1.82 0 0 1-.836 1.404l-19.354 11.169c-.468.267-.836.075-.836-.426a1.815 1.815 0 0 1 .87-1.404zM325.471 145.79l-3.126 1.806v-34.962l3.126-1.805v34.961zM330.989 142.605l-3.127 1.806v-34.962l3.127-1.806v34.962zM336.507 139.42l-3.127 1.805v-34.961l3.127-1.806v34.962zM342.024 136.235l-3.127 1.805v-34.961l3.127-1.806v34.962zM347.542 133.049l-3.127 1.798V99.894l3.127-1.806v34.961zM353.059 129.856l-3.126 1.806V96.7l3.126-1.797v34.953z",
    fill: "#E0E0E0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "m349.933 96.7 3.126-1.797v15.951l-3.126 1.805V96.7z",
    fill: "url(#cq)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "m322.345 120.267 3.126-1.806v19.521l-3.126 1.806v-19.521z",
    fill: "url(#cr)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m322.345 139.788 3.126-1.806v7.808l-3.126 1.806v-7.808z",
    fill: "#000"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "m327.862 121.521 3.127-1.806v7.023l-3.127 1.805v-7.022z",
    fill: "url(#cs)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m327.862 128.543 3.127-1.805v15.867l-3.127 1.806v-15.868z",
    fill: "#000"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "m333.38 109.19 3.127-1.806v6.128l-3.127 1.806v-6.128z",
    fill: "url(#ct)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m333.38 115.318 3.127-1.806v25.908l-3.127 1.805v-25.907z",
    fill: "#000"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "m338.897 110.711 3.127-1.805v15.449l-3.127 1.806v-15.45z",
    fill: "url(#cu)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m338.897 126.161 3.127-1.806v11.88l-3.127 1.805v-11.879z",
    fill: "#000"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "m344.415 113.796 3.127-1.805v6.537l-3.127 1.806v-6.538z",
    fill: "url(#cv)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m344.415 120.334 3.127-1.806v14.521l-3.127 1.798v-14.513zM349.933 112.659l3.126-1.805v19.002l-3.126 1.806v-19.003z",
    fill: "#000"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "m322.345 139.788 3.126-1.806v7.808l-3.126 1.806v-7.808z",
    fill: "url(#cw)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m322.345 139.788 3.126-1.806v7.808l-3.126 1.806v-7.808z",
    fill: "#000"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "m327.862 128.543 3.127-1.805v15.867l-3.127 1.806v-15.868z",
    fill: "url(#cx)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m327.862 128.543 3.127-1.805v15.867l-3.127 1.806v-15.868z",
    fill: "#000"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "m333.38 115.318 3.127-1.806v25.908l-3.127 1.805v-25.907z",
    fill: "url(#cy)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m333.38 115.318 3.127-1.806v25.908l-3.127 1.805v-25.907z",
    fill: "#000"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "m338.897 126.161 3.127-1.806v11.88l-3.127 1.805v-11.879z",
    fill: "url(#cz)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m338.897 126.161 3.127-1.806v11.88l-3.127 1.805v-11.879z",
    fill: "#000"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "m344.415 120.334 3.127-1.806v14.521l-3.127 1.798v-14.513z",
    fill: "url(#cA)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m344.415 120.334 3.127-1.806v14.521l-3.127 1.798v-14.513z",
    fill: "#000"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "m349.933 112.659 3.126-1.805v19.002l-3.126 1.806v-19.003z",
    fill: "url(#cB)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m349.933 112.659 3.126-1.805v19.002l-3.126 1.806v-19.003z",
    fill: "#000"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M288.495 85.33a.416.416 0 0 1-.399-.309.418.418 0 0 1 .19-.468l66.178-38.314a.418.418 0 0 1 .611.47.425.425 0 0 1-.193.258l-66.178 38.305a.393.393 0 0 1-.209.058zM288.495 89.193a.416.416 0 0 1-.399-.31.418.418 0 0 1 .19-.468l66.178-38.314a.426.426 0 0 1 .569.16.423.423 0 0 1-.151.568l-66.186 38.314a.477.477 0 0 1-.201.05zM288.495 93.064a.415.415 0 0 1-.359-.21.424.424 0 0 1 .15-.576l66.178-38.306a.418.418 0 0 1 .418.72l-66.186 38.313a.496.496 0 0 1-.201.059zM288.495 174.298a.416.416 0 0 1-.399-.31.418.418 0 0 1 .19-.468l66.178-38.314a.42.42 0 0 1 .418.728l-66.186 38.313a.468.468 0 0 1-.201.051zM288.495 178.168a.417.417 0 0 1-.402-.528.433.433 0 0 1 .193-.258l66.178-38.305a.415.415 0 0 1 .533.171.419.419 0 0 1-.115.548l-66.186 38.314a.506.506 0 0 1-.201.058zM288.495 182.031a.416.416 0 0 1-.399-.31.418.418 0 0 1 .19-.468l66.178-38.297a.416.416 0 0 1 .661.293.412.412 0 0 1-.243.426l-66.186 38.314a.398.398 0 0 1-.201.042z",
    fill: "#E0E0E0"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M360.357 150.764V99.083l-51.756 29.887-.017 51.681 51.773-29.887z",
    fill: "#000"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "m317.379 134.964-1.731-.995 77.506-44.751 1.731.995-77.506 44.751z",
    fill: "#F0F0F0"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M394.885 90.213V209.25l-77.539 44.768.033-119.055 77.506-44.751z",
    fill: "#E1EDF8"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M394.475 90.923V209l-76.72 44.308V135.206l76.687-44.308m.409-.71-77.505 44.751v119.055l77.539-44.768V90.213l-.034-.025z",
    fill: "#EBEBEB"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "m317.379 134.964-.033 119.055-1.681-.97-.017-119.08 1.698.97.033.025z",
    fill: "#E0E0E0"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "m328.364 216.984-3.47 1.998a.98.98 0 0 0-.393.761v.075c0 .292.176.426.393.301l3.47-1.998a.959.959 0 0 0 .393-.761v-.075c0-.293-.209-.427-.393-.301zM335.896 212.637l-3.469 1.998a.96.96 0 0 0-.393.76v.076c0 .292.176.426.393.301l3.469-1.998a.968.968 0 0 0 .393-.761v-.075c0-.293-.175-.427-.393-.301zM343.429 208.289l-3.47 1.998a.968.968 0 0 0-.401.761v.075c0 .293.184.427.401.301l3.47-2.006a.934.934 0 0 0 .393-.752v-.076c0-.292-.176-.426-.393-.301zM350.953 203.984l-3.47 1.998a.95.95 0 0 0-.393.761v.075c0 .293.176.426.393.301l3.47-2.006a.955.955 0 0 0 .401-.753v-.083c0-.293-.184-.46-.401-.293zM358.485 199.595l-3.47 1.998a.96.96 0 0 0-.392.752v.084c0 .293.175.426.392.301l3.47-2.006a.937.937 0 0 0 .393-.753v-.083c0-.293-.176-.427-.393-.293zM366.018 195.239l-3.47 2.007a.959.959 0 0 0-.401.752v.084c0 .292.184.426.401.301l3.47-2.007a.931.931 0 0 0 .393-.752v-.084c0-.292-.176-.426-.393-.301zM373.542 190.892l-3.462 2.007a.921.921 0 0 0-.401.752v.084c0 .292.176.426.401.301l3.462-2.007a.937.937 0 0 0 .401-.752v-.084c0-.292-.176-.426-.401-.301zM381.074 186.545l-3.47 2.006a.937.937 0 0 0-.393.753v.083c0 .285.176.427.393.293l3.47-1.998a.95.95 0 0 0 .393-.761v-.075c0-.293-.176-.418-.393-.301zM388.606 182.198l-3.469 2.006a.936.936 0 0 0-.393.753v.083c0 .284.175.418.393.293l3.469-1.998a.96.96 0 0 0 .393-.761v-.075c0-.251-.176-.427-.393-.301z",
    fill: "#455A64"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "m324.368 206.743 4.272-2.466v7.014l-4.272 2.457v-7.005z",
    fill: "url(#cC)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "m331.9 195.164 4.264-2.458v14.237l-4.264 2.458v-14.237z",
    fill: "url(#cD)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m331.9 195.164 4.264-2.458v14.237l-4.264 2.458v-14.237z",
    fill: "#fff"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "m339.424 181.813 4.272-2.466v23.249l-4.272 2.458v-23.241z",
    fill: "url(#cE)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m339.424 181.813 4.272-2.466v23.249l-4.272 2.458v-23.241z",
    fill: "#fff"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "m346.957 190.048 4.263-2.458v10.659l-4.263 2.466v-10.667z",
    fill: "url(#cF)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m346.957 190.048 4.263-2.458v10.659l-4.263 2.466v-10.667z",
    fill: "#fff"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "m354.48 183.335 4.264-2.458v13.025l-4.264 2.466v-13.033z",
    fill: "url(#cG)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m354.48 183.335 4.264-2.458v13.025l-4.264 2.466v-13.033z",
    fill: "#fff"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "m362.013 174.966 4.264-2.466v17.055l-4.264 2.466v-17.055z",
    fill: "url(#cH)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "m369.537 179.79 4.264-2.466v7.892l-4.264 2.458v-7.884z",
    fill: "url(#cI)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m369.537 179.79 4.264-2.466v7.892l-4.264 2.458v-7.884z",
    fill: "#fff"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "m377.061 172.927 4.272-2.458v10.4l-4.272 2.457v-10.399z",
    fill: "url(#cJ)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m377.061 172.927 4.272-2.458v10.4l-4.272 2.457v-10.399z",
    fill: "#fff"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "m384.593 166.916 4.264-2.466v12.071l-4.264 2.458v-12.063z",
    fill: "url(#cK)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M388.782 155.287c-4.715 9.982-10.944 12.891-14.848 12.356a13.197 13.197 0 0 1-3.411-1.011c-1.847-.753-3.344-1.346-6.378.426-1.973 1.137-3.604 3.235-5.192 5.267-2.048 2.633-3.979 5.116-6.345 4.89-1.672-.159-2.817-1.362-3.946-2.508-1.739-1.797-3.528-3.661-7.106-1.605-5.961 3.444-12.791 16.511-17.406 26.033l.443.443c4.532-9.363 11.228-22.196 16.963-25.506 3.302-1.906 4.932-.217 6.688 1.563 1.17 1.212 2.374 2.466 4.18 2.634 2.617.25 4.682-2.391 6.863-5.192 1.522-1.956 3.085-3.971 4.925-5.016 2.884-1.672 4.18-1.129 6.035-.384 1.111.497 2.284.843 3.487 1.028 4.088.56 10.608-2.508 15.558-12.958l-.51-.46z",
    fill: "url(#cL)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M388.782 155.287c-4.715 9.982-10.944 12.891-14.848 12.356a13.197 13.197 0 0 1-3.411-1.011c-1.847-.753-3.344-1.346-6.378.426-1.973 1.137-3.604 3.235-5.192 5.267-2.048 2.633-3.979 5.116-6.345 4.89-1.672-.159-2.817-1.362-3.946-2.508-1.739-1.797-3.528-3.661-7.106-1.605-5.961 3.444-12.791 16.511-17.406 26.033l.443.443c4.532-9.363 11.228-22.196 16.963-25.506 3.302-1.906 4.932-.217 6.688 1.563 1.17 1.212 2.374 2.466 4.18 2.634 2.617.25 4.682-2.391 6.863-5.192 1.522-1.956 3.085-3.971 4.925-5.016 2.884-1.672 4.18-1.129 6.035-.384 1.111.497 2.284.843 3.487 1.028 4.088.56 10.608-2.508 15.558-12.958l-.51-.46z",
    fill: "#fff"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M322.813 229.357a.421.421 0 0 1-.399-.31.418.418 0 0 1 .19-.468l66.186-38.314a.4.4 0 0 1 .154-.054.403.403 0 0 1 .308.081.427.427 0 0 1-.044.701l-66.186 38.305a.36.36 0 0 1-.209.059zM322.813 233.244a.421.421 0 0 1-.399-.309.418.418 0 0 1 .19-.468l66.186-38.314a.416.416 0 0 1 .569.158.408.408 0 0 1-.151.569l-66.186 38.314a.433.433 0 0 1-.209.05zM322.813 237.09a.425.425 0 0 1-.359-.209.426.426 0 0 1 .15-.577l66.186-38.306a.42.42 0 0 1 .662.293.423.423 0 0 1-.244.426l-66.186 38.314a.36.36 0 0 1-.209.059z",
    fill: "#E0E0E0"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M322.696 143.04a.42.42 0 0 1-.209-.778l33.958-19.604a.416.416 0 0 1 .581.467.416.416 0 0 1-.163.252l-33.925 19.579a.379.379 0 0 1-.242.084zM322.696 146.96a.412.412 0 0 1-.399-.309.418.418 0 0 1 .19-.468l50.937-29.411a.423.423 0 0 1 .317-.045.41.41 0 0 1 .252.196.428.428 0 0 1-.151.577l-50.937 29.41a.46.46 0 0 1-.209.05z",
    fill: "#455A64"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M322.696 154.802a.415.415 0 0 1-.399-.309.418.418 0 0 1 .19-.468l30.564-17.648a.417.417 0 0 1 .573.154.423.423 0 0 1-.155.573l-30.564 17.648a.473.473 0 0 1-.209.05zM322.696 158.723a.42.42 0 0 1-.209-.778l30.564-17.647a.424.424 0 0 1 .569.158.423.423 0 0 1 .045.316.401.401 0 0 1-.073.146.395.395 0 0 1-.123.107l-30.531 17.648a.472.472 0 0 1-.242.05zM322.696 162.644a.42.42 0 0 1-.209-.778l30.564-17.648a.427.427 0 0 1 .623.313.403.403 0 0 1-.082.308.395.395 0 0 1-.123.107l-30.564 17.648a.487.487 0 0 1-.209.05zM322.696 166.565a.42.42 0 0 1-.209-.778l30.564-17.648a.429.429 0 0 1 .569.159.417.417 0 0 1 .045.316.401.401 0 0 1-.073.146.395.395 0 0 1-.123.107l-30.564 17.647a.474.474 0 0 1-.209.051zM322.696 170.485a.412.412 0 0 1-.399-.309.418.418 0 0 1 .19-.468l30.564-17.648a.429.429 0 0 1 .569.159.418.418 0 0 1 .045.316.401.401 0 0 1-.196.252l-30.564 17.648a.46.46 0 0 1-.209.05zM322.696 174.406a.418.418 0 0 1-.209-.777l30.564-17.648a.424.424 0 0 1 .569.159.418.418 0 0 1 .045.316.41.41 0 0 1-.196.252l-30.564 17.648a.46.46 0 0 1-.209.05zM322.696 178.327a.415.415 0 0 1-.399-.309.418.418 0 0 1 .19-.468l30.564-17.648a.424.424 0 0 1 .569.159.418.418 0 0 1 .045.316.41.41 0 0 1-.196.252l-30.564 17.648a.473.473 0 0 1-.209.05zM358.142 134.37a.417.417 0 0 1-.402-.528.43.43 0 0 1 .193-.258l30.564-17.639a.414.414 0 0 1 .491-.001.426.426 0 0 1 .171.294.417.417 0 0 1-.244.426l-30.564 17.648a.375.375 0 0 1-.209.058zM358.142 138.291a.408.408 0 0 1-.207-.057.424.424 0 0 1-.002-.729l30.564-17.639a.414.414 0 0 1 .491-.001.426.426 0 0 1 .171.294.419.419 0 0 1-.244.426l-30.564 17.648a.375.375 0 0 1-.209.058zM358.142 142.212a.408.408 0 0 1-.207-.057.424.424 0 0 1-.002-.729l30.564-17.639a.414.414 0 0 1 .491-.001.426.426 0 0 1 .171.293.422.422 0 0 1-.244.427l-30.564 17.614a.369.369 0 0 1-.209.092zM358.142 146.133a.416.416 0 0 1-.399-.31.418.418 0 0 1 .19-.468l30.564-17.648a.428.428 0 0 1 .332-.071.42.42 0 0 1 .33.364.423.423 0 0 1-.244.426l-30.564 17.648a.376.376 0 0 1-.209.059zM358.142 150.054a.416.416 0 0 1-.399-.31.418.418 0 0 1 .19-.468l30.564-17.648a.428.428 0 0 1 .577.151.434.434 0 0 1-.159.577l-30.564 17.639a.376.376 0 0 1-.209.059zM358.142 153.974a.416.416 0 0 1-.209-.777l30.564-17.648a.42.42 0 0 1 .662.293.423.423 0 0 1-.244.426l-30.564 17.648a.367.367 0 0 1-.209.058zM358.142 157.895a.415.415 0 0 1-.399-.309.418.418 0 0 1 .19-.468l30.564-17.648a.425.425 0 0 1 .577.15.435.435 0 0 1-.159.577l-30.564 17.64a.375.375 0 0 1-.209.058z",
    fill: "#E0E0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 89.292,
    y1: 255.362,
    x2: 89.292,
    y2: 259.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 277.586,
    y1: 211.457,
    x2: 277.586,
    y2: 261.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 77.585,
    y1: 244.396,
    x2: 77.585,
    y2: 297.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 100.629,
    y1: 271.006,
    x2: 100.629,
    y2: 315.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 54.545,
    y1: 271.006,
    x2: 54.545,
    y2: 315.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 77.585,
    y1: 224.441,
    x2: 77.585,
    y2: 277.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 100.629,
    y1: 251.051,
    x2: 100.629,
    y2: 290.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 54.545,
    y1: 251.051,
    x2: 54.545,
    y2: 290.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 55.987,
    y1: 266.015,
    x2: 55.987,
    y2: 294.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 77.585,
    y1: 204.486,
    x2: 77.585,
    y2: 257.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 100.629,
    y1: 231.095,
    x2: 100.629,
    y2: 271.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 54.545,
    y1: 231.095,
    x2: 54.545,
    y2: 271.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 77.585,
    y1: 184.539,
    x2: 77.585,
    y2: 237.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 100.629,
    y1: 211.14,
    x2: 100.629,
    y2: 251.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 54.545,
    y1: 211.14,
    x2: 54.545,
    y2: 251.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 77.585,
    y1: 164.542,
    x2: 77.585,
    y2: 217.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 100.629,
    y1: 191.151,
    x2: 100.629,
    y2: 231.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 54.545,
    y1: 191.151,
    x2: 54.545,
    y2: 231.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 77.585,
    y1: 145.217,
    x2: 77.585,
    y2: 211.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 100.617,
    y1: 170.368,
    x2: 100.617,
    y2: 211.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 77.585,
    y1: 145.217,
    x2: 77.585,
    y2: 197.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 38.274,
    y1: 279.517,
    x2: 38.274,
    y2: 283.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 37.741,
    y1: 279.895,
    x2: 37.741,
    y2: 283.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 38.273,
    y1: 259.551,
    x2: 38.273,
    y2: 263.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 37.741,
    y1: 259.935,
    x2: 37.741,
    y2: 263.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 38.274,
    y1: 239.598,
    x2: 38.274,
    y2: 243.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 37.741,
    y1: 239.976,
    x2: 37.741,
    y2: 243.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 38.29,
    y1: 219.662,
    x2: 38.29,
    y2: 223.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 37.741,
    y1: 220.044,
    x2: 37.741,
    y2: 223.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 38.273,
    y1: 199.668,
    x2: 38.273,
    y2: 203.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 37.741,
    y1: 200.052,
    x2: 37.741,
    y2: 203.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 38.273,
    y1: 179.696,
    x2: 38.273,
    y2: 183.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 37.741,
    y1: 180.083,
    x2: 37.741,
    y2: 183.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 118.691,
    y1: 279.286,
    x2: 118.691,
    y2: 281.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 117.136,
    y1: 280.191,
    x2: 117.136,
    y2: 282.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 115.585,
    y1: 281.086,
    x2: 115.585,
    y2: 283.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 110.933,
    y1: 283.769,
    x2: 110.933,
    y2: 286.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 109.378,
    y1: 284.664,
    x2: 109.378,
    y2: 287.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 107.827,
    y1: 285.558,
    x2: 107.827,
    y2: 288.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 106.277,
    y1: 286.453,
    x2: 106.277,
    y2: 288.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 104.722,
    y1: 287.354,
    x2: 104.722,
    y2: 289.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 103.187,
    y1: 288.242,
    x2: 103.187,
    y2: 290.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 101.62,
    y1: 289.137,
    x2: 101.62,
    y2: 291.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 98.519,
    y1: 290.922,
    x2: 98.519,
    y2: 293.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 96.963,
    y1: 291.823,
    x2: 96.963,
    y2: 294.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 118.691,
    y1: 259.347,
    x2: 118.691,
    y2: 261.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 115.585,
    y1: 261.136,
    x2: 115.585,
    y2: 263.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 110.933,
    y1: 263.819,
    x2: 110.933,
    y2: 266.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 109.377,
    y1: 264.714,
    x2: 109.377,
    y2: 267.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 107.827,
    y1: 265.618,
    x2: 107.827,
    y2: 268.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 104.721,
    y1: 267.394,
    x2: 104.721,
    y2: 269.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 101.62,
    y1: 269.185,
    x2: 101.62,
    y2: 271.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 98.519,
    y1: 270.974,
    x2: 98.519,
    y2: 273.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 96.963,
    y1: 271.866,
    x2: 96.963,
    y2: 274.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 118.692,
    y1: 239.373,
    x2: 118.692,
    y2: 241.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 117.135,
    y1: 240.266,
    x2: 117.135,
    y2: 242.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 115.585,
    y1: 241.16,
    x2: 115.585,
    y2: 243.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 114.052,
    y1: 242.056,
    x2: 114.052,
    y2: 244.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 109.378,
    y1: 244.732,
    x2: 109.378,
    y2: 247.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 107.827,
    y1: 245.633,
    x2: 107.827,
    y2: 248.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 106.277,
    y1: 246.571,
    x2: 106.277,
    y2: 249.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 103.187,
    y1: 248.344,
    x2: 103.187,
    y2: 250.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 101.622,
    y1: 249.193,
    x2: 101.622,
    y2: 251.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 98.519,
    y1: 251.002,
    x2: 98.519,
    y2: 253.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 118.692,
    y1: 219.434,
    x2: 118.692,
    y2: 221.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 115.585,
    y1: 221.221,
    x2: 115.585,
    y2: 223.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 114.052,
    y1: 222.16,
    x2: 114.052,
    y2: 224.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 112.479,
    y1: 223.004,
    x2: 112.479,
    y2: 225.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 107.827,
    y1: 225.684,
    x2: 107.827,
    y2: 228.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 104.721,
    y1: 227.459,
    x2: 104.721,
    y2: 229.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 103.187,
    y1: 228.378,
    x2: 103.187,
    y2: 230.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 101.628,
    y1: 229.303,
    x2: 101.628,
    y2: 231.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 98.519,
    y1: 231.063,
    x2: 98.519,
    y2: 233.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 96.963,
    y1: 231.956,
    x2: 96.963,
    y2: 234.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 118.691,
    y1: 199.442,
    x2: 118.691,
    y2: 201.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 115.585,
    y1: 201.24,
    x2: 115.585,
    y2: 203.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 114.051,
    y1: 202.112,
    x2: 114.051,
    y2: 204.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 112.48,
    y1: 203.02,
    x2: 112.48,
    y2: 205.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 107.827,
    y1: 205.713,
    x2: 107.827,
    y2: 208.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 104.722,
    y1: 207.493,
    x2: 104.722,
    y2: 209.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 103.187,
    y1: 208.387,
    x2: 103.187,
    y2: 210.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 101.62,
    y1: 209.282,
    x2: 101.62,
    y2: 211.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 98.519,
    y1: 211.071,
    x2: 98.519,
    y2: 213.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 96.963,
    y1: 211.965,
    x2: 96.963,
    y2: 214.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 117.136,
    y1: 180.368,
    x2: 117.136,
    y2: 182.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 110.933,
    y1: 183.972,
    x2: 110.933,
    y2: 186.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 109.378,
    y1: 184.837,
    x2: 109.378,
    y2: 187.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 106.277,
    y1: 186.64,
    x2: 106.277,
    y2: 189.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 100.065,
    y1: 190.218,
    x2: 100.065,
    y2: 192.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 89.292,
    y1: 295.28,
    x2: 89.292,
    y2: 298.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 89.799,
    y1: 295.654,
    x2: 89.799,
    y2: 299.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 83.498,
    y1: 298.62,
    x2: 83.498,
    y2: 302.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 84.014,
    y1: 298.998,
    x2: 84.014,
    y2: 302.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 89.292,
    y1: 275.318,
    x2: 89.292,
    y2: 279.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 89.807,
    y1: 275.702,
    x2: 89.807,
    y2: 279.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 83.499,
    y1: 278.668,
    x2: 83.499,
    y2: 282.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 84.014,
    y1: 279.043,
    x2: 84.014,
    y2: 282.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 285.015,
    y1: 227.8,
    x2: 285.015,
    y2: 270.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 89.807,
    y1: 255.744,
    x2: 89.807,
    y2: 259.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 83.499,
    y1: 258.673,
    x2: 83.499,
    y2: 262.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 84.014,
    y1: 259.085,
    x2: 84.014,
    y2: 262.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 89.292,
    y1: 235.407,
    x2: 89.292,
    y2: 239.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 89.807,
    y1: 235.794,
    x2: 89.807,
    y2: 239.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 83.499,
    y1: 238.751,
    x2: 83.499,
    y2: 242.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 84.014,
    y1: 239.138,
    x2: 84.014,
    y2: 242.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 89.292,
    y1: 215.425,
    x2: 89.292,
    y2: 219.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 89.807,
    y1: 215.799,
    x2: 89.807,
    y2: 219.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 83.498,
    y1: 218.757,
    x2: 83.498,
    y2: 222.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 84.014,
    y1: 219.143,
    x2: 84.014,
    y2: 222.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 89.292,
    y1: 195.466,
    x2: 89.292,
    y2: 199.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 89.807,
    y1: 195.858,
    x2: 89.807,
    y2: 199.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 83.498,
    y1: 198.809,
    x2: 83.498,
    y2: 202.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 84.014,
    y1: 199.202,
    x2: 84.014,
    y2: 202.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 59.72,
    y1: 244.535,
    x2: 59.72,
    y2: 259.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 54.156,
    y1: 248.226,
    x2: 54.156,
    y2: 257.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 59.72,
    y1: 264.532,
    x2: 59.72,
    y2: 279.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 55.752,
    y1: 268.225,
    x2: 55.752,
    y2: 279.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 59.72,
    y1: 284.387,
    x2: 59.72,
    y2: 299.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 57.349,
    y1: 288.074,
    x2: 57.349,
    y2: 301.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 59.72,
    y1: 224.741,
    x2: 59.72,
    y2: 240.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 58.148,
    y1: 228.417,
    x2: 58.148,
    y2: 242.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 59.72,
    y1: 184.772,
    x2: 59.72,
    y2: 200.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 55.752,
    y1: 188.459,
    x2: 55.752,
    y2: 199.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 59.72,
    y1: 204.744,
    x2: 59.72,
    y2: 220.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 58.148,
    y1: 208.423,
    x2: 58.148,
    y2: 222.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 77.865,
    y1: 149.54,
    x2: 77.865,
    y2: 189.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 77.865,
    y1: 149.54,
    x2: 77.865,
    y2: 186.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 94.109,
    y1: 167.677,
    x2: 94.109,
    y2: 189.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 93.532,
    y1: 164.65,
    x2: 93.532,
    y2: 166.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 89.787,
    y1: 166.815,
    x2: 89.787,
    y2: 168.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 90.723,
    y1: 163.028,
    x2: 90.723,
    y2: 164.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 83.241,
    y1: 167.359,
    x2: 83.241,
    y2: 168.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 84.177,
    y1: 163.57,
    x2: 84.177,
    y2: 165.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 78.534,
    y1: 173.253,
    x2: 78.534,
    y2: 174.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 85.113,
    y1: 159.785,
    x2: 85.113,
    y2: 161.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 77.648,
    y1: 164.113,
    x2: 77.648,
    y2: 165.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 72.924,
    y1: 170.009,
    x2: 72.924,
    y2: 171.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 74.894,
    y1: 155.101,
    x2: 74.894,
    y2: 163.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 77.91,
    y1: 153.087,
    x2: 77.91,
    y2: 156.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 73.935,
    y1: 151.038,
    x2: 73.935,
    y2: 157.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 68.898,
    y1: 149.057,
    x2: 68.898,
    y2: 159.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 84.113,
    y1: 292.724,
    x2: 84.113,
    y2: 346.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 58.8,
    y1: 108.964,
    x2: 58.8,
    y2: 145.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 58.771,
    y1: 108.46,
    x2: 58.771,
    y2: 112.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 52.641,
    y1: 46.789,
    x2: 52.641,
    y2: 115.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 57.234,
    y1: 49.159,
    x2: 57.234,
    y2: 115.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 186.524,
    y1: 144.787,
    x2: 186.524,
    y2: 326.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 165.164,
    y1: 221.874,
    x2: 165.164,
    y2: 258.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 165.21,
    y1: 225.519,
    x2: 165.21,
    y2: 258.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 194.734,
    y1: 203.825,
    x2: 194.734,
    y2: 214.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 228.951,
    y1: 184.042,
    x2: 228.951,
    y2: 194.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 248.149,
    y1: 220.531,
    x2: 248.149,
    y2: 244.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 224.975,
    y1: 234.562,
    x2: 224.975,
    y2: 253.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 201.801,
    y1: 247.955,
    x2: 201.801,
    y2: 259.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 178.682,
    y1: 261.053,
    x2: 178.682,
    y2: 268.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 154.15,
    y1: 274.158,
    x2: 154.15,
    y2: 279.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 251.852,
    y1: 80.176,
    x2: 251.852,
    y2: 111.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 239.934,
    y1: 80.199,
    x2: 239.934,
    y2: 86.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 254.558,
    y1: 80.632,
    x2: 254.558,
    y2: 107.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 221.097,
    y1: 34.345,
    x2: 221.097,
    y2: 91.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 223.221,
    y1: 36.848,
    x2: 223.221,
    y2: 91.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 205.159,
    y1: 47.1,
    x2: 205.159,
    y2: 89.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 224.123,
    y1: 39.708,
    x2: 224.123,
    y2: 88.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 347.358,
    y1: 236.286,
    x2: 347.358,
    y2: 285.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 360.893,
    y1: 234.512,
    x2: 360.893,
    y2: 238.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 301.441,
    y1: 92.861,
    x2: 301.441,
    y2: 125.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 301.139,
    y1: 130.274,
    x2: 301.139,
    y2: 134.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 306.75,
    y1: 128.941,
    x2: 306.75,
    y2: 144.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 301.139,
    y1: 156.265,
    x2: 301.139,
    y2: 160.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 326.516,
    y1: 78.174,
    x2: 326.516,
    y2: 86.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 326.529,
    y1: 87.278,
    x2: 326.529,
    y2: 95.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 326.516,
    y1: 96.39,
    x2: 326.516,
    y2: 104.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 351.496,
    y1: 94.903,
    x2: 351.496,
    y2: 112.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 323.908,
    y1: 118.461,
    x2: 323.908,
    y2: 139.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 329.426,
    y1: 119.715,
    x2: 329.426,
    y2: 128.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 334.943,
    y1: 107.384,
    x2: 334.943,
    y2: 115.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 340.461,
    y1: 108.906,
    x2: 340.461,
    y2: 126.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 345.978,
    y1: 111.991,
    x2: 345.978,
    y2: 120.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 323.908,
    y1: 137.982,
    x2: 323.908,
    y2: 147.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 329.426,
    y1: 126.738,
    x2: 329.426,
    y2: 144.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 334.943,
    y1: 113.512,
    x2: 334.943,
    y2: 141.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 340.461,
    y1: 124.355,
    x2: 340.461,
    y2: 138.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cA",
    x1: 345.978,
    y1: 118.528,
    x2: 345.978,
    y2: 134.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cB",
    x1: 351.496,
    y1: 110.854,
    x2: 351.496,
    y2: 131.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cC",
    x1: 326.504,
    y1: 204.277,
    x2: 326.504,
    y2: 213.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: 334.032,
    y1: 192.706,
    x2: 334.032,
    y2: 209.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cE",
    x1: 341.56,
    y1: 179.347,
    x2: 341.56,
    y2: 205.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: 349.088,
    y1: 187.59,
    x2: 349.088,
    y2: 200.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cG",
    x1: 356.612,
    y1: 180.877,
    x2: 356.612,
    y2: 196.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 364.145,
    y1: 172.5,
    x2: 364.145,
    y2: 192.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cI",
    x1: 371.669,
    y1: 177.324,
    x2: 371.669,
    y2: 187.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cJ",
    x1: 379.197,
    y1: 170.469,
    x2: 379.197,
    y2: 183.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cK",
    x1: 386.725,
    y1: 164.45,
    x2: 386.725,
    y2: 178.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL",
    x1: 356.721,
    y1: 155.287,
    x2: 356.721,
    y2: 199.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustrationMin);
export default __webpack_public_path__ + "static/media/hero-illustration-min.7813e1c58220cc6d298f330d51b89297.svg";
export { ForwardRef as ReactComponent };